import * as i1$1 from '@angular/common';
import { isPlatformBrowser, DOCUMENT, DatePipe, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { PLATFORM_ID, Component, Inject, HostBinding, HostListener, TemplateRef, Type, Injectable, Directive, Input, Optional, isDevMode, EventEmitter, forwardRef, ViewChild, Output, Host, SkipSelf, Self, ElementRef, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1$2 from '@angular/router';
import { NavigationEnd, NavigationStart, RouterModule } from '@angular/router';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { Subject, merge, fromEvent, of } from 'rxjs';
import { filter, tap, debounceTime, map, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { trigger, transition, style, animate } from '@angular/animations';
import * as i1 from '@sumday/common';
import { KeyCodes, TypeaheadConfigDefaults, TextMasks, hasRequiredField, conformToMask, statesWithMilitaryAndTerritories, statesWithMilitary, statesWithTerritories, states, ExtendedValidators, countries, NotificationType, ToggleType, FileSizePipe, CanvasTextAlign, NumberUtils, CanvasGlobalComposition, CanvasService, ChartType, MomentPipe, DEFAULT_ACTIVITY_PARAMS, SumdayCommonModule } from '@sumday/common';
import * as i1$3 from '@angular/cdk/layout';
import { Breakpoint, Color } from '@sumday/assets';
import * as i1$4 from '@angular/forms';
import { NG_VALUE_ACCESSOR, Validators, UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import tabbable from 'tabbable';
import { HttpEventType } from '@angular/common/http';
import { mimeTypes } from 'mime-wrapper';
import * as dayjs from 'dayjs';
import dayjs__default from 'dayjs';
import merge$1 from 'ts-deepmerge';
import * as HighCharts from 'highcharts';
import { getOptions, dateFormat, setOptions, chart } from 'highcharts';
import utc from 'dayjs/plugin/utc';
import accessibilityModule from 'highcharts/modules/accessibility';
import exportModule from 'highcharts/modules/exporting';
import offlineExportModule from 'highcharts/modules/offline-exporting';
import fillPatternModule from 'highcharts/modules/pattern-fill';
import zxcvbn from 'zxcvbn';
import * as i4 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as extend from 'extend';
import { MatNativeDateModule } from '@angular/material/core';

class LoaderType {
    static { this.Wave = 'wave'; }
    static { this.Dots = 'dots'; }
    static { this.Spin = 'spin'; }
    static { this.Content = 'content'; }
}

var ModalType;
(function (ModalType) {
    ModalType["Standard"] = "standard";
    ModalType["Success"] = "success";
    ModalType["Warning"] = "warning";
})(ModalType || (ModalType = {}));

function PopupModalComponent_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "div");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("icon-", ctx_r1.content.icon, "");
} }
function PopupModalComponent_div_5_h1_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("autoFocus", false);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.content.headline, " ");
} }
function PopupModalComponent_div_5_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.content.desc, " ");
} }
function PopupModalComponent_div_5_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function PopupModalComponent_div_5_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.close()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.content.btnTextCancel, " ");
} }
function PopupModalComponent_div_5_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r5.content.legalText, i0.ɵɵsanitizeHtml);
} }
function PopupModalComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PopupModalComponent_div_5_div_1_Template, 2, 3, "div", 5);
    i0.ɵɵtemplate(2, PopupModalComponent_div_5_h1_2_Template, 2, 2, "h1", 6);
    i0.ɵɵtemplate(3, PopupModalComponent_div_5_p_3_Template, 2, 1, "p", 7);
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵtemplate(5, PopupModalComponent_div_5_button_5_Template, 2, 1, "button", 9);
    i0.ɵɵelementStart(6, "button", 10);
    i0.ɵɵlistener("click", function PopupModalComponent_div_5_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.close(true)); });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, PopupModalComponent_div_5_div_8_Template, 1, 1, "div", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("large-message ", ctx_r0.content.type, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.content.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.content.headline);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.content.desc);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.content.btnTextCancel);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("btn-success", ctx_r0.content.type === ctx_r0.ModalType.Success)("btn-warning", ctx_r0.content.type === ctx_r0.ModalType.Warning);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.content.btnText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.content.legalText);
} }
const _c0$w = ["*"];
const FOCUSABLE_ELEMENTS = [
    'a[href]',
    'area[href]',
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    'select:not([disabled]):not([aria-hidden])',
    'textarea:not([disabled]):not([aria-hidden])',
    'button:not([disabled]):not([aria-hidden])',
    'iframe',
    'object',
    'embed',
    '[contenteditable]',
    '[tabindex]:not([tabindex^="-"])'
];
const HEADER_ELEMENTS = [
    'h1',
    '.h1',
    'h2',
    '.h2',
    'h3',
    '.h3',
    'h4',
    '.h4',
    'h5',
    '.h5',
    'h6',
    '.h6',
];
class PopupModalComponent {
    onDocKeydown(event) {
        switch (event.keyCode) {
            case KeyCodes.TAB:
                this.findFocusableNodes();
                this.maintainFocus(event);
                break;
            case KeyCodes.ESC:
                event.preventDefault();
                this.close();
                break;
        }
    }
    onDocClick(event) {
        if (this.isSafari) {
            // Safari doesnt track document.activeElement for button clicks so we have to hold its hand
            if (!this.previouslyFocusedElement || this.previouslyFocusedElement === this.document.body) {
                this.previouslyFocusedElement = event.target;
            }
        }
    }
    onClick() {
        this.close();
    }
    constructor(platformId, document, element, window) {
        this.platformId = platformId;
        this.document = document;
        this.element = element;
        this.window = window;
        this.action = new Subject();
        this.isSafari = /^((?!chrome|android).)*safari/i.test(this.window.nativeWindow.navigator.userAgent);
        this.ModalType = ModalType;
        // Get the currently focused item to restore focus later
        if (!this.previouslyFocusedElement) {
            this.previouslyFocusedElement = this.document.activeElement;
        }
    }
    onAnimationDone(event) {
        if (event.toState === 'void') {
            this.onPopupClosed && this.onPopupClosed();
        }
    }
    ngAfterViewInit() {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.findFirstHeader();
        this.findFocusableNodes();
        this.setInitialFocus();
    }
    close(submit = false) {
        if (this.previouslyFocusedElement) {
            this.previouslyFocusedElement.focus();
        }
        this.action.next(submit);
        this.action.complete();
    }
    getActiveElement() {
        // <body> is sometimes returned from document.activeElement. We need to ignore it
        if (this.document.activeElement !== this.document.body) {
            this.activeElement = this.document.activeElement;
        }
        return this.activeElement;
    }
    findFocusableNodes() {
        this.focusableNodes = Array(...this.element.nativeElement.querySelectorAll(FOCUSABLE_ELEMENTS));
    }
    findFirstHeader() {
        this.firstHeader = this.element.nativeElement.querySelector(HEADER_ELEMENTS);
        this.firstHeader.id = 'modal-headline';
    }
    setInitialFocus() {
        // We want to focus on the first item that's not the close button, and not the cancel button
        let initialFocusable = this.focusableNodes
            .filter(n => !n.classList.contains('icon-close'))
            .filter(n => !n.classList.contains('btn-cancel'));
        // Force the first header element to be tabindex -1 if there's nothing else, so we can focus that instead
        if (initialFocusable.length === 0) {
            this.firstHeader.tabIndex = -1;
            initialFocusable.push(this.firstHeader);
        }
        // If we have a initialFocusable item, use it, otherwise use anything we have
        initialFocusable[0].focus();
    }
    maintainFocus(e) {
        if (!this.focusableNodes.includes(this.getActiveElement())) {
            this.setInitialFocus();
        }
        else if (e) {
            const lastFocusableIndex = this.focusableNodes.length - 1;
            const focusedItemIndex = this.focusableNodes.indexOf(this.getActiveElement());
            if (e.shiftKey && focusedItemIndex === 0) {
                this.focusableNodes[lastFocusableIndex].focus();
                event.preventDefault();
            }
            if (!e.shiftKey && focusedItemIndex === lastFocusableIndex) {
                this.focusableNodes[0].focus();
                event.preventDefault();
            }
        }
    }
    static { this.ɵfac = function PopupModalComponent_Factory(t) { return new (t || PopupModalComponent)(i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.WindowRefService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PopupModalComponent, selectors: [["sumday-popup-modal"]], hostVars: 1, hostBindings: function PopupModalComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("keydown", function PopupModalComponent_keydown_HostBindingHandler($event) { return ctx.onDocKeydown($event); }, false, i0.ɵɵresolveDocument)("click", function PopupModalComponent_click_HostBindingHandler($event) { return ctx.onDocClick($event); }, false, i0.ɵɵresolveDocument)("click", function PopupModalComponent_click_HostBindingHandler() { return ctx.onClick(); });
        } if (rf & 2) {
            i0.ɵɵsyntheticHostProperty("@fadeInOut", ctx.onDocKeydown);
        } }, ngContentSelectors: _c0$w, decls: 6, vars: 4, consts: [["aria-labelledby", "modal-headline", 1, "popup-modal", 3, "click"], [1, "modal-header"], ["type", "button", "aria-label", "Close modal", 1, "no-default-styles", "pull-right", "icon-close", 3, "click"], [1, "modal-body"], [3, "class", 4, "ngIf"], ["class", "icon", "role", "presentation", 4, "ngIf"], ["id", "modal-headline", "class", "headline", 3, "autoFocus", 4, "ngIf"], ["id", "modal-desc", 4, "ngIf"], [1, "button-container"], ["type", "button", "class", "btn-inverse btn-cancel", 3, "click", 4, "ngIf"], ["type", "button", 3, "click"], ["class", "legal", 3, "innerHtml", 4, "ngIf"], ["role", "presentation", 1, "icon"], ["id", "modal-headline", 1, "headline", 3, "autoFocus"], ["id", "modal-desc"], ["type", "button", 1, "btn-inverse", "btn-cancel", 3, "click"], [1, "legal", 3, "innerHtml"]], template: function PopupModalComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function PopupModalComponent_Template_div_click_0_listener($event) { return $event.stopPropagation(); })("@fadeInOut.done", function PopupModalComponent_Template_div_animation_fadeInOut_done_0_listener($event) { return ctx.onAnimationDone($event); });
            i0.ɵɵelementStart(1, "div", 1)(2, "button", 2);
            i0.ɵɵlistener("click", function PopupModalComponent_Template_button_click_2_listener() { return ctx.close(); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵprojection(4);
            i0.ɵɵtemplate(5, PopupModalComponent_div_5_Template, 9, 13, "div", 4);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("@fadeInOut", undefined);
            i0.ɵɵattribute("role", ctx.content && !ctx.content.btnTextCancel ? "alertdialog" : "dialog")("aria-describedby", (ctx.content == null ? null : ctx.content.desc) ? "modal-desc" : null);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.content);
        } }, dependencies: [i1$1.NgIf, i1.H1Directive], encapsulation: 2, data: { animation: [
                trigger('fadeInOut', [
                    transition(':enter', [
                        style({
                            transform: 'translateY(-10px)',
                            opacity: 0,
                        }),
                        animate('.3s ease-in-out', style({
                            transform: 'translateY(0)',
                            opacity: 1,
                        }))
                    ]),
                    transition(':leave', [
                        style({
                            transform: 'translateY(0)',
                            opacity: 1,
                        }),
                        animate('.3s ease-in-out', style({
                            transform: 'translateY(-10px)',
                            opacity: 0,
                        }))
                    ])
                ]),
            ] } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopupModalComponent, [{
        type: Component,
        args: [{ selector: 'sumday-popup-modal', animations: [
                    trigger('fadeInOut', [
                        transition(':enter', [
                            style({
                                transform: 'translateY(-10px)',
                                opacity: 0,
                            }),
                            animate('.3s ease-in-out', style({
                                transform: 'translateY(0)',
                                opacity: 1,
                            }))
                        ]),
                        transition(':leave', [
                            style({
                                transform: 'translateY(0)',
                                opacity: 1,
                            }),
                            animate('.3s ease-in-out', style({
                                transform: 'translateY(-10px)',
                                opacity: 0,
                            }))
                        ])
                    ]),
                ], template: "<div\n  class=\"popup-modal\"\n  [attr.role]=\"content && !content.btnTextCancel ? 'alertdialog' : 'dialog'\"\n  aria-labelledby=\"modal-headline\"\n  [attr.aria-describedby]=\"content?.desc ? 'modal-desc' : null\"\n  (click)=\"$event.stopPropagation()\"\n  [@fadeInOut]\n  (@fadeInOut.done)=\"onAnimationDone($event)\"\n>\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"no-default-styles pull-right icon-close\"\n      aria-label=\"Close modal\"\n      (click)=\"close()\"\n    ></button>\n  </div>\n  <div class=\"modal-body\">\n    <ng-content></ng-content>\n\n    <div *ngIf=\"content\" class=\"large-message {{ content.type }}\">\n      <div *ngIf=\"content.icon\" class=\"icon\" role=\"presentation\">\n        <div class=\"icon-{{content.icon}}\"></div>\n      </div>\n\n      <h1 *ngIf=\"content.headline\" [autoFocus]=\"false\" id=\"modal-headline\" class=\"headline\">\n        {{content.headline}}\n      </h1>\n\n      <p *ngIf=\"content.desc\" id=\"modal-desc\">\n        {{content.desc}}\n      </p>\n\n      <div class=\"button-container\">\n        <button\n          *ngIf=\"content.btnTextCancel\"\n          type=\"button\"\n          class=\"btn-inverse btn-cancel\"\n          (click)=\"close()\"\n        >\n          {{content.btnTextCancel}}\n        </button>\n\n        <button\n          type=\"button\"\n          [class.btn-success]=\"content.type === ModalType.Success\"\n          [class.btn-warning]=\"content.type === ModalType.Warning\"\n          (click)=\"close(true)\"\n        >\n          {{content.btnText}}\n        </button>\n      </div>\n\n      <div class=\"legal\" *ngIf=\"content.legalText\" [innerHtml]=\"content.legalText\"></div>\n    </div>\n  </div>\n</div>\n" }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: i0.ElementRef }, { type: i1.WindowRefService }]; }, { onDocKeydown: [{
            type: HostBinding,
            args: ['@fadeInOut']
        }, {
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }], onDocClick: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();

let modalId = 0;
// @dynamic @see: https://github.com/angular/angular/issues/20351
class ModalService {
    constructor(document, resolver, injector, applicationRef, router, rendererFactory) {
        this.document = document;
        this.resolver = resolver;
        this.injector = injector;
        this.applicationRef = applicationRef;
        this.router = router;
        this.rendererFactory = rendererFactory;
        this.componentRefs = new Map();
        // Need to do it this way because you can't directly inject Renderer2 into a service
        this.renderer = rendererFactory.createRenderer(null, null);
        this.modalElement = null;
        // Cancel all modals if you navigate to a different page
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(data => {
            if (this.action) {
                this.closeAll();
            }
        });
    }
    open(content, options) {
        const DEFAULT_MODAL_OPTIONS = {
            pinTo: null,
            resolver: this.resolver,
        };
        options = options
            ? Object.assign({}, DEFAULT_MODAL_OPTIONS, options)
            : DEFAULT_MODAL_OPTIONS;
        const id = modalId++;
        const factory = options.resolver.resolveComponentFactory(PopupModalComponent);
        const { ngContent = null, viewRef = null } = this.resolveNgContent(content, options.resolver) || {};
        this.componentRefs.set(id, factory.create(this.injector, ngContent || {}));
        let modalComponent = this.componentRefs.get(id);
        this.modalElement = modalComponent.location.nativeElement;
        modalComponent.instance.onPopupClosed = () => {
            if (viewRef) {
                viewRef.destroy();
            }
        };
        if (!ngContent) {
            modalComponent.instance.content = content;
        }
        this.applicationRef.attachView(modalComponent.hostView);
        this.rootComponent = this.applicationRef.components[0].location.nativeElement;
        this.rootComponent.parentNode.appendChild(this.modalElement);
        if (this.rootComponent) {
            this.lockPageScrolling(true, this.modalElement.querySelector('.modal-body'));
            // Sets aria attributes to hide page content
            this.rootComponent.setAttribute('aria-hidden', 'true');
        }
        if (options.pinTo) {
            let modalWindow = this.modalElement.querySelector('.popup-modal');
            let targetLocation = options.pinTo.getBoundingClientRect();
            let modalLocation = modalWindow.getBoundingClientRect();
            let windowLocation = this.modalElement.getBoundingClientRect();
            if (this.modalCanPin(targetLocation, modalLocation, windowLocation)) {
                // Pin the modal window to the corner of the button that opened it
                this.renderer.setStyle(modalWindow, 'position', 'absolute');
                this.renderer.setStyle(modalWindow, 'top', `${targetLocation.top}px`);
                this.renderer.setStyle(modalWindow, 'right', `${windowLocation.width - targetLocation.right}px`);
            }
        }
        // If an action is taken, destroy the modal and pass back a proxy observable
        modalComponent.instance.action
            .subscribe(action => {
            this.close(action, true);
        });
        this.action = new Subject();
        return this.action.asObservable();
    }
    close(action = false, fromModal = false, id = this.getLastModalId()) {
        if (!fromModal) {
            // We want to make sure the close event passes through the modal first, so we call it if it didn't
            this.componentRefs.get(id).instance.close(action);
        }
        else {
            if (this.rootComponent) {
                this.rootComponent.removeAttribute('aria-hidden');
                this.lockPageScrolling(false);
            }
            this.componentRefs.get(id).destroy();
            this.componentRefs.delete(id);
            this.action.next(action);
            this.action.complete();
            this.modalElement = null;
        }
    }
    lockPageScrolling(lock, element) {
        if (lock && element) {
            disableBodyScroll(element);
        }
        else {
            clearAllBodyScrollLocks();
        }
    }
    modalCanPin(target, modal, window) {
        let fitsHeight = (target.top + modal.height) < window.height;
        let fitsWidth = (target.right - modal.width) > 0;
        return fitsHeight && fitsWidth;
    }
    closeAll() {
        this.componentRefs.forEach((componentRef, id) => {
            this.close(false, true, id);
        });
    }
    getLastModalId() {
        let lastId;
        this.componentRefs.forEach((componentRef, id) => {
            lastId = id;
        });
        return lastId;
    }
    resolveNgContent(content, resolver) {
        if (content instanceof TemplateRef) {
            // Template reference
            const viewRef = content.createEmbeddedView(null);
            this.applicationRef.attachView(viewRef);
            return { ngContent: [viewRef.rootNodes], viewRef };
        }
        else if (content instanceof Type) {
            // Component
            try {
                // NOTE: Components may need to have the resolver from the calling function passed in, due to lazy-load resolution siloing
                // @see: https://github.com/angular/angular/issues/14324
                const factory = resolver.resolveComponentFactory(content);
                const componentRef = factory.create(this.injector);
                this.applicationRef.attachView(componentRef.hostView);
                return {
                    ngContent: [[componentRef.location.nativeElement]],
                    viewRef: componentRef.hostView
                };
            }
            catch (e) {
                console.error(`If you're passing a template or a component, you probably need to pass ComponentFactoryResolver to the .open() call`);
                throw e;
            }
        }
        return null;
    }
    isInModal(child) {
        return this.modalElement?.contains(child);
    }
    static { this.ɵfac = function ModalService_Factory(t) { return new (t || ModalService)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(i1$2.Router), i0.ɵɵinject(i0.RendererFactory2)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ModalService, factory: ModalService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: i0.ComponentFactoryResolver }, { type: i0.Injector }, { type: i0.ApplicationRef }, { type: i1$2.Router }, { type: i0.RendererFactory2 }]; }, null); })();

class BaseControlValueAccessor {
    constructor() {
        this.disabled = false;
        this.errorMessageId = null;
        this.describedBy = ['errorMessageId'];
    }
    // Call when value has changed programmatically
    onChange(newVal) { }
    onTouched(_) { }
    // Model -> View changes
    writeValue(obj) { this.value = obj; }
    registerOnChange(fn) { this.onChange = fn; }
    registerOnTouched(fn) { this.onTouched = fn; }
    setDisabledState(isDisabled) { this.disabled = isDisabled; }
    // Update some vars after ngOnChanges
    ngDoCheck() {
        this.errorMessageId = `${this.inputId}-error`;
        this.describedByAttr = this.describedBy
            .map(v => this[v])
            .filter(x => x)
            .join(' ');
    }
    static { this.ɵfac = function BaseControlValueAccessor_Factory(t) { return new (t || BaseControlValueAccessor)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: BaseControlValueAccessor, inputs: { errorMessageId: "errorMessageId" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseControlValueAccessor, [{
        type: Directive
    }], null, { errorMessageId: [{
            type: Input
        }] }); })();

const _c0$v = [[["", "accordion-heading", ""]], [["", "accordion-contents", ""]]];
const _c1$k = function (a0) { return [a0]; };
const _c2$6 = ["[accordion-heading]", "[accordion-contents]"];
let id$9 = 0;
class AccordionComponent {
    constructor(breakpointObserver) {
        this.breakpointObserver = breakpointObserver;
        this.showContents = false;
        this.id = `accordion-${id$9++}`;
    }
    ngOnInit() {
        // we want the open/closed state to reflect the current browser breakpoint for a11y
        this.showContents = this.breakpointObserver.isMatched(Breakpoint.GreaterThanTablet);
    }
    toggle(showContents = !this.showContents) {
        this.showContents = showContents;
    }
    static { this.ɵfac = function AccordionComponent_Factory(t) { return new (t || AccordionComponent)(i0.ɵɵdirectiveInject(i1$3.BreakpointObserver)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AccordionComponent, selectors: [["sumday-accordion"]], inputs: { showContents: "showContents", id: "id" }, ngContentSelectors: _c2$6, decls: 5, vars: 10, consts: [[1, "accordion"], ["tabindex", "0", "role", "button", 1, "accordion-heading", 3, "ngClass", "click"], [1, "accordion-contents", 3, "id", "hidden"]], template: function AccordionComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$v);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵlistener("click", function AccordionComponent_Template_div_click_1_listener() { return ctx.toggle(); });
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵprojection(4, 1);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$k, ctx.showContents ? "open" : "closed"));
            i0.ɵɵattribute("aria-controls", ctx.id)("aria-expanded", ctx.showContents);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("hide", !ctx.showContents);
            i0.ɵɵproperty("id", ctx.id)("hidden", !ctx.showContents);
            i0.ɵɵattribute("aria-hidden", !ctx.showContents);
        } }, dependencies: [i1$1.NgClass, i1.RoleButtonDirective], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionComponent, [{
        type: Component,
        args: [{ selector: 'sumday-accordion', template: "<div class=\"accordion\">\n  <div\n    class=\"accordion-heading\"\n    tabindex=\"0\"\n    role=\"button\"\n    [ngClass]=\"[ showContents ? 'open' : 'closed' ]\"\n    [attr.aria-controls]=\"id\"\n    [attr.aria-expanded]=\"showContents\"\n    (click)=\"toggle()\"\n  >\n    <ng-content select=\"[accordion-heading]\"></ng-content>\n  </div>\n  <div\n    class=\"accordion-contents\"\n    [id]=\"id\"\n    [class.hide]=\"!showContents\"\n    [hidden]=\"!showContents\"\n    [attr.aria-hidden]=\"!showContents\">\n    <ng-content select=\"[accordion-contents]\"></ng-content>\n  </div>\n</div>\n" }]
    }], function () { return [{ type: i1$3.BreakpointObserver }]; }, { showContents: [{
            type: Input
        }], id: [{
            type: Input
        }] }); })();

const _c0$u = ["*"];
class GridComponent {
    constructor() {
        this.classes = 'grid';
    }
    set container(value) { this.classes += ` grid-container`; }
    set stretch(value) { this.classes += ` grid-stretch`; }
    set gutters(value) { this.classes += ` grid-gutters`; }
    set desktop(size) { this.setSize(size, 'desktop'); }
    set mobile(size) { this.setSize(size, 'mobile'); }
    set tablet(size) { this.setSize(size, 'tablet'); }
    set print(size) { this.setSize(size, 'print'); }
    set desktopShift(size) { this.setShift(size, 'desktop'); }
    set mobileShift(size) { this.setShift(size, 'mobile'); }
    set tabletShift(size) { this.setShift(size, 'tablet'); }
    set printShift(size) { this.setShift(size, 'print'); }
    set desktopOffset(size) { this.setShift(size, 'desktop', true); }
    set mobileOffset(size) { this.setShift(size, 'mobile', true); }
    set tabletOffset(size) { this.setShift(size, 'tablet', true); }
    set printOffset(size) { this.setShift(size, 'print', true); }
    setSize(size, breakpoint) {
        if (size) {
            this.classes += size > 0
                ? ` grid-${breakpoint}-${size}`
                : ` hide-on-${breakpoint}`;
        }
    }
    setShift(size, breakpoint, offset = false) {
        if (size) {
            let type = offset
                ? 'offset'
                : size >= 0
                    ? 'push'
                    : 'pull';
            this.classes += ` grid-${breakpoint}-${type}-${Math.abs(size)}`;
        }
    }
    static { this.ɵfac = function GridComponent_Factory(t) { return new (t || GridComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GridComponent, selectors: [["sumday-grid"]], hostVars: 2, hostBindings: function GridComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassMap(ctx.classes);
        } }, inputs: { container: "container", stretch: "stretch", gutters: "gutters", desktop: "desktop", mobile: "mobile", tablet: "tablet", print: "print", desktopShift: "desktopShift", mobileShift: "mobileShift", tabletShift: "tabletShift", printShift: "printShift", desktopOffset: "desktopOffset", mobileOffset: "mobileOffset", tabletOffset: "tabletOffset", printOffset: "printOffset" }, ngContentSelectors: _c0$u, decls: 1, vars: 0, template: function GridComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GridComponent, [{
        type: Component,
        args: [{ selector: 'sumday-grid', template: "<ng-content></ng-content>\n" }]
    }], null, { classes: [{
            type: HostBinding,
            args: ['class']
        }], container: [{
            type: Input
        }], stretch: [{
            type: Input
        }], gutters: [{
            type: Input
        }], desktop: [{
            type: Input
        }], mobile: [{
            type: Input
        }], tablet: [{
            type: Input
        }], print: [{
            type: Input
        }], desktopShift: [{
            type: Input
        }], mobileShift: [{
            type: Input
        }], tabletShift: [{
            type: Input
        }], printShift: [{
            type: Input
        }], desktopOffset: [{
            type: Input
        }], mobileOffset: [{
            type: Input
        }], tabletOffset: [{
            type: Input
        }], printOffset: [{
            type: Input
        }] }); })();

class BaseTypeahead {
    constructor() {
        this.typeaheadConfig = TypeaheadConfigDefaults;
        this.typing = false;
        this.loading = false;
        this.loadingMore = false;
        this.canLoadMore = false;
        this.page = 1;
        this.selectList = [];
    }
    // Provided so we can overload it later
    onLoadMore() { }
    postOnChanges(changes) { }
    ngOnChanges(changes) {
        if (changes['typeaheadConfig'] && this.typeaheadConfig) {
            // Make sure we apply any changes over our defaults
            this.typeaheadConfig = { ...TypeaheadConfigDefaults, ...this.typeaheadConfig };
        }
        this.postOnChanges(changes);
    }
    ngAfterViewInit() {
        if (this.typeaheadConfig.action && this.typeaheadConfig.context) {
            // Literally the suggested way of doing this according to the Angular docs:
            // https://angular.io/guide/practical-observable-usage#type-ahead-suggestions
            if (this.focusOrInputSubscription) {
                this.focusOrInputSubscription.unsubscribe();
            }
            this.focusOrInputSubscription =
                merge(
                // We merge the focus event too to clear out the duplicate value between focus states
                fromEvent(this.inputRef.nativeElement, 'focus'), fromEvent(this.inputRef.nativeElement, 'input').pipe(tap(() => this.typing = true), // Flag that we're currently typing
                debounceTime(this.typeaheadConfig.debounceTime) // We want to throttle our keyboard input checks a bit
                )).pipe(
                // Sends the input value down the chain
                map((e) => e.target.value), 
                // No duplicate searches
                distinctUntilChanged(), switchMap(text => this.loadContent(text))).subscribe(({ data: list, pagination }) => {
                    if (pagination) {
                        this.canLoadMore = pagination.hasNextPage;
                    }
                    this.page = pagination ? pagination.currentPage : 1;
                    this.loadingMore = false;
                    this.loading = false;
                    this.typing = false;
                    // if the user tabs away / changed focus before it finishes loading then don't open
                    this.baseShowDropdown = this.inputRef.nativeElement === document.activeElement;
                    this.selectList = list || [];
                });
        }
    }
    listScroll(e) {
        if (this.canLoadMore) {
            // If we're 75% of the way down the list, load more automatically
            if ((e.target.scrollHeight - e.target.scrollTop) * .75 < e.target.clientHeight) {
                this.loadMore();
            }
        }
    }
    loadMore(e) {
        if (e) {
            // Catch the click event
            e.preventDefault();
            e.stopPropagation();
        }
        if (!this.loadingMore) {
            this.loadingMore = true;
            this.loadContent(this.inputRef.nativeElement.value, true)
                .subscribe(({ data: list, pagination }) => {
                if (pagination) {
                    this.page = pagination.currentPage;
                    this.canLoadMore = pagination.hasNextPage;
                }
                this.loadingMore = false;
                this.loading = false;
                this.typing = false;
                this.baseShowDropdown = true;
                this.selectList = this.selectList.concat(list);
            });
        }
    }
    loadContent(text, more = false) {
        // Don't search under the length threshold
        if (text.length < this.typeaheadConfig.minSearchLength && !this.typeaheadConfig.pagingOnly) {
            this.loading = false;
            this.baseShowDropdown = false;
            this.selectList = [];
            return of([]);
        }
        else {
            this.baseShowDropdown = true;
            if (more) {
                this.page++;
                this.loadingMore = true;
            }
            else {
                this.loading = true;
            }
            this.onLoadMore();
            return this.typeaheadConfig.action.call(this.typeaheadConfig.context, text.toLowerCase(), this.page);
        }
    }
    static { this.ɵfac = function BaseTypeahead_Factory(t) { return new (t || BaseTypeahead)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: BaseTypeahead, inputs: { typeaheadConfig: "typeaheadConfig", inputRef: "inputRef", typing: "typing", loading: "loading", loadingMore: "loadingMore", canLoadMore: "canLoadMore" }, features: [i0.ɵɵNgOnChangesFeature] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseTypeahead, [{
        type: Directive
    }], function () { return []; }, { typeaheadConfig: [{
            type: Input
        }], inputRef: [{
            type: Input
        }], typing: [{
            type: Input
        }], loading: [{
            type: Input
        }], loadingMore: [{
            type: Input
        }], canLoadMore: [{
            type: Input
        }] }); })();

class BaseTraversableComponent extends BaseTypeahead {
    constructor() {
        super();
        this.loopFocus = false;
        this.traversableList = 'traversableList';
    }
    onLoadMore() {
        let list = this[this.traversableList];
        if (this.focusedIndex === list.length) {
            this.focusItem(list.length - 1);
        }
    }
    traverseList(direction, $event) {
        let list = this[this.traversableList];
        // Slightly hacky way to account for the extra Load More button at the bottom
        let listLength = this.canLoadMore ? list.length : list.length - 1;
        if (this.focusedIndex == null) {
            this.focusItem(direction > 0 ? 0 : listLength);
        }
        else {
            let lastChildFocused = this.focusedIndex === listLength;
            let firstChildFocused = this.focusedIndex === 0;
            if (direction > 0 && lastChildFocused) {
                if (this.loopFocus) {
                    // If we're at the end of the list, wrap to the beginning
                    this.focusItem(0);
                }
            }
            else if (direction < 0 && firstChildFocused) {
                if (this.loopFocus) {
                    // If we're at the beginning of the list, wrap to the end
                    this.focusItem(list.length - 1);
                }
            }
            else {
                this.focusItem(this.focusedIndex + direction);
            }
        }
    }
}

function SelectItemComponent_span_0_img_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 7);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r2.item.image, i0.ɵɵsanitizeUrl)("fallbackUrl", ctx_r2.item.fallback);
} }
const _c0$t = function (a1) { return ["icon", a1]; };
function SelectItemComponent_span_0_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$t, ctx_r3.item.icon));
} }
function SelectItemComponent_span_0_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 9);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("normal-desc", ctx_r4.normalDescription);
    i0.ɵɵproperty("innerHtml", ctx_r4.item.desc, i0.ɵɵsanitizeHtml);
} }
function SelectItemComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtemplate(1, SelectItemComponent_span_0_img_1_Template, 1, 2, "img", 3);
    i0.ɵɵtemplate(2, SelectItemComponent_span_0_span_2_Template, 1, 3, "span", 4);
    i0.ɵɵelementStart(3, "span", 5);
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, SelectItemComponent_span_0_span_5_Template, 1, 3, "span", 6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("icon-right", ctx_r0.iconRight);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.item.image);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.item.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.item.text || ctx_r0.item.value, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.item.desc);
} }
function SelectItemComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵprojection(1);
    i0.ɵɵelementContainerEnd();
} }
const _c1$j = ["*"];
class SelectItemComponent {
    constructor() {
        this.iconRight = false;
        this.normalDescription = false;
    }
    ngOnChanges(changes) {
        if (changes['item'] && this.item) {
            this.value = this.item.value;
        }
    }
    static { this.ɵfac = function SelectItemComponent_Factory(t) { return new (t || SelectItemComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectItemComponent, selectors: [["sumday-select-item"]], hostVars: 1, hostBindings: function SelectItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵattribute("data-value", ctx.value);
        } }, inputs: { item: "item", iconRight: "iconRight", normalDescription: "normalDescription" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1$j, decls: 2, vars: 2, consts: [["class", "text-with-icon", 3, "icon-right", 4, "ngIf"], [4, "ngIf"], [1, "text-with-icon"], ["class", "icon", "alt", "", 3, "src", "fallbackUrl", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], [1, "text"], ["class", "desc", 3, "normal-desc", "innerHtml", 4, "ngIf"], ["alt", "", 1, "icon", 3, "src", "fallbackUrl"], [3, "ngClass"], [1, "desc", 3, "innerHtml"]], template: function SelectItemComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, SelectItemComponent_span_0_Template, 6, 6, "span", 0);
            i0.ɵɵtemplate(1, SelectItemComponent_ng_container_1_Template, 2, 0, "ng-container", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.item);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.item);
        } }, dependencies: [i1$1.NgClass, i1$1.NgIf, i1.CdnSrcDirective], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectItemComponent, [{
        type: Component,
        args: [{ selector: 'sumday-select-item', template: "<span *ngIf=\"item\" class=\"text-with-icon\" [class.icon-right]=\"iconRight\">\n  <img *ngIf=\"item.image\"\n       [src]=\"item.image\"\n       [fallbackUrl]=\"item.fallback\"\n       class=\"icon\" alt=\"\" />\n  <span *ngIf=\"item.icon\" [ngClass]=\"['icon', item.icon]\"></span>\n  <span class=\"text\">\n    {{ item.text || item.value }}\n    <span\n      *ngIf=\"item.desc\"\n      class=\"desc\"\n      [class.normal-desc]=\"normalDescription\"\n      [innerHtml]=\"item.desc\"\n    ></span>\n  </span>\n</span>\n\n<ng-container *ngIf=\"!item\">\n  <ng-content></ng-content>\n</ng-container>\n" }]
    }], null, { value: [{
            type: HostBinding,
            args: ['attr.data-value']
        }], item: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], normalDescription: [{
            type: Input
        }] }); })();

function ValidationErrorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("server", ctx_r0.errorType === "server");
} }
const _c0$s = ["*"];
class ValidationErrorComponent {
    constructor(control, controlContainer, cd) {
        this.control = control;
        this.controlContainer = controlContainer;
        this.cd = cd;
        this.showError = false;
    }
    ngAfterViewChecked() {
        let control = this.control || this.controlContainer.control;
        if (control) {
            this.showError =
                control.invalid &&
                    control.hasError(this.errorType) &&
                    (control.touched || !this.control);
            // fixes ExpressionChangedAfterItHasBeenCheckedError
            this.cd.detectChanges();
        }
    }
    static { this.ɵfac = function ValidationErrorComponent_Factory(t) { return new (t || ValidationErrorComponent)(i0.ɵɵdirectiveInject(i1$4.NgControl, 8), i0.ɵɵdirectiveInject(i1$4.ControlContainer), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ValidationErrorComponent, selectors: [["sumday-validation-error"]], inputs: { errorType: "errorType" }, ngContentSelectors: _c0$s, decls: 1, vars: 1, consts: [["class", "validation", 3, "server", 4, "ngIf"], [1, "validation"]], template: function ValidationErrorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ValidationErrorComponent_div_0_Template, 2, 2, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.showError);
        } }, dependencies: [i1$1.NgIf], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValidationErrorComponent, [{
        type: Component,
        args: [{ selector: 'sumday-validation-error', template: "<div class=\"validation\" [class.server]=\"errorType === 'server'\" *ngIf=\"showError\">\n  <ng-content></ng-content>\n</div>\n" }]
    }], function () { return [{ type: i1$4.NgControl, decorators: [{
                type: Optional
            }] }, { type: i1$4.ControlContainer }, { type: i0.ChangeDetectorRef }]; }, { errorType: [{
            type: Input
        }] }); })();

function ValidationsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "sumday-validation-error", 1);
    i0.ɵɵelement(2, "span", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const error_r1 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("errorType", error_r1.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", error_r1.message, i0.ɵɵsanitizeHtml);
} }
const DEFAULT_VALIDATION_MESSAGE_MAPPINGS = {
    required: (params) => `${params.fieldName} is required`,
    pattern: `This is not formatted correctly`,
    minlength: (params) => `${params.fieldName} needs to be at least ${params.requiredLength} characters long`,
    server: '',
    DEFAULT: `This doesn't look right`,
};
class ValidationsComponent {
    set errorMessageMappings(mappings) {
        this.errorMappings = Object.assign({}, DEFAULT_VALIDATION_MESSAGE_MAPPINGS, mappings);
    }
    constructor(control) {
        this.control = control;
        this.errors = [];
        this.errorMappings = DEFAULT_VALIDATION_MESSAGE_MAPPINGS;
    }
    ngOnInit() {
        this.updateErrors();
        this.control.statusChanges.subscribe(() => this.updateErrors());
    }
    updateErrors() {
        const errors = this.control.errors || {};
        this.errors = Object.keys(errors).map((type) => {
            if (type === 'server') {
                return {
                    type,
                    message: errors.server,
                };
            }
            const validationMessage = this.errorMappings[type] || (typeof errors[type] === 'string' ? errors[type] : this.errorMappings.DEFAULT);
            let message;
            if (typeof validationMessage === 'string') {
                message = validationMessage;
            }
            else {
                const params = Object.assign({}, this.fieldParams, errors[type]);
                message = validationMessage(params);
            }
            return { type, message };
        });
    }
    static { this.ɵfac = function ValidationsComponent_Factory(t) { return new (t || ValidationsComponent)(i0.ɵɵdirectiveInject(i1$4.NgControl)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ValidationsComponent, selectors: [["sumday-validations"]], inputs: { fieldParams: "fieldParams", errorMessageMappings: "errorMessageMappings" }, decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [3, "errorType"], [3, "innerHtml"]], template: function ValidationsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ValidationsComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngForOf", ctx.errors);
        } }, dependencies: [i1$1.NgForOf, ValidationErrorComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValidationsComponent, [{
        type: Component,
        args: [{ selector: 'sumday-validations', template: "<ng-container *ngFor=\"let error of errors;\">\n  <sumday-validation-error [errorType]=\"error.type\">\n    <span [innerHtml]=\"error.message\"></span>\n  </sumday-validation-error>\n</ng-container>\n" }]
    }], function () { return [{ type: i1$4.NgControl }]; }, { fieldParams: [{
            type: Input
        }], errorMessageMappings: [{
            type: Input
        }] }); })();

/* eslint-disable @typescript-eslint/no-unused-expressions */
const _c0$r = ["input"];
const _c1$i = ["button"];
const _c2$5 = ["list"];
function SelectComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19)(2, "sumday-select-item", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("readonly", ctx_r2.readonly)("disabled", ctx_r2.disabled)("icon-up-caret", ctx_r2.showDropDown)("icon-down-caret", !ctx_r2.showDropDown);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("hide-desc", ctx_r2.hideSelectedDescription)("truncate-text", ctx_r2.truncateSelectedText);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.inputId, "-value");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("item", ctx_r2.selected);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", !ctx_r2.selected && ctx_r2.placeholder ? ctx_r2.placeholder : "", " ");
} }
function SelectComponent_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "searching, please wait");
    i0.ɵɵelementEnd();
} }
function SelectComponent_ng_container_15_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 23)(1, "sumday-select-item");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.typeaheadConfig == null ? null : ctx_r12.typeaheadConfig.noInputText, " ");
} }
function SelectComponent_ng_container_15_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 24)(1, "sumday-select-item");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.typeaheadConfig == null ? null : ctx_r13.typeaheadConfig.noResultsText, " ");
} }
function SelectComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SelectComponent_ng_container_15_li_1_Template, 3, 1, "li", 21);
    i0.ɵɵtemplate(2, SelectComponent_ng_container_15_li_2_Template, 3, 1, "li", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (_r0 == null ? null : _r0.value.length) < (ctx_r5.typeaheadConfig == null ? null : ctx_r5.typeaheadConfig.minSearchLength));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (_r0 == null ? null : _r0.value.length) >= (ctx_r5.typeaheadConfig == null ? null : ctx_r5.typeaheadConfig.minSearchLength) && !ctx_r5.typing);
} }
function SelectComponent_li_16_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 25)(1, "a", 26);
    i0.ɵɵlistener("keydown", function SelectComponent_li_16_Template_a_keydown_1_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.handleItemKeys($event)); })("click", function SelectComponent_li_16_Template_a_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const item_r14 = restoredCtx.$implicit; const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.changeValue(item_r14)); })("focus", function SelectComponent_li_16_Template_a_focus_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const item_r14 = restoredCtx.$implicit; const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.changeFocus(item_r14)); })("mouseenter", function SelectComponent_li_16_Template_a_mouseenter_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const i_r15 = restoredCtx.index; const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.focusItem(i_r15)); });
    i0.ɵɵelement(2, "sumday-select-item", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const i_r15 = ctx.index;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r6.inputId, "_option-", i_r15, "");
    i0.ɵɵattribute("tabindex", i_r15 === ctx_r6.focusedIndex ? "0" : "-1")("aria-selected", (item_r14 == null ? null : item_r14.value) === (ctx_r6.selected == null ? null : ctx_r6.selected.value) || null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("item", item_r14);
} }
const _c3$3 = function (a0) { return { value: a0, icon: "icon-plus" }; };
function SelectComponent_ng_container_17_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 28)(1, "a", 29);
    i0.ɵɵlistener("keydown", function SelectComponent_ng_container_17_li_1_Template_a_keydown_1_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.handleItemKeys($event)); })("click", function SelectComponent_ng_container_17_li_1_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.loadMore($event)); })("focus", function SelectComponent_ng_container_17_li_1_Template_a_focus_1_listener() { i0.ɵɵrestoreView(_r24); const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.changeFocus()); })("mouseenter", function SelectComponent_ng_container_17_li_1_Template_a_mouseenter_1_listener() { i0.ɵɵrestoreView(_r24); const ctx_r27 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r27.focusItem(ctx_r27.selectList.length)); });
    i0.ɵɵelement(2, "sumday-select-item", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("tabindex", ctx_r21.selectList.length === ctx_r21.focusedIndex ? "0" : "-1");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("item", i0.ɵɵpureFunction1(2, _c3$3, ctx_r21.typeaheadConfig == null ? null : ctx_r21.typeaheadConfig.loadMoreText));
} }
const _c4$2 = function (a0) { return { value: a0, icon: "icon-loading" }; };
function SelectComponent_ng_container_17_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 24);
    i0.ɵɵelement(1, "sumday-select-item", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("item", i0.ɵɵpureFunction1(1, _c4$2, ctx_r22.typeaheadConfig == null ? null : ctx_r22.typeaheadConfig.loadingMoreText));
} }
function SelectComponent_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SelectComponent_ng_container_17_li_1_Template, 3, 4, "li", 27);
    i0.ɵɵtemplate(2, SelectComponent_ng_container_17_li_2_Template, 2, 3, "li", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.loadingMore && ctx_r7.canLoadMore);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.loadingMore);
} }
function SelectComponent_span_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Searching, please wait.");
    i0.ɵɵelementEnd();
} }
function SelectComponent_span_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Loading more, please wait.");
    i0.ɵɵelementEnd();
} }
function SelectComponent_option_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r28 = ctx.$implicit;
    i0.ɵɵattribute("value", item_r28 == null ? null : item_r28.value);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r28 == null ? null : item_r28.text, " ");
} }
function SelectComponent_div_25_ng_content_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 2, ["*ngIf", "!errorMessageMappings"]);
} }
function SelectComponent_div_25_sumday_validations_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sumday-validations", 32);
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("errorMessageMappings", ctx_r30.errorMessageMappings[ctx_r30.formControlName])("fieldParams", ctx_r30.fieldParams);
} }
function SelectComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, SelectComponent_div_25_ng_content_1_Template, 1, 0, "ng-content", 10);
    i0.ɵɵtemplate(2, SelectComponent_div_25_sumday_validations_2_Template, 1, 2, "sumday-validations", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r11.errorMessageId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r11.errorMessageMappings);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.errorMessageMappings);
} }
const _c5$1 = ["*", [["", "after-label", ""]], [["sumday-validations"], ["sumday-validation-error"], ["", 8, "validation"], ["", "validation", ""]]];
const _c6 = ["*", "[after-label]", "sumday-validations, sumday-validation-error, .validation, [validation]"];
let id$8 = 0;
let currentlyOpenSelect$1; // Keeps track if which select is open, globally
class SelectComponent extends BaseTraversableComponent {
    set id(setId) {
        if (setId) {
            this.inputId = `${setId}-input`;
        }
    }
    set list(list) {
        // Build the optional properties and defaults for our list
        for (let item of list) {
            // Text is the value if one isn't provided
            item.text = item.text || item.value.toString();
        }
        // Save the result
        this.selectList = list;
    }
    set value(value) {
        if (this.formControlName || this.formControl) {
            isDevMode() && console.warn(`${this.formControlName || this.formControl}:`, `Don't use the 'value' property of sumday-select with a formControl.`, `It should generally only be used when in readonly mode to display data as a dumb component`);
        }
        this.writeValue(value);
    }
    get value() {
        return this.selected ? this.selected.value : '';
    }
    windowClickHandler(event, targetElement) {
        if (this.showDropDown) {
            // Only close it if the click isn't on a select element
            if (![
                this.buttonRef && this.buttonRef.nativeElement,
                this.inputRef && this.inputRef.nativeElement,
            ].filter(x => x).includes(targetElement)) {
                this.toggleDropdown(false, false);
            }
        }
    }
    constructor(window, modalService) {
        super();
        this.window = window;
        this.modalService = modalService;
        this.inputId = `select-${id$8++}-input`;
        this.typeaheadInstructionsId = `${this.inputId}-typeahead-instructions`;
        this.textJump = '';
        this.openUp = true;
        this.hasTouch = false;
        this.useInternalErrorMessage = false;
        this.loopFocus = false;
        this.traversableList = 'selectList';
        this.readonly = false;
        this.disabled = false;
        this.autocomplete = null;
        this.ariaLabel = null;
        this.ariaDescribedBy = null;
        this.errorMessageId = null;
        this.extraLabelClass = '';
        this.overlay = true;
        this.showDropDown = false;
        this.placeholder = 'Select';
        this.iconRight = false;
        this.normalDescription = false;
        this.hideSelectedDescription = false;
        this.truncateSelectedText = false;
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.change = new EventEmitter();
        this.onChangeCallback = () => { };
        this.onTouchedCallback = () => { };
        this.handleKeys = ($event) => {
            switch ($event.keyCode) {
                case KeyCodes.ARROW_DOWN:
                case KeyCodes.ARROW_UP:
                    $event.preventDefault();
                    if (!this.showDropDown) {
                        this.toggleDropdown(true);
                    }
                    else {
                        this.traverseList($event.keyCode === KeyCodes.ARROW_UP ? -1 : 1, $event);
                    }
                    break;
                case KeyCodes.TAB:
                    if (this.showDropDown) {
                        /*
                        We need to timeout so if you tab off from the dropdown it wont focus you to the select button.
                        Focus should go to the next item not back to the select.
                        */
                        setTimeout(() => {
                            this.toggleDropdown(false, false);
                        }, 10);
                    }
                    break;
                case KeyCodes.ENTER:
                    $event.preventDefault();
                    $event.stopPropagation();
                    if (!this.showDropDown) {
                        this.toggleDropdown();
                    }
                    break;
                case KeyCodes.SPACEBAR:
                    if (!this.typeaheadConfig.action) {
                        // If there's no text to jump to, it's basically the Enter key
                        if (this.textJump.length === 0) {
                            $event.preventDefault();
                            $event.stopPropagation();
                            if (!this.showDropDown) {
                                this.toggleDropdown();
                            }
                        }
                        else {
                            // Otherwise the user might be trying to type multiple words
                            this.handleTextJump($event);
                        }
                    }
                    break;
                case KeyCodes.ESC:
                    this.toggleDropdown(false, true);
                    break;
                default:
                    if (!this.typeaheadConfig.action) {
                        this.handleTextJump($event);
                    }
            }
        };
        this.handleItemKeys = ($event) => {
            switch ($event.keyCode) {
                case KeyCodes.ENTER:
                    $event.preventDefault();
                    $event.stopPropagation();
                    $event.currentTarget.click();
                    break;
                case KeyCodes.TAB:
                    this.toggleDropdown(false, false);
                    break;
                case KeyCodes.SPACEBAR:
                    // If there's no text to jump to, it's basically the Enter key
                    if (this.textJump.length === 0) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        $event.currentTarget.click();
                    }
                    else {
                        // Otherwise the user might be trying to type multiple words
                        this.handleTextJump($event);
                    }
                    break;
            }
        };
        this.handleTextJump = ($event) => {
            let matchedIndex;
            // If it's closed, we're working from the selected index. Otherwise, focused.
            let startIndex = this.showDropDown ? this.focusedIndex + 1 : this.selectedIndex + 1;
            // We accept either a character, or a space
            let letter = String.fromCharCode($event.keyCode).toLowerCase();
            // If we just typed the same letter twice in a row or it's the first letter
            if (this.textJump.length === 0 || this.textJump === letter) {
                this.textJump = letter;
                // Find the next entry that starts with that letter
                matchedIndex = this.selectList
                    .slice(startIndex)
                    .findIndex(item => item.text.toLowerCase().startsWith(letter));
                if (matchedIndex < 0) {
                    // If we found nothing, let's search the full list instead
                    matchedIndex = this.selectList
                        .findIndex(item => item.text.toLowerCase().startsWith(letter));
                }
                else {
                    // If we did find a match, add the start offset to get the original index back
                    matchedIndex = matchedIndex + startIndex;
                }
            }
            else {
                // For some reason, the spacebar fires multiple times, so let's make sure we only add it once
                if (!(this.textJump.slice(-1) === ' ' && letter === ' ')) {
                    this.textJump += letter;
                }
                // Otherwise let's look for an entry that might match the typed text
                matchedIndex = this.selectList
                    .findIndex(item => item.text.toLowerCase().startsWith(this.textJump));
            }
            // If we've found something, either select or focus it depending on if the list is open
            if (matchedIndex >= 0) {
                this.showDropDown
                    ? this.focusItem(matchedIndex)
                    : this.changeValue(this.selectList[matchedIndex]);
            }
            // Clear out the textJump buffer after a second
            clearTimeout(this.textJumpTimer);
            this.textJumpTimer = setTimeout(() => this.textJump = '', 500);
        };
    }
    ngOnInit() {
        if (!this.errorMessageId) {
            this.errorMessageId = `${this.inputId}-error`;
            this.useInternalErrorMessage = true;
        }
        this.labelledByValue = `${this.inputId}-label ${this.inputId}-value`;
        this.describedByValue = this.getDescribedByValue();
    }
    getDescribedByValue() {
        let ids = [this.errorMessageId];
        if (this.ariaDescribedBy) {
            ids.push(this.ariaDescribedBy);
        }
        return ids.join(' ');
    }
    blurDropdown($event) {
        this.toggleDropdown(false);
    }
    toggleDropdown(show = !this.showDropDown, refocus = true) {
        // Don't do anything if we don't have anything to show, or it's disabled
        if (this.disabled || this.readonly || (!this.typeaheadConfig.noInputText && (!this.selectList || this.selectList.length === 0))) {
            return;
        }
        this.showDropDown = show;
        if (this.showDropDown) {
            // Close any open dropdowns and set this as the new active one
            if (currentlyOpenSelect$1) {
                currentlyOpenSelect$1.toggleDropdown(false);
            }
            currentlyOpenSelect$1 = this;
            this.checkDirection();
            this.updateListHeight();
            if (this.typeaheadConfig.action && this.inputRef) {
                setTimeout(() => {
                    this.inputRef.nativeElement.focus();
                }, 50);
            }
            else {
                this.focusItem(this.selectedIndex || 0, true);
            }
        }
        else {
            currentlyOpenSelect$1 = null;
            if (refocus) {
                this.focusCombobox();
            }
            this.inputRef.nativeElement.value = '';
            this.focusedIndex = null;
            if (this.typeaheadConfig.action && !this.typeaheadConfig.pagingOnly) {
                this.selectList = [];
            }
            this.touch();
        }
    }
    checkDirection() {
        // If the input is below the midpoint of the page, open the list upward if it's an overlay
        let nativeElement = this.buttonRef.nativeElement;
        let bottomThreshold = this.window.nativeWindow.innerHeight * .7;
        if (this.modalService.isInModal(nativeElement)) {
            bottomThreshold = this.modalService.modalElement.lastElementChild.getBoundingClientRect().bottom * .7;
        }
        this.openUp = nativeElement.getBoundingClientRect().top > bottomThreshold;
    }
    updateListHeight() {
        let nativeElement = this.buttonRef.nativeElement;
        if (this.modalService.isInModal(nativeElement)) {
            let eleStats = nativeElement.getBoundingClientRect();
            let modalStats = this.modalService.modalElement.lastElementChild.getBoundingClientRect();
            let height = modalStats.height / 2;
            let availableToTop = eleStats.top - modalStats.top;
            let availableToBottom = modalStats.bottom - eleStats.bottom;
            if (this.openUp && height > availableToTop) {
                height = availableToTop * .7;
            }
            if (!this.openUp && height > availableToBottom) {
                height = availableToBottom * .7;
            }
            this.listRef.nativeElement.setAttribute('style', `max-height: ${height}px`);
        }
    }
    focusItem(index = 0, scrollTo = false) {
        setTimeout(() => {
            let parentUl = this.listRef.nativeElement;
            let targetLi = parentUl.children[index];
            if (targetLi) {
                if (scrollTo) {
                    // Scroll to the selected item
                    parentUl.scrollTop = targetLi.offsetTop - parentUl.offsetTop;
                }
                // Focus it if there's something focusable there
                let focusableElement = targetLi.querySelector('a');
                if (focusableElement) {
                    focusableElement.focus();
                }
            }
        }, 50);
    }
    focusCombobox() {
        // need to timeout for screen readers
        setTimeout(() => this.buttonRef.nativeElement.focus(), 100);
    }
    nativeSelectChanged($event) {
        // If the hidden native select proxy element is changed (via autofill for example), update our select
        let t = $event.target;
        this.writeValue(t.options[t.selectedIndex].value);
    }
    getSelectedId() {
        if (!this.selectList) {
            return null;
        }
        return (this.selectedIndex !== null && this.selectedIndex > -1) ? `${this.inputId}_option-${this.selectedIndex}` : null;
    }
    changeFocus(item) {
        if (item) {
            this.focusedIndex = this.selectList.indexOf(item);
        }
        else if (this.canLoadMore) {
            // If we don't pass an item and we can load more, then it's the Load More link
            this.focusedIndex = this.selectList.length;
        }
        if (this.focusedIndex < 0) {
            this.focusedIndex = null;
        }
    }
    changeValue(item) {
        // Confirms that the value is in our list
        let itemIndex = this.selectList.indexOf(item);
        if (itemIndex >= 0) {
            this.selected = item;
            this.selectedIndex = itemIndex;
            if (this.onChangeCallback) {
                this.onChangeCallback(item.value);
            }
            this.change.emit(item);
            // If the dropdown is open, hide it
            if (this.showDropDown) {
                this.toggleDropdown(false, true);
            }
        }
        else {
            this.selected = null;
            this.selectedIndex = null;
            if (this.onChangeCallback) {
                this.onChangeCallback(null);
            }
            this.change.emit(null);
        }
    }
    touch() {
        if (this.onTouchedCallback && !this.disabled && !this.readonly) {
            this.onTouchedCallback();
        }
    }
    onBlur(event) {
        if (!this.showDropDown) {
            this.touch();
            this.blur.emit(event);
        }
    }
    onFocus(event) {
        this.focus.emit(event);
    }
    clickHandler() {
        if (!this.hasTouch) {
            this.toggleDropdown();
        }
    }
    touchHandler() {
        this.hasTouch = true;
        this.toggleDropdown();
    }
    writeValue(value) {
        // If it's not a SelectItem, find the SelectItem that matches
        if (value && !value.hasOwnProperty('value')) {
            value = this.selectList.find(selectItem => selectItem.value === value);
        }
        this.changeValue(value);
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    static { this.ɵfac = function SelectComponent_Factory(t) { return new (t || SelectComponent)(i0.ɵɵdirectiveInject(i1.WindowRefService), i0.ɵɵdirectiveInject(ModalService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectComponent, selectors: [["sumday-select"]], viewQuery: function SelectComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$r, 5);
            i0.ɵɵviewQuery(_c1$i, 5);
            i0.ɵɵviewQuery(_c2$5, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttonRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listRef = _t.first);
        } }, hostBindings: function SelectComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function SelectComponent_click_HostBindingHandler($event) { return ctx.windowClickHandler($event, $event.target); }, false, i0.ɵɵresolveDocument);
        } }, inputs: { readonly: "readonly", disabled: "disabled", autocomplete: "autocomplete", ariaLabel: "ariaLabel", ariaDescribedBy: "ariaDescribedBy", errorMessageId: "errorMessageId", extraLabelClass: "extraLabelClass", errorMessageMappings: "errorMessageMappings", fieldParams: "fieldParams", id: "id", overlay: "overlay", showDropDown: "showDropDown", placeholder: "placeholder", iconRight: "iconRight", normalDescription: "normalDescription", hideSelectedDescription: "hideSelectedDescription", truncateSelectedText: "truncateSelectedText", formControl: "formControl", formControlName: "formControlName", list: "list", value: "value" }, outputs: { selected: "selected", blur: "blur", focus: "focus", change: "change" }, features: [i0.ɵɵProvidersFeature([{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => SelectComponent),
                    multi: true
                }]), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c6, decls: 26, vars: 51, consts: [[3, "id", "for"], [1, "select-wrapper", 3, "keydown", "blur"], [1, "select-input"], [1, "text-input"], ["type", "text", "autocomplete", "off", "aria-haspopup", "listbox"], ["input", ""], ["type", "button", "aria-haspopup", "listbox", 1, "select-control", 3, "id", "disabled", "click", "touched", "blur", "focus"], ["button", ""], ["class", "selected", "aria-hidden", "true", "role", "presentation", 3, "readonly", "disabled", "icon-up-caret", "icon-down-caret", 4, "ngIf"], ["aria-live", "polite", "role", "status", 1, "screen-reader-only"], [4, "ngIf"], ["role", "listbox", "aria-live", "polite", 1, "select-list", 3, "id", "hidden", "scroll"], ["list", ""], ["role", "presentation", 4, "ngFor", "ngForOf"], [1, "screen-reader-only", 3, "id"], [1, "select-proxy", 3, "change"], [4, "ngFor", "ngForOf"], [3, "id", 4, "ngIf"], ["aria-hidden", "true", "role", "presentation", 1, "selected"], [1, "select-item", 3, "id"], [3, "item"], ["role", "option", "class", "typeahead-message", "role", "presentation", 4, "ngIf"], ["class", "typeahead-message", "role", "presentation", 4, "ngIf"], ["role", "option", "role", "presentation", 1, "typeahead-message"], ["role", "presentation", 1, "typeahead-message"], ["role", "presentation"], ["role", "option", 1, "select-item", 3, "id", "keydown", "click", "focus", "mouseenter"], ["class", "typeahead-message typeahead-load-more", "role", "presentation", 4, "ngIf"], ["role", "presentation", 1, "typeahead-message", "typeahead-load-more"], ["role", "option", 1, "select-item", 3, "keydown", "click", "focus", "mouseenter"], [3, "id"], [3, "errorMessageMappings", "fieldParams", 4, "ngIf"], [3, "errorMessageMappings", "fieldParams"]], template: function SelectComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c5$1);
            i0.ɵɵelementStart(0, "label", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(2, 1);
            i0.ɵɵelementStart(3, "div", 1);
            i0.ɵɵlistener("keydown", function SelectComponent_Template_div_keydown_3_listener($event) { return ctx.handleKeys($event); })("blur", function SelectComponent_Template_div_blur_3_listener($event) { return ctx.blurDropdown($event); });
            i0.ɵɵelementStart(4, "div", 2)(5, "span", 3);
            i0.ɵɵelement(6, "input", 4, 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "button", 6, 7);
            i0.ɵɵlistener("click", function SelectComponent_Template_button_click_8_listener() { return ctx.clickHandler(); })("touched", function SelectComponent_Template_button_touched_8_listener() { return ctx.touchHandler(); })("blur", function SelectComponent_Template_button_blur_8_listener($event) { return ctx.onBlur($event); })("focus", function SelectComponent_Template_button_focus_8_listener($event) { return ctx.onFocus($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(10, SelectComponent_div_10_Template, 4, 15, "div", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "div", 9);
            i0.ɵɵtemplate(12, SelectComponent_span_12_Template, 2, 0, "span", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "ul", 11, 12);
            i0.ɵɵlistener("scroll", function SelectComponent_Template_ul_scroll_13_listener($event) { return ctx.listScroll($event); });
            i0.ɵɵtemplate(15, SelectComponent_ng_container_15_Template, 3, 2, "ng-container", 10);
            i0.ɵɵtemplate(16, SelectComponent_li_16_Template, 3, 5, "li", 13);
            i0.ɵɵtemplate(17, SelectComponent_ng_container_17_Template, 3, 2, "ng-container", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "div", 9);
            i0.ɵɵtemplate(19, SelectComponent_span_19_Template, 2, 0, "span", 10);
            i0.ɵɵtemplate(20, SelectComponent_span_20_Template, 2, 0, "span", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "div", 14);
            i0.ɵɵtext(22, "This is a typeahead search field. Start typing and wait for results. Use up and down arrows to highlight an item and use space bar or enter to select an item.");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "select", 15);
            i0.ɵɵlistener("change", function SelectComponent_Template_select_change_23_listener($event) { return ctx.nativeSelectChanged($event); });
            i0.ɵɵtemplate(24, SelectComponent_option_24_Template, 2, 2, "option", 16);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(25, SelectComponent_div_25_Template, 3, 3, "div", 17);
        } if (rf & 2) {
            i0.ɵɵpropertyInterpolate1("id", "", ctx.inputId, "-label")("for", "", ctx.inputId, "-button");
            i0.ɵɵattribute("class", ctx.extraLabelClass);
            i0.ɵɵadvance(3);
            i0.ɵɵclassProp("open-down", ctx.showDropDown && (!ctx.openUp || !ctx.overlay))("open-up", ctx.showDropDown && ctx.openUp && ctx.overlay);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("hide", !(ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.action) || !ctx.showDropDown || (ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.pagingOnly))("icon-search", !ctx.loading)("icon-loading", ctx.loading);
            i0.ɵɵadvance(1);
            i0.ɵɵattributeInterpolate2("aria-describedby", "", ctx.describedByValue, " ", ctx.typeaheadInstructionsId, "");
            i0.ɵɵattribute("aria-labelledby", ctx.labelledByValue)("aria-expanded", ctx.showDropDown || null);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("hide", (ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.action) && ctx.showDropDown && !(ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.pagingOnly))("open", ctx.showDropDown);
            i0.ɵɵpropertyInterpolate1("id", "", ctx.inputId, "-button");
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵattribute("tabindex", (ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.action) && ctx.showDropDown && !(ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.pagingOnly) ? -1 : 0)("aria-labelledby", ctx.labelledByValue)("aria-disabled", ctx.disabled || null)("aria-describedby", ctx.describedByValue)("aria-expanded", ctx.showDropDown || null);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !(ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.action) || !ctx.showDropDown || (ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.pagingOnly));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.loading);
            i0.ɵɵadvance(1);
            i0.ɵɵclassProp("overlay", ctx.overlay)("open-up", ctx.openUp)("hide", !ctx.showDropDown);
            i0.ɵɵattributeInterpolate1("aria-labelledby", "", ctx.inputId, "-label");
            i0.ɵɵproperty("id", ctx.inputId)("hidden", !ctx.showDropDown);
            i0.ɵɵattribute("aria-hidden", !ctx.showDropDown)("aria-activedescendant", ctx.getSelectedId())("aria-expanded", ctx.showDropDown);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", (ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.action) && ctx.selectList.length === 0 && ctx.loading && (ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.pagingOnly));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.selectList);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.action) && !ctx.loading && ctx.selectList.length > 0);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.loading);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.loadingMore);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("id", ctx.typeaheadInstructionsId);
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("autocomplete", ctx.autocomplete);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.selectList);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.useInternalErrorMessage);
        } }, dependencies: [i1$1.NgForOf, i1$1.NgIf, i1$4.NgSelectOption, i1$4.ɵNgSelectMultipleOption, SelectItemComponent, ValidationsComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectComponent, [{
        type: Component,
        args: [{ selector: 'sumday-select', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => SelectComponent),
                        multi: true
                    }], template: "<label id=\"{{inputId}}-label\" for=\"{{inputId}}-button\" [attr.class]=\"extraLabelClass\"><ng-content></ng-content></label>\n\n<ng-content select=\"[after-label]\"></ng-content>\n\n<div\n  class=\"select-wrapper\"\n  [class.open-down]=\"showDropDown && (!openUp || !overlay)\"\n  [class.open-up]=\"showDropDown && openUp && overlay\"\n  (keydown)=\"handleKeys($event)\"\n  (blur)=\"blurDropdown($event)\"\n>\n  <div class=\"select-input\">\n    <span\n      class=\"text-input\"\n      [class.hide]=\"(!typeaheadConfig?.action || !showDropDown) || typeaheadConfig?.pagingOnly\"\n      [class.icon-search]=\"!loading\"\n      [class.icon-loading]=\"loading\"\n    >\n      <input\n        #input\n        type=\"text\"\n        autocomplete=\"off\"\n        [attr.aria-labelledby]=\"labelledByValue\"\n        attr.aria-describedby=\"{{describedByValue}} {{typeaheadInstructionsId}}\"\n        [attr.aria-expanded]=\"showDropDown || null\"\n        aria-haspopup=\"listbox\"\n      />\n  </span>\n\n    <button\n      [class.hide]=\"typeaheadConfig?.action && showDropDown && !typeaheadConfig?.pagingOnly\"\n      [attr.tabindex]=\"(typeaheadConfig?.action && showDropDown && !typeaheadConfig?.pagingOnly) ? -1 : 0\"\n      type=\"button\"\n      #button\n      id=\"{{inputId}}-button\"\n      [attr.aria-labelledby]=\"labelledByValue\"\n      class=\"select-control\"\n      (click)=\"clickHandler()\"\n      (touched)=\"touchHandler()\"\n      (blur)=\"onBlur($event);\"\n      (focus)=\"onFocus($event);\"\n      [class.open]=\"showDropDown\"\n      [disabled]=\"disabled\"\n\n      aria-haspopup=\"listbox\"\n\n      [attr.aria-disabled]=\"disabled || null\"\n      [attr.aria-describedby]=\"describedByValue\"\n      [attr.aria-expanded]=\"showDropDown || null\"\n    ></button>\n\n    <div\n      *ngIf=\"!typeaheadConfig?.action || !showDropDown || typeaheadConfig?.pagingOnly\"\n      class=\"selected\"\n      [class.readonly]=\"readonly\"\n      [class.disabled]=\"disabled\"\n      [class.icon-up-caret]=\"showDropDown\"\n      [class.icon-down-caret]=\"!showDropDown\"\n      aria-hidden=\"true\"\n      role=\"presentation\"\n    >\n      <div\n        class=\"select-item\"\n        [class.hide-desc]=\"hideSelectedDescription\"\n        [class.truncate-text]=\"truncateSelectedText\"\n        id=\"{{inputId}}-value\"\n      >\n        <sumday-select-item [item]=\"selected\">\n          {{ (!selected && placeholder) ? placeholder : '' }}\n        </sumday-select-item>\n      </div>\n    </div>\n\n  </div>\n\n  <div class=\"screen-reader-only\" aria-live=\"polite\" role=\"status\">\n    <span *ngIf=\"loading\">searching, please wait</span>\n  </div>\n\n  <ul\n    #list\n    [id]=\"inputId\"\n    attr.aria-labelledby=\"{{inputId}}-label\"\n    class=\"select-list\"\n    [class.overlay]=\"overlay\"\n    [class.open-up]=\"openUp\"\n    [class.hide]=\"!showDropDown\"\n    [attr.aria-hidden]=\"!showDropDown\"\n    [hidden]=\"!showDropDown\"\n    [attr.aria-activedescendant]=\"getSelectedId()\"\n    (scroll)=\"listScroll($event)\"\n    role=\"listbox\"\n    aria-live=\"polite\"\n    [attr.aria-expanded]=\"showDropDown\"\n  >\n    <ng-container *ngIf=\"typeaheadConfig?.action && selectList.length === 0 && loading && typeaheadConfig?.pagingOnly\">\n      <li role=\"option\" class=\"typeahead-message\" *ngIf=\"input?.value.length < typeaheadConfig?.minSearchLength\" role=\"presentation\">\n        <sumday-select-item>\n          {{ typeaheadConfig?.noInputText }}\n        </sumday-select-item>\n      </li>\n\n      <li class=\"typeahead-message\" *ngIf=\"input?.value.length >= typeaheadConfig?.minSearchLength && !typing\" role=\"presentation\">\n        <sumday-select-item>\n          {{ typeaheadConfig?.noResultsText }}\n        </sumday-select-item>\n      </li>\n    </ng-container>\n\n    <li *ngFor=\"let item of selectList; let i = index\" role=\"presentation\">\n      <a\n        id=\"{{ inputId }}_option-{{i}}\"\n        class=\"select-item\"\n        role=\"option\"\n        [attr.tabindex]=\"(i === focusedIndex) ? '0' : '-1'\"\n        [attr.aria-selected]=\"(item?.value === selected?.value) || null\"\n        (keydown)=\"handleItemKeys($event)\"\n        (click)=\"changeValue(item)\"\n        (focus)=\"changeFocus(item)\"\n        (mouseenter)=\"focusItem(i)\"\n      >\n        <sumday-select-item [item]=\"item\"></sumday-select-item>\n      </a>\n    </li>\n\n    <ng-container *ngIf=\"typeaheadConfig?.action && !loading && selectList.length > 0\">\n      <li class=\"typeahead-message typeahead-load-more\" *ngIf=\"!loadingMore && canLoadMore\" role=\"presentation\">\n        <a\n          class=\"select-item\"\n          role=\"option\"\n          [attr.tabindex]=\"(selectList.length === focusedIndex) ? '0' : '-1'\"\n          (keydown)=\"handleItemKeys($event)\"\n          (click)=\"loadMore($event)\"\n          (focus)=\"changeFocus()\"\n          (mouseenter)=\"focusItem(selectList.length)\"\n        >\n          <sumday-select-item\n            [item]=\"{ value: typeaheadConfig?.loadMoreText, icon: 'icon-plus' }\"\n          ></sumday-select-item>\n        </a>\n      </li>\n      <li class=\"typeahead-message\" *ngIf=\"loadingMore\" role=\"presentation\">\n        <sumday-select-item\n          [item]=\"{ value: typeaheadConfig?.loadingMoreText, icon: 'icon-loading' }\"\n        ></sumday-select-item>\n      </li>\n    </ng-container>\n  </ul>\n\n  <div class=\"screen-reader-only\" aria-live=\"polite\" role=\"status\">\n    <span *ngIf=\"loading\">Searching, please wait.</span>\n    <span *ngIf=\"loadingMore\">Loading more, please wait.</span>\n  </div>\n\n  <div [id]=\"typeaheadInstructionsId\" class=\"screen-reader-only\">This is a typeahead search field.  Start typing and wait for results.  Use up and down arrows to highlight an item and use space bar or enter to select an item.</div>\n\n  <select\n    class=\"select-proxy\"\n    [attr.autocomplete]=\"autocomplete\"\n    (change)=\"nativeSelectChanged($event)\"\n  >\n    <option\n      *ngFor=\"let item of selectList\"\n      [attr.value]=\"item?.value\"\n    >\n      {{ item?.text }}\n    </option>\n  </select>\n</div>\n\n<div\n  *ngIf=\"useInternalErrorMessage\"\n  [id]=\"errorMessageId\"\n>\n  <ng-content *ngIf=\"!errorMessageMappings\" select=\"sumday-validations, sumday-validation-error, .validation, [validation]\"></ng-content>\n  <sumday-validations *ngIf=\"errorMessageMappings\" [errorMessageMappings]=\"errorMessageMappings[formControlName]\" [fieldParams]=\"fieldParams\"></sumday-validations>\n</div>\n" }]
    }], function () { return [{ type: i1.WindowRefService }, { type: ModalService }]; }, { inputRef: [{
            type: ViewChild,
            args: ['input', { static: false }]
        }], buttonRef: [{
            type: ViewChild,
            args: ['button', { static: false }]
        }], listRef: [{
            type: ViewChild,
            args: ['list', { static: false }]
        }], readonly: [{
            type: Input
        }], disabled: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], ariaDescribedBy: [{
            type: Input
        }], errorMessageId: [{
            type: Input
        }], extraLabelClass: [{
            type: Input
        }], errorMessageMappings: [{
            type: Input
        }], fieldParams: [{
            type: Input
        }], id: [{
            type: Input
        }], overlay: [{
            type: Input
        }], showDropDown: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], normalDescription: [{
            type: Input
        }], hideSelectedDescription: [{
            type: Input
        }], truncateSelectedText: [{
            type: Input
        }], formControl: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], list: [{
            type: Input
        }], value: [{
            type: Input
        }], selected: [{
            type: Output
        }], blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], change: [{
            type: Output
        }], windowClickHandler: [{
            type: HostListener,
            args: ['document:click', ['$event', '$event.target']]
        }] }); })();

const _c0$q = ["list"];
function SelectListComponent_ng_container_2_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 5)(1, "sumday-select-item");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.typeaheadConfig == null ? null : ctx_r4.typeaheadConfig.noInputText, " ");
} }
function SelectListComponent_ng_container_2_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 5)(1, "sumday-select-item");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.typeaheadConfig == null ? null : ctx_r5.typeaheadConfig.noResultsText, " ");
} }
function SelectListComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SelectListComponent_ng_container_2_li_1_Template, 3, 1, "li", 4);
    i0.ɵɵtemplate(2, SelectListComponent_ng_container_2_li_2_Template, 3, 1, "li", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r1.inputRef == null ? null : ctx_r1.inputRef.nativeElement.value.length) < (ctx_r1.typeaheadConfig == null ? null : ctx_r1.typeaheadConfig.minSearchLength));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r1.inputRef == null ? null : ctx_r1.inputRef.nativeElement.value.length) >= (ctx_r1.typeaheadConfig == null ? null : ctx_r1.typeaheadConfig.minSearchLength) && !ctx_r1.typing);
} }
function SelectListComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 6)(1, "a", 7);
    i0.ɵɵlistener("keydown", function SelectListComponent_li_3_Template_a_keydown_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.handleItemKeys($event)); })("click", function SelectListComponent_li_3_Template_a_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const item_r6 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.changeValue(item_r6)); });
    i0.ɵɵelement(2, "sumday-select-item", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("focus", i_r7 === ctx_r2.focusedIndex);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r2.inputId, "_option-", i_r7, "");
    i0.ɵɵattribute("tabindex", i_r7 === ctx_r2.focusedIndex ? 0 : -1)("aria-selected", item_r6.value === (ctx_r2.selected == null ? null : ctx_r2.selected.value) || null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("item", item_r6);
} }
const _c1$h = function (a0) { return { value: a0, icon: "icon-plus" }; };
function SelectListComponent_ng_container_4_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 5)(1, "a", 9);
    i0.ɵɵlistener("keydown", function SelectListComponent_ng_container_4_li_1_Template_a_keydown_1_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.handleItemKeys($event)); })("click", function SelectListComponent_ng_container_4_li_1_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.loadMore($event)); })("focus", function SelectListComponent_ng_container_4_li_1_Template_a_focus_1_listener() { i0.ɵɵrestoreView(_r14); const ctx_r16 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r16.changeFocus()); })("mouseenter", function SelectListComponent_ng_container_4_li_1_Template_a_mouseenter_1_listener() { i0.ɵɵrestoreView(_r14); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.focusItem(ctx_r17.selectList.length)); });
    i0.ɵɵelement(2, "sumday-select-item", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("tabindex", ctx_r11.selectList.length === ctx_r11.focusedIndex ? "0" : "-1");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("item", i0.ɵɵpureFunction1(2, _c1$h, ctx_r11.typeaheadConfig == null ? null : ctx_r11.typeaheadConfig.loadMoreText));
} }
const _c2$4 = function (a0) { return { value: a0, icon: "icon-loading" }; };
function SelectListComponent_ng_container_4_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 5);
    i0.ɵɵelement(1, "sumday-select-item", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("item", i0.ɵɵpureFunction1(1, _c2$4, ctx_r12.typeaheadConfig == null ? null : ctx_r12.typeaheadConfig.loadingMoreText));
} }
function SelectListComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SelectListComponent_ng_container_4_li_1_Template, 3, 4, "li", 4);
    i0.ɵɵtemplate(2, SelectListComponent_ng_container_4_li_2_Template, 2, 3, "li", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.loadingMore && ctx_r3.canLoadMore);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.loadingMore);
} }
let currentlyOpenSelect; // Keeps track if which select is open, globally
class SelectListComponent extends BaseTraversableComponent {
    set list(list) {
        // Build the optional properties and defaults for our list
        for (let item of list) {
            // Text is the value if one isn't provided
            item.text = item.text || item.value;
        }
        // Save the result
        this.selectList = list;
    }
    set listShowDropdown(show) {
        if (show !== this.dropdown) {
            this.toggleDropdown(show);
        }
    }
    windowClickHandler(event, targetElement) {
        if (this.dropdown) {
            // Only close it if the click isn't on a input/select element
            if (targetElement !== this.inputRef.nativeElement) {
                this.toggleDropdown(false, false);
            }
        }
    }
    constructor(window) {
        super();
        this.window = window;
        this.selectList = [];
        this.openUp = false;
        this.dropdown = false;
        this.loopFocus = false;
        this.traversableList = 'selectList';
        this.readonly = false;
        this.disabled = false;
        this.checkDirection = true;
        this.overlay = true;
        this.autoFocus = true;
        this.iconRight = false;
        this.normalDescription = false;
        this.hideSelectedDescription = false;
        this.select = new EventEmitter();
        this.toggle = new EventEmitter();
        this.escape = new EventEmitter();
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.handleKeys = ($event) => {
            switch ($event.keyCode) {
                case KeyCodes.ARROW_DOWN:
                case KeyCodes.ARROW_UP:
                    $event.preventDefault();
                    if (!this.dropdown) {
                        this.toggleDropdown(true);
                    }
                    else {
                        this.traverseList($event.keyCode === KeyCodes.ARROW_UP ? -1 : 1, $event);
                    }
                    break;
                case KeyCodes.TAB:
                    $event.stopPropagation();
                    if (this.dropdown) {
                        this.escape.emit(false);
                    }
                    break;
                case KeyCodes.ENTER:
                case KeyCodes.SPACEBAR:
                    if (this.focusedIndex >= 0) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        this.changeValue(this.selectList[this.focusedIndex]);
                    }
                    else {
                        if (!this.dropdown) {
                            this.toggleDropdown();
                        }
                    }
                    break;
                case KeyCodes.ESC:
                    $event.stopPropagation();
                    this.escape.emit(true);
                    break;
            }
        };
        this.handleItemKeys = ($event) => {
            switch ($event.keyCode) {
                case KeyCodes.ARROW_DOWN:
                case KeyCodes.ARROW_UP:
                    $event.preventDefault();
                    this.traverseList($event.keyCode === KeyCodes.ARROW_UP ? -1 : 1, $event);
                    break;
                case KeyCodes.ENTER:
                case KeyCodes.SPACEBAR:
                    $event.preventDefault();
                    $event.stopPropagation();
                    $event.currentTarget.click();
                    break;
                case KeyCodes.ESC:
                    this.escape.emit(true);
                    break;
                case KeyCodes.TAB:
                    this.escape.emit(false);
                    break;
            }
        };
    }
    toggleDropdown(show = !this.dropdown, refocus = true) {
        // Don't do anything if we don't have any list items or its disabled
        if (!this.selectList || this.selectList.length === 0 || this.disabled || this.readonly) {
            return;
        }
        this.dropdown = show;
        if (this.dropdown) {
            // Close any open dropdowns and set this as the new active one
            if (currentlyOpenSelect) {
                currentlyOpenSelect.toggleDropdown(false);
            }
            currentlyOpenSelect = this;
            this.direction();
            if (this.selectedIndex || this.autoFocus) {
                this.focusItem(this.selectedIndex || 0, true);
            }
        }
        else {
            currentlyOpenSelect = null;
            this.focusedIndex = null;
        }
        this.toggle.emit(this.dropdown);
    }
    direction() {
        // If the input is below the midpoint of the page, open the list upward if it's an overlay
        this.openUp = this.checkDirection
            && this.listRef.nativeElement.getBoundingClientRect().top > this.window.nativeWindow.innerHeight * .7;
    }
    focusItem(index = 0, scrollTo = true) {
        setTimeout(() => {
            let parentUl = this.listRef.nativeElement;
            let targetLi = parentUl.children[index];
            if (targetLi) {
                if (scrollTo) {
                    // Scroll to the selected item, trying to keep it in the middle of the list
                    parentUl.scrollTop = targetLi.offsetTop - parentUl.offsetTop - (parentUl.offsetHeight / 2);
                }
                // Focus it if there's something focusable there
                let focusableElement = targetLi.querySelector('a');
                if (focusableElement) {
                    focusableElement.focus();
                    this.focusedIndex = index;
                }
            }
        }, 50);
    }
    changeFocus(item) {
        if (item) {
            this.focusedIndex = this.selectList.indexOf(item);
        }
        else if (this.canLoadMore) {
            // If we don't pass an item and we can load more, then it's the Load More link
            this.focusedIndex = this.selectList.length;
        }
        if (this.focusedIndex < 0) {
            this.focusedIndex = null;
        }
    }
    changeValue(item) {
        // Confirms that the value is in our list
        let itemIndex = this.selectList.indexOf(item);
        if (itemIndex >= 0) {
            this.selectedIndex = itemIndex;
            this.select.emit(item);
            // If the dropdown is open, hide it
            if (this.dropdown) {
                this.toggleDropdown(false);
            }
        }
        else {
            this.selectedIndex = null;
            this.select.emit(null);
        }
    }
    getSelectedId() {
        if (!this.selectList) {
            return null;
        }
        return (this.selectedIndex !== null && this.selectedIndex > -1) ? `${this.inputId}_option-${this.selectedIndex}` : null;
    }
    static { this.ɵfac = function SelectListComponent_Factory(t) { return new (t || SelectListComponent)(i0.ɵɵdirectiveInject(i1.WindowRefService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectListComponent, selectors: [["sumday-select-list"]], viewQuery: function SelectListComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$q, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listRef = _t.first);
        } }, hostBindings: function SelectListComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function SelectListComponent_click_HostBindingHandler($event) { return ctx.windowClickHandler($event, $event.target); }, false, i0.ɵɵresolveDocument);
        } }, inputs: { inputId: "inputId", readonly: "readonly", disabled: "disabled", checkDirection: "checkDirection", overlay: "overlay", autoFocus: "autoFocus", iconRight: "iconRight", normalDescription: "normalDescription", hideSelectedDescription: "hideSelectedDescription", list: "list", listShowDropdown: "listShowDropdown" }, outputs: { select: "select", toggle: "toggle", escape: "escape", blur: "blur", focus: "focus" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 14, consts: [["aria-live", "polite", "role", "listbox", 1, "select-list", 3, "id", "hidden"], ["list", ""], [4, "ngIf"], ["role", "presentation", 4, "ngFor", "ngForOf"], ["class", "typeahead-message", "role", "presentation", 4, "ngIf"], ["role", "presentation", 1, "typeahead-message"], ["role", "presentation"], ["role", "option", 1, "select-item", 3, "id", "keydown", "click"], [3, "item"], ["role", "option", 1, "select-item", 3, "keydown", "click", "focus", "mouseenter"]], template: function SelectListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "ul", 0, 1);
            i0.ɵɵtemplate(2, SelectListComponent_ng_container_2_Template, 3, 2, "ng-container", 2);
            i0.ɵɵtemplate(3, SelectListComponent_li_3_Template, 3, 7, "li", 3);
            i0.ɵɵtemplate(4, SelectListComponent_ng_container_4_Template, 3, 2, "ng-container", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵclassProp("overlay", ctx.overlay)("open-up", ctx.openUp)("hide", !ctx.dropdown);
            i0.ɵɵattributeInterpolate1("aria-labelledby", "", ctx.inputId, "-label");
            i0.ɵɵproperty("id", ctx.inputId)("hidden", !ctx.dropdown);
            i0.ɵɵattribute("aria-hidden", !ctx.dropdown)("aria-activedescendant", ctx.getSelectedId());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", (ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.action) && ctx.selectList.length === 0 && ctx.loading && (ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.pagingOnly));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.selectList);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.action) && !ctx.loading && ctx.selectList.length > 0);
        } }, dependencies: [i1$1.NgForOf, i1$1.NgIf, SelectItemComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectListComponent, [{
        type: Component,
        args: [{ selector: 'sumday-select-list', template: "<ul\n  #list\n  [id]=\"inputId\"\n  class=\"select-list\"\n  [class.overlay]=\"overlay\"\n  [class.open-up]=\"openUp\"\n  [class.hide]=\"!dropdown\"\n  [hidden]=\"!dropdown\"\n  [attr.aria-hidden]=\"!dropdown\"\n  [attr.aria-activedescendant]=\"getSelectedId()\"\n  attr.aria-labelledby=\"{{inputId}}-label\"\n  aria-live=\"polite\"\n  role=\"listbox\"\n>\n  <ng-container *ngIf=\"typeaheadConfig?.action && selectList.length === 0 && loading && typeaheadConfig?.pagingOnly\">\n    <li class=\"typeahead-message\" *ngIf=\"inputRef?.nativeElement.value.length < typeaheadConfig?.minSearchLength\" role=\"presentation\">\n      <sumday-select-item>\n        {{ typeaheadConfig?.noInputText }}\n      </sumday-select-item>\n    </li>\n\n    <li class=\"typeahead-message\" *ngIf=\"inputRef?.nativeElement.value.length >= typeaheadConfig?.minSearchLength && !typing\" role=\"presentation\">\n      <sumday-select-item>\n        {{ typeaheadConfig?.noResultsText }}\n      </sumday-select-item>\n    </li>\n  </ng-container>\n\n  <li *ngFor=\"let item of selectList; let i = index\" role=\"presentation\">\n    <a\n      id=\"{{ inputId }}_option-{{i}}\"\n      class=\"select-item\"\n      role=\"option\"\n      [attr.tabindex]=\"(i === focusedIndex) ? 0 : -1\"\n      [attr.aria-selected]=\"(item.value === selected?.value) || null\"\n      (keydown)=\"handleItemKeys($event)\"\n      [class.focus]=\"i === focusedIndex\"\n      (click)=\"changeValue(item)\"\n    >\n      <sumday-select-item [item]=\"item\"></sumday-select-item>\n    </a>\n\n  </li>\n\n  <ng-container *ngIf=\"typeaheadConfig?.action && !loading && selectList.length > 0\">\n    <li class=\"typeahead-message\" *ngIf=\"!loadingMore && canLoadMore\" role=\"presentation\">\n      <a\n        class=\"select-item\"\n        role=\"option\"\n        [attr.tabindex]=\"(selectList.length === focusedIndex) ? '0' : '-1'\"\n        (keydown)=\"handleItemKeys($event)\"\n        (click)=\"loadMore($event)\"\n        (focus)=\"changeFocus()\"\n        (mouseenter)=\"focusItem(selectList.length)\"\n      >\n        <sumday-select-item\n          [item]=\"{ value: typeaheadConfig?.loadMoreText, icon: 'icon-plus' }\"\n        ></sumday-select-item>\n      </a>\n    </li>\n    <li class=\"typeahead-message\" *ngIf=\"loadingMore\" role=\"presentation\">\n      <sumday-select-item\n        [item]=\"{ value: typeaheadConfig?.loadingMoreText, icon: 'icon-loading' }\"\n      ></sumday-select-item>\n    </li>\n  </ng-container>\n</ul>\n" }]
    }], function () { return [{ type: i1.WindowRefService }]; }, { listRef: [{
            type: ViewChild,
            args: ['list', { static: false }]
        }], inputId: [{
            type: Input
        }], readonly: [{
            type: Input
        }], disabled: [{
            type: Input
        }], checkDirection: [{
            type: Input
        }], overlay: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], normalDescription: [{
            type: Input
        }], hideSelectedDescription: [{
            type: Input
        }], list: [{
            type: Input
        }], listShowDropdown: [{
            type: Input
        }], select: [{
            type: Output
        }], toggle: [{
            type: Output
        }], escape: [{
            type: Output
        }], blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], windowClickHandler: [{
            type: HostListener,
            args: ['document:click', ['$event', '$event.target']]
        }] }); })();

const _c0$p = ["input"];
const _c1$g = ["list"];
function TextComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.prefix);
} }
function TextComponent_input_7_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 12, 13);
    i0.ɵɵlistener("focus", function TextComponent_input_7_Template_input_focus_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.onFocus($event)); })("blur", function TextComponent_input_7_Template_input_blur_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.onBlur($event)); })("input", function TextComponent_input_7_Template_input_input_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.onInput($event)); })("change", function TextComponent_input_7_Template_input_change_0_listener() { i0.ɵɵrestoreView(_r14); const _r12 = i0.ɵɵreference(1); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.onChange(_r12.value)); })("keyup", function TextComponent_input_7_Template_input_keyup_0_listener() { i0.ɵɵrestoreView(_r14); const _r12 = i0.ɵɵreference(1); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.onChange(_r12.value)); })("keydown", function TextComponent_input_7_Template_input_keydown_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.handleKeys($event)); })("paste", function TextComponent_input_7_Template_input_paste_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.onPaste($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("has-icon", ctx_r1.icon)("has-left-icon", ctx_r1.iconLeft);
    i0.ɵɵproperty("id", ctx_r1.inputId)("type", ctx_r1.type)("value", ctx_r1.value !== undefined && ctx_r1.value !== null ? ctx_r1.value : "")("readonly", ctx_r1.readonly || null)("disabled", ctx_r1.disabled || null)("textMask", ctx_r1.mask)("required", ctx_r1.required || null);
    i0.ɵɵattribute("name", ctx_r1.formControlName)("autocomplete", ctx_r1.autocomplete)("placeholder", ctx_r1.placeholder)("aria-disabled", ctx_r1.disabled || null)("aria-label", ctx_r1.ariaLabel)("aria-describedby", ctx_r1.describedByValue)("minlength", ctx_r1.minLength)("maxlength", ctx_r1.maxLength);
} }
function TextComponent_textarea_8_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "textarea", 14, 13);
    i0.ɵɵlistener("focus", function TextComponent_textarea_8_Template_textarea_focus_0_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22.onFocus($event)); })("blur", function TextComponent_textarea_8_Template_textarea_blur_0_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r24.onBlur($event)); })("input", function TextComponent_textarea_8_Template_textarea_input_0_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r25.onInput($event)); })("change", function TextComponent_textarea_8_Template_textarea_change_0_listener() { i0.ɵɵrestoreView(_r23); const _r21 = i0.ɵɵreference(1); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.onChange(_r21.value)); })("keyup", function TextComponent_textarea_8_Template_textarea_keyup_0_listener() { i0.ɵɵrestoreView(_r23); const _r21 = i0.ɵɵreference(1); const ctx_r27 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r27.onChange(_r21.value)); })("keydown", function TextComponent_textarea_8_Template_textarea_keydown_0_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r28 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r28.handleKeys($event)); })("paste", function TextComponent_textarea_8_Template_textarea_paste_0_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r29 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r29.onPaste($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("has-icon", ctx_r2.icon)("has-left-icon", ctx_r2.iconLeft);
    i0.ɵɵproperty("id", ctx_r2.inputId)("value", ctx_r2.value !== undefined && ctx_r2.value !== null ? ctx_r2.value : "")("readonly", ctx_r2.readonly || null)("disabled", ctx_r2.disabled || null)("textMask", ctx_r2.mask)("required", ctx_r2.required || null);
    i0.ɵɵattribute("name", ctx_r2.formControlName)("autocomplete", (ctx_r2.typeaheadConfig == null ? null : ctx_r2.typeaheadConfig.action) ? "off" : ctx_r2.autocomplete)("placeholder", ctx_r2.placeholder)("aria-disabled", ctx_r2.disabled || null)("aria-label", ctx_r2.ariaLabel)("aria-describedby", ctx_r2.describedByValue)("minlength", ctx_r2.minLength)("maxlength", ctx_r2.maxLength);
} }
function TextComponent_span_9_ng_content_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 5, ["*ngIf", "injectSuffix"]);
} }
function TextComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, TextComponent_span_9_ng_content_2_Template, 1, 0, "ng-content", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.suffix);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.injectSuffix);
} }
function TextComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r4.formatTextId);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.maskingFormatText[ctx_r4.maskKey], " ");
} }
function TextComponent_ng_content_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 6, ["*ngIf", "!injectSuffix"]);
} }
function TextComponent_sumday_select_list_13_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sumday-select-list", 17, 18);
    i0.ɵɵlistener("select", function TextComponent_sumday_select_list_13_Template_sumday_select_list_select_0_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r32.onSelect($event)); })("toggle", function TextComponent_sumday_select_list_13_Template_sumday_select_list_toggle_0_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r34 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r34.onToggleDropdown($event)); })("escape", function TextComponent_sumday_select_list_13_Template_sumday_select_list_escape_0_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r35 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r35.onEscapeDropdown($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("list", ctx_r6.selectList)("autoFocus", false)("checkDirection", false)("listShowDropdown", ctx_r6.showDropdown)("inputRef", ctx_r6.inputRef)("typeaheadConfig", ctx_r6.typeaheadConfig)("loading", ctx_r6.loading)("loadingMore", ctx_r6.loadingMore)("canLoadMore", ctx_r6.canLoadMore);
} }
function TextComponent_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Searching, please wait.");
    i0.ɵɵelementEnd();
} }
function TextComponent_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Loading more, please wait.");
    i0.ɵɵelementEnd();
} }
function TextComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, "This is a typeahead search field. Start typing and wait for results. Use up and down arrows to highlight an item and use space bar or enter to select an item.");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r9.typeaheadInstructionsId);
} }
function TextComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("color-plum", ctx_r10.getCharsRemaining() > 5)("color-red", ctx_r10.getCharsRemaining() <= 5);
    i0.ɵɵattribute("id", ctx_r10.charsRemainingId)("aria-live", ctx_r10.getAriaLiveValue());
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.getCharsRemaining(), " characters left\n");
} }
function TextComponent_div_20_ng_content_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 7, ["*ngIf", "!errorMessageMappings"]);
} }
function TextComponent_div_20_sumday_validations_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sumday-validations", 21);
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("errorMessageMappings", ctx_r37.errorMessageMappings[ctx_r37.formControlName || (ctx_r37.control == null ? null : ctx_r37.control.name)])("fieldParams", ctx_r37.fieldParams);
} }
function TextComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, TextComponent_div_20_ng_content_1_Template, 1, 0, "ng-content", 7);
    i0.ɵɵtemplate(2, TextComponent_div_20_sumday_validations_2_Template, 1, 2, "sumday-validations", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", ctx_r11.errorMessageId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r11.errorMessageMappings);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.errorMessageMappings);
} }
const _c2$3 = ["*", [["", "after-label", ""]], [["", "prefix", ""]], [["", "side-section", ""]], [["", "after-section", ""]], [["", "suffix", ""]], [["", "suffix", ""]], [["sumday-validations"], ["sumday-validation-error"], ["", 8, "validation"], ["", "validation", ""]]];
const _c3$2 = ["*", "[after-label]", "[prefix]", "[side-section]", "[after-section]", "[suffix]", "[suffix]", "sumday-validations, sumday-validation-error, .validation, [validation]"];
let id$7 = 0;
class TextComponent extends BaseTypeahead {
    set id(setId) {
        if (setId) {
            this.inputId = `${setId}-input`;
        }
    }
    set mask(key) {
        if (typeof key === 'object') {
            this.maskConfig = key;
            return;
        }
        else {
            this.maskKey = key;
        }
        this.maskConfig = TextMasks.getMask(key, this.maxLength);
    }
    get mask() {
        if (!this.maskConfig) {
            // [textMask] doesn't handle undefined/null so we have to return a default mask that does nothing
            this.maskConfig = TextMasks.getMask(undefined);
        }
        return this.maskConfig;
    }
    set unmask(unmask) {
        if (this.maskConfig) {
            // If it's a function, use it, otherwise just passthrough
            this.maskConfig.unmask = typeof unmask === 'function'
                ? unmask
                : (value) => value;
        }
    }
    constructor(controlContainer, cd) {
        super();
        this.cd = cd;
        this.inputId = `text-${id$7++}-input`;
        this.typeaheadInstructionsId = `${this.inputId}-typeahead-instructions`;
        this.required = false;
        this.useInternalErrorMessage = false;
        // we use this as an extra for screen readers
        this.maskingFormatText = {
            'ssn': 'format 123-45-6789',
            'currency': 'format $12.34 ',
            'date': 'format 07/16/2018',
            'phone': 'format 123-456-7890',
            'postal-code': 'format 12345',
            'whole-number': 'enter a whole number'
        };
        this.type = 'text';
        this.readonly = false;
        this.disabled = false;
        this.autocomplete = null;
        this.maxLength = null;
        this.minLength = null;
        this.ariaLabel = null;
        this.errorMessageId = null;
        this.counter = false;
        this.injectSuffix = false;
        this.extraLabelClass = '';
        this.icon = '';
        this.iconLeft = false;
        this.value = '';
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.change = new EventEmitter();
        this.input = new EventEmitter();
        this.onChangeCallback = () => { };
        this.onTouchedCallback = () => { };
        this.handleKeys = ($event) => {
            if (this.listRef && this.selectList && this.selectList.length > 0) {
                this.listRef.handleKeys($event);
                switch ($event.keyCode) {
                    case KeyCodes.ARROW_DOWN:
                    case KeyCodes.ARROW_UP:
                        $event.preventDefault();
                        this.showDropdown = true;
                        break;
                    case KeyCodes.ESC:
                        this.showDropdown = false;
                        break;
                }
            }
        };
        this.controlContainer = controlContainer;
    }
    ngOnInit() {
        if (!this.errorMessageId) {
            this.errorMessageId = `${this.inputId}-error`;
            this.useInternalErrorMessage = true;
        }
        if (this.maskKey) {
            this.formatTextId = `${this.inputId}-format-text`;
        }
        if (this.counter && this.maxLength) {
            this.charsRemainingId = `${this.inputId}-remaining`;
        }
        this.describedByValue = this.getDescribedByValue();
        // Gets the form control so we can check touched/dirty for aria-live check on the counter
        if (!this.control && this.counter) {
            if (this.formControl) {
                this.control = this.formControl;
            }
            else if (this.controlContainer) {
                if (this.formControlName) {
                    this.control = this.controlContainer.control.get(this.formControlName);
                }
                else {
                    isDevMode() && console.warn(`Missing FormControlName directive from sumday-text component`);
                }
            }
            else {
                isDevMode() && console.warn(`Can't find parent FormGroup directive of sumday-text component`);
            }
            if (this.control) {
                this.required = hasRequiredField(this.control);
                this.control.statusChanges.subscribe(change => {
                    this.required = hasRequiredField(this.control);
                });
            }
        }
    }
    postOnChanges(changes) {
        let { mask: maskChanges, typeaheadConfig: typeaheadConfigChanges, } = changes;
        if ((typeaheadConfigChanges
            && typeaheadConfigChanges.currentValue
            && typeaheadConfigChanges.currentValue.action)
            || (maskChanges
                && maskChanges.currentValue === 'ssn')) {
            this.autocomplete = 'off';
        }
    }
    getDescribedByValue() {
        let ids = [this.errorMessageId];
        if (this.formatTextId) {
            ids.push(this.formatTextId);
        }
        if (this.charsRemainingId) {
            ids.push(this.charsRemainingId);
        }
        if (this.extraDescribedBy) {
            ids.push(this.extraDescribedBy);
        }
        // there is always a default, but if there is no action set we don't want this set
        if (this.typeaheadConfig?.action) {
            ids.push(this.typeaheadInstructionsId);
        }
        return ids.join(' ');
    }
    getCharsRemaining() {
        return this.maxLength - (this.value || '').length;
    }
    getAriaLiveValue() {
        // for some reason just touching wont update the element until blur
        // so we are checking dirty as well so that it will flip when they
        // start typing -- @crob
        // We should see if we can just do this with change and focus events instead -- @ytilis
        return this.control && (this.control.dirty || this.control.touched) ? 'polite' : 'off';
    }
    touch() {
        if (this.onTouchedCallback && !this.disabled && !this.readonly) {
            this.onTouchedCallback();
        }
    }
    emitNewValue(value) {
        this.change.emit(value);
        this.input.emit(value);
        if (this.onChangeCallback) {
            this.onChangeCallback(value);
        }
    }
    onPaste(event) {
        const value = event.clipboardData.getData('text');
        this.emitNewValue(value);
    }
    onChange(value) {
        if (this.value !== value) {
            // Save the raw input value for display
            if (this.maxLength && this.maxLength > 0 && value && value.length > this.maxLength) {
                this.value = value.substring(0, this.maxLength);
            }
            else {
                this.value = value;
            }
            // Propagate the unmasked value to the FormControl instead of the raw value if we want to unmask it
            let unmaskedValue = (this.maskConfig && this.maskConfig.unmask)
                ? this.maskConfig.unmask(value)
                : value;
            if (this.selectList) {
                // Filter out any non-matching items preemptively, so we don't show them while loading more
                this.selectList = this.selectList.filter(item => item.value.includes(value));
            }
            this.emitNewValue(unmaskedValue);
        }
    }
    onBlur(event) {
        this.touch();
        if (this.value && typeof (this.value.trim) === 'function') {
            let trimmed = this.value.trim();
            if (trimmed !== this.value) {
                this.onChange(trimmed);
            }
        }
        setTimeout(() => {
            // if there is a dropdown and its closed or isnt focused to any item then
            // we can close on blur, otherwise we have to let the dropdown handle it
            if (this.listRef && (!this.listRef.dropdown || isNaN(this.listRef.focusedIndex))) {
                // We need to delay this or else the dropdown will close before the click event registers
                this.showDropdown = false;
            }
        }, 500);
        this.blur.emit(event);
    }
    onToggleDropdown(value, focus = false) {
        this.showDropdown = value;
        this.cd.detectChanges();
        if (!value && focus) {
            // need to set focus back because it will be lost when the dropdown closes
            this.focusInput();
        }
    }
    onEscapeDropdown(focus) {
        if (focus) {
            this.writeValue('');
        }
        this.onToggleDropdown(false, focus);
    }
    focusInput() {
        // need a small timeout for screenreaders
        setTimeout(this.inputRef.nativeElement.focus(), 100);
    }
    onSelect(event) {
        if (event && event.value) {
            this.writeValue(event.value);
        }
        // need to set focus back because it will be lost when the dropdown closes
        this.focusInput();
    }
    onFocus(event) {
        this.showDropdown = true;
        this.cd.detectChanges();
        this.focus.emit(event);
    }
    onInput(event) {
        this.input.emit(event);
    }
    writeValue(value) {
        value = this.applyMask(value);
        // Turn falsey values (null, undefined, false, etc) into empty strings
        value = value || '';
        this.onChange(value);
    }
    applyMask(value) {
        let isString = typeof (value) === 'string';
        if (this.maskConfig && this.maskConfig.mask &&
            value !== null && value !== undefined &&
            ((isString && value.length > 0) || !isString)) {
            let mask = this.maskConfig.mask;
            if (typeof (mask) === 'function') {
                mask = mask;
                mask = mask(`${value}`);
                // hack central - apparently createNumberMask can return [] inside the mask.
                // https://github.com/text-mask/text-mask/issues/492#issuecomment-333632813
                mask = mask.filter(val => val !== '[]');
            }
            let masked = conformToMask(`${value}`, mask, {});
            // if any value was rejected, then we do not want to override the value
            if (!masked.meta.someCharsRejected) {
                value = masked.conformedValue;
            }
        }
        return value;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    static { this.ɵfac = function TextComponent_Factory(t) { return new (t || TextComponent)(i0.ɵɵdirectiveInject(i1$4.ControlContainer, 5), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TextComponent, selectors: [["sumday-text"]], viewQuery: function TextComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$p, 5);
            i0.ɵɵviewQuery(_c1$g, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listRef = _t.first);
        } }, inputs: { formControl: "formControl", formControlName: "formControlName", type: "type", readonly: "readonly", disabled: "disabled", autocomplete: "autocomplete", maxLength: "maxLength", minLength: "minLength", placeholder: "placeholder", ariaLabel: "ariaLabel", errorMessageId: "errorMessageId", counter: "counter", prefix: "prefix", suffix: "suffix", injectSuffix: "injectSuffix", extraLabelClass: "extraLabelClass", icon: "icon", iconLeft: "iconLeft", value: "value", extraDescribedBy: "extraDescribedBy", errorMessageMappings: "errorMessageMappings", fieldParams: "fieldParams", id: "id", mask: "mask", unmask: "unmask" }, outputs: { blur: "blur", focus: "focus", change: "change", input: "input" }, features: [i0.ɵɵProvidersFeature([{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => TextComponent),
                    multi: true
                }]), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c3$2, decls: 21, vars: 25, consts: [[1, "label"], [1, "text-input", 3, "ngClass"], ["class", "prefix", 4, "ngIf"], [3, "id", "type", "value", "readonly", "disabled", "textMask", "required", "has-icon", "has-left-icon", "focus", "blur", "input", "change", "keyup", "keydown", "paste", 4, "ngIf"], [3, "id", "value", "readonly", "disabled", "textMask", "required", "has-icon", "has-left-icon", "focus", "blur", "input", "change", "keyup", "keydown", "paste", 4, "ngIf"], ["class", "suffix", 4, "ngIf"], ["class", "screen-reader-only", 3, "id", 4, "ngIf"], [4, "ngIf"], [3, "list", "autoFocus", "checkDirection", "listShowDropdown", "inputRef", "typeaheadConfig", "loading", "loadingMore", "canLoadMore", "select", "toggle", "escape", 4, "ngIf"], ["aria-live", "polite", "role", "status", 1, "screen-reader-only"], ["class", "input-counter", "aria-atomic", "true", 3, "color-plum", "color-red", 4, "ngIf"], [1, "prefix"], [3, "id", "type", "value", "readonly", "disabled", "textMask", "required", "focus", "blur", "input", "change", "keyup", "keydown", "paste"], ["input", ""], [3, "id", "value", "readonly", "disabled", "textMask", "required", "focus", "blur", "input", "change", "keyup", "keydown", "paste"], [1, "suffix"], [1, "screen-reader-only", 3, "id"], [3, "list", "autoFocus", "checkDirection", "listShowDropdown", "inputRef", "typeaheadConfig", "loading", "loadingMore", "canLoadMore", "select", "toggle", "escape"], ["list", ""], ["aria-atomic", "true", 1, "input-counter"], [3, "errorMessageMappings", "fieldParams", 4, "ngIf"], [3, "errorMessageMappings", "fieldParams"]], template: function TextComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c2$3);
            i0.ɵɵelementStart(0, "label")(1, "span", 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(3, 1);
            i0.ɵɵprojection(4, 2);
            i0.ɵɵelementStart(5, "span", 1);
            i0.ɵɵtemplate(6, TextComponent_span_6_Template, 2, 1, "span", 2);
            i0.ɵɵtemplate(7, TextComponent_input_7_Template, 2, 19, "input", 3);
            i0.ɵɵtemplate(8, TextComponent_textarea_8_Template, 2, 18, "textarea", 4);
            i0.ɵɵtemplate(9, TextComponent_span_9_Template, 3, 2, "span", 5);
            i0.ɵɵprojection(10, 3);
            i0.ɵɵtemplate(11, TextComponent_span_11_Template, 2, 2, "span", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, TextComponent_ng_content_12_Template, 1, 0, "ng-content", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, TextComponent_sumday_select_list_13_Template, 2, 9, "sumday-select-list", 8);
            i0.ɵɵelementStart(14, "div", 9);
            i0.ɵɵtemplate(15, TextComponent_span_15_Template, 2, 0, "span", 7);
            i0.ɵɵtemplate(16, TextComponent_span_16_Template, 2, 0, "span", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(17, TextComponent_div_17_Template, 2, 1, "div", 6);
            i0.ɵɵtemplate(18, TextComponent_div_18_Template, 2, 7, "div", 10);
            i0.ɵɵprojection(19, 4);
            i0.ɵɵtemplate(20, TextComponent_div_20_Template, 3, 3, "div", 7);
        } if (rf & 2) {
            i0.ɵɵattribute("class", ctx.extraLabelClass)("for", ctx.inputId);
            i0.ɵɵadvance(5);
            i0.ɵɵclassProp("icon-loading", ctx.loading)("disabled", ctx.disabled)("readonly", ctx.readonly)("dropdown", ctx.showDropdown)("icon-left", ctx.iconLeft);
            i0.ɵɵproperty("ngClass", ctx.icon && "icon-" + ctx.icon);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.prefix);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.type !== "textarea");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.type === "textarea");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.suffix || ctx.injectSuffix);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.maskKey);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.injectSuffix);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.selectList == null ? null : ctx.selectList.length) > 0);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.loading);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.loadingMore);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.typeaheadConfig == null ? null : ctx.typeaheadConfig.action);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.maxLength && ctx.counter);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.useInternalErrorMessage);
        } }, dependencies: [i1$1.NgClass, i1$1.NgIf, i1.MaskedInputDirective, SelectListComponent, ValidationsComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextComponent, [{
        type: Component,
        args: [{ selector: 'sumday-text', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => TextComponent),
                        multi: true
                    }], template: "<label [attr.class]=\"extraLabelClass\" [attr.for]=\"inputId\">\n  <span class=\"label\"><ng-content></ng-content></span>\n\n  <ng-content select=\"[after-label]\"></ng-content>\n\n  <ng-content select=\"[prefix]\"></ng-content>\n\n  <span\n    class=\"text-input\"\n    [ngClass]=\"icon && ('icon-' + icon)\"\n    [class.icon-loading]=\"loading\"\n    [class.disabled]=\"disabled\"\n    [class.readonly]=\"readonly\"\n    [class.dropdown]=\"showDropdown\"\n    [class.icon-left]=\"iconLeft\"\n  >\n    <span\n      *ngIf=\"prefix\"\n      class=\"prefix\"\n    >{{ prefix }}</span>\n\n    <input *ngIf=\"type !== 'textarea'\"\n      #input\n      [id]=\"inputId\"\n      [type]=\"type\"\n      [value]=\"(value !== undefined && value !== null) ? value : ''\"\n      [readonly]=\"readonly || null\"\n      [disabled]=\"disabled || null\"\n      [textMask]=\"mask\"\n      [attr.name]=\"formControlName\"\n      [attr.autocomplete]=\"autocomplete\"\n      [attr.placeholder]=\"placeholder\"\n      [required]=\"required || null\"\n      [attr.aria-disabled]=\"disabled || null\"\n      [attr.aria-label]=\"ariaLabel\"\n      [attr.aria-describedby]=\"describedByValue\"\n      [attr.minlength]=\"minLength\"\n      [attr.maxlength]=\"maxLength\"\n      [class.has-icon]=\"icon\"\n      [class.has-left-icon]=\"iconLeft\"\n\n      (focus)=\"onFocus($event);\"\n      (blur)=\"onBlur($event);\"\n      (input)=\"onInput($event);\"\n      (change)=\"onChange(input.value);\"\n      (keyup)=\"onChange(input.value);\"\n      (keydown)=\"handleKeys($event);\"\n      (paste)=\"onPaste($event);\"\n    />\n    <textarea *ngIf=\"type === 'textarea'\"\n      #input\n      [id]=\"inputId\"\n      [value]=\"(value !== undefined && value !== null) ? value : ''\"\n      [readonly]=\"readonly || null\"\n      [disabled]=\"disabled || null\"\n      [textMask]=\"mask\"\n      [attr.name]=\"formControlName\"\n      [attr.autocomplete]=\"typeaheadConfig?.action ? 'off' : autocomplete\"\n      [attr.placeholder]=\"placeholder\"\n      [required]=\"required || null\"\n      [attr.aria-disabled]=\"disabled || null\"\n      [attr.aria-label]=\"ariaLabel\"\n      [attr.aria-describedby]=\"describedByValue\"\n      [attr.minlength]=\"minLength\"\n      [attr.maxlength]=\"maxLength\"\n      [class.has-icon]=\"icon\"\n      [class.has-left-icon]=\"iconLeft\"\n\n      (focus)=\"onFocus($event);\"\n      (blur)=\"onBlur($event);\"\n      (input)=\"onInput($event);\"\n      (change)=\"onChange(input.value);\"\n      (keyup)=\"onChange(input.value);\"\n      (keydown)=\"handleKeys($event);\"\n      (paste)=\"onPaste($event);\"\n    ></textarea>\n\n    <span\n      *ngIf=\"suffix || injectSuffix\"\n      class=\"suffix\"\n    >{{ suffix }}<ng-content *ngIf=\"injectSuffix\" select=\"[suffix]\"></ng-content></span>\n\n    <ng-content select=\"[side-section]\"></ng-content>\n\n    <span\n      *ngIf=\"maskKey\"\n      [id]=\"formatTextId\"\n      class=\"screen-reader-only\"\n    >\n      {{maskingFormatText[maskKey]}}\n    </span>\n  </span>\n\n  <ng-content *ngIf=\"!injectSuffix\" select=\"[suffix]\"></ng-content>\n</label>\n\n\n<sumday-select-list\n  #list\n  *ngIf=\"selectList?.length > 0\"\n  [list]=\"selectList\"\n  [autoFocus]=\"false\"\n  [checkDirection]=\"false\"\n  [listShowDropdown]=\"showDropdown\"\n  [inputRef]=\"inputRef\"\n  [typeaheadConfig]=\"typeaheadConfig\"\n  [loading]=\"loading\"\n  [loadingMore]=\"loadingMore\"\n\n  [canLoadMore]=\"canLoadMore\"\n  (select)=\"onSelect($event)\"\n  (toggle)=\"onToggleDropdown($event)\"\n  (escape)=\"onEscapeDropdown($event)\"\n></sumday-select-list>\n\n<div class=\"screen-reader-only\" aria-live=\"polite\" role=\"status\">\n  <span *ngIf=\"loading\">Searching, please wait.</span>\n  <span *ngIf=\"loadingMore\">Loading more, please wait.</span>\n</div>\n\n<div *ngIf=\"typeaheadConfig?.action\" [id]=\"typeaheadInstructionsId\" class=\"screen-reader-only\">This is a typeahead search field.  Start typing and wait for results.  Use up and down arrows to highlight an item and use space bar or enter to select an item.</div>\n\n<div\n  *ngIf=\"maxLength && counter\"\n  [attr.id]=\"charsRemainingId\"\n  class=\"input-counter\"\n  aria-atomic=\"true\"\n  [attr.aria-live]=\"getAriaLiveValue()\"\n  [class.color-plum]=\"getCharsRemaining() > 5\"\n  [class.color-red]=\"getCharsRemaining() <= 5\"\n>\n  {{ getCharsRemaining() }} characters left\n</div>\n\n<ng-content select=\"[after-section]\"></ng-content>\n\n<div *ngIf=\"useInternalErrorMessage\" [attr.id]=\"errorMessageId\">\n  <ng-content *ngIf=\"!errorMessageMappings\" select=\"sumday-validations, sumday-validation-error, .validation, [validation]\"></ng-content>\n  <sumday-validations *ngIf=\"errorMessageMappings\" [errorMessageMappings]=\"errorMessageMappings[formControlName || control?.name]\" [fieldParams]=\"fieldParams\"></sumday-validations>\n</div>\n" }]
    }], function () { return [{ type: i1$4.ControlContainer, decorators: [{
                type: Host
            }, {
                type: SkipSelf
            }] }, { type: i0.ChangeDetectorRef }]; }, { inputRef: [{
            type: ViewChild,
            args: ['input', { static: false }]
        }], listRef: [{
            type: ViewChild,
            args: ['list', { static: false }]
        }], formControl: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], type: [{
            type: Input
        }], readonly: [{
            type: Input
        }], disabled: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], maxLength: [{
            type: Input
        }], minLength: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], errorMessageId: [{
            type: Input
        }], counter: [{
            type: Input
        }], prefix: [{
            type: Input
        }], suffix: [{
            type: Input
        }], injectSuffix: [{
            type: Input
        }], extraLabelClass: [{
            type: Input
        }], icon: [{
            type: Input
        }], iconLeft: [{
            type: Input
        }], value: [{
            type: Input
        }], extraDescribedBy: [{
            type: Input
        }], errorMessageMappings: [{
            type: Input
        }], fieldParams: [{
            type: Input
        }], id: [{
            type: Input
        }], mask: [{
            type: Input
        }], unmask: [{
            type: Input
        }], blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], change: [{
            type: Output
        }], input: [{
            type: Output
        }] }); })();

class StateDropdownDirective {
    set allowMilitary(allowMilitary) {
        this.allowMilitaryState = allowMilitary;
        this.setStates();
    }
    set allowTerritory(allowTerritory) {
        this.allowTerritoryState = allowTerritory;
        this.setStates();
    }
    constructor(parent) {
        this.parent = parent;
        // Note: by default we display all states, including military states and
        // territories. This is because if the selected value is one of these
        // states, the item must already be in the list, even before the setters
        // are called. Otherwise the selected value won't be displayed.
        this.allowMilitaryState = true;
        this.allowTerritoryState = true;
        this.setStates();
    }
    setStates() {
        let statesToDisplay;
        if (this.allowMilitaryState && this.allowTerritoryState) {
            statesToDisplay = statesWithMilitaryAndTerritories;
        }
        else if (this.allowMilitaryState) {
            statesToDisplay = statesWithMilitary;
        }
        else if (this.allowTerritoryState) {
            statesToDisplay = statesWithTerritories;
        }
        else {
            statesToDisplay = states;
        }
        this.parent.list = Object.entries(statesToDisplay).map(([value, text]) => ({ value, text }));
    }
    static { this.ɵfac = function StateDropdownDirective_Factory(t) { return new (t || StateDropdownDirective)(i0.ɵɵdirectiveInject(SelectComponent)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: StateDropdownDirective, selectors: [["", "sumdayStateDropdown", ""]], inputs: { allowMilitary: "allowMilitary", allowTerritory: "allowTerritory" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StateDropdownDirective, [{
        type: Directive,
        args: [{
                selector: '[sumdayStateDropdown]',
            }]
    }], function () { return [{ type: SelectComponent }]; }, { allowMilitary: [{
            type: Input
        }], allowTerritory: [{
            type: Input
        }] }); })();

function AddressComponent_sumday_select_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
} }
function AddressComponent_sumday_select_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sumday-select", 3);
    i0.ɵɵtext(1, " Country ");
    i0.ɵɵelement(2, "sumday-validations", 4);
    i0.ɵɵtemplate(3, AddressComponent_sumday_select_1_div_3_Template, 2, 0, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("readonly", ctx_r0.readonly)("list", ctx_r0.countrySelectItems);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("errorMessageMappings", ctx_r0.errors.countryCode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.countryCode.hasError("i18n"));
} }
function AddressComponent_ng_container_2_sumday_text_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sumday-text", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "sumday-validations", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("readonly", ctx_r3.readonly)("maxLength", 42);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Street address 3 ", ctx_r3.showOptionalText ? "(optional)" : "", " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("errorMessageMappings", ctx_r3.errors.line3);
} }
function AddressComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "sumday-text", 7);
    i0.ɵɵtext(2, " Street address ");
    i0.ɵɵelement(3, "sumday-validations", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "sumday-text", 8);
    i0.ɵɵtext(5);
    i0.ɵɵelement(6, "sumday-validations", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, AddressComponent_ng_container_2_sumday_text_7_Template, 3, 4, "sumday-text", 9);
    i0.ɵɵelementStart(8, "sumday-text", 10);
    i0.ɵɵtext(9, " City ");
    i0.ɵɵelement(10, "sumday-validations", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "sumday-grid", 11)(12, "sumday-grid", 12)(13, "sumday-select", 13);
    i0.ɵɵtext(14, " State ");
    i0.ɵɵelement(15, "sumday-validations", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "sumday-grid", 12)(17, "sumday-text", 14);
    i0.ɵɵtext(18, " ZIP Code ");
    i0.ɵɵelement(19, "sumday-validations", 4);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("readonly", ctx_r1.readonly)("counter", ctx_r1.payeeMode)("maxLength", ctx_r1.payeeMode ? 40 : 42);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("errorMessageMappings", ctx_r1.errors.line1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("readonly", ctx_r1.readonly)("counter", ctx_r1.payeeMode)("maxLength", ctx_r1.payeeMode ? 40 : 42);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Street address 2 ", ctx_r1.showOptionalText ? "(optional)" : "", " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("errorMessageMappings", ctx_r1.errors.line2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showLine3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("readonly", ctx_r1.readonly);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("errorMessageMappings", ctx_r1.errors.city);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("readonly", ctx_r1.readonly)("allowMilitary", ctx_r1.allowMilitary)("allowTerritory", ctx_r1.allowTerritory);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("errorMessageMappings", ctx_r1.errors.stateCode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("readonly", ctx_r1.readonly);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("errorMessageMappings", ctx_r1.errors.postalCode);
} }
const _c0$o = [[["", 8, "i18n"]]];
const _c1$f = [".i18n"];
class AddressComponent {
    get showCountries() {
        return this._showCountries;
    }
    set showCountries(value) {
        this._showCountries = value;
        if (value) {
            this.countryCode.setValidators([
                Validators.required,
                ExtendedValidators.callback(this.i18nSupport, 'i18n')
            ]);
        }
        else {
            this.countryCode.setValidators(null);
        }
    }
    get errors() {
        return Object.entries(this.customErrors)
            .reduce((errors, [fieldName, fieldErrors]) => ({
            ...errors,
            [fieldName]: {
                ...errors[fieldName],
                ...fieldErrors
            }
        }), this.defaultErrors);
    }
    set formGroup(value) {
        this.form = value;
        if (!this.form.contains(this.line1ControlName)) {
            this.form.addControl(this.line1ControlName, this.line1);
        }
        else {
            this.line1 = this.form.get(this.line1ControlName);
        }
        if (!this.form.contains(this.line2ControlName)) {
            this.form.addControl(this.line2ControlName, this.line2);
        }
        else {
            this.line2 = this.form.get(this.line2ControlName);
        }
        if (!this.form.contains(this.line3ControlName)) {
            this.form.addControl(this.line3ControlName, this.line3);
        }
        else {
            this.line3 = this.form.get(this.line3ControlName);
        }
        if (!this.form.contains(this.cityControlName)) {
            this.form.addControl(this.cityControlName, this.city);
        }
        else {
            this.city = this.form.get(this.cityControlName);
        }
        if (!this.form.contains(this.stateCodeControlName)) {
            this.form.addControl(this.stateCodeControlName, this.stateCode);
        }
        else {
            this.stateCode = this.form.get(this.stateCodeControlName);
        }
        if (!this.form.contains(this.countryCodeControlName)) {
            this.form.addControl(this.countryCodeControlName, this.countryCode);
        }
        else {
            this.countryCode = this.form.get(this.countryCodeControlName);
        }
        if (!this.form.contains(this.postalCodeControlName)) {
            this.form.addControl(this.postalCodeControlName, this.postalCode);
        }
        else {
            this.postalCode = this.form.get(this.postalCodeControlName);
        }
    }
    get address() {
        return {
            line1: this.line1.value,
            line2: this.line2.value,
            line3: this.line3.value,
            city: this.city.value,
            stateCode: this.stateCode.value,
            countryCode: this.countryCode.value,
            postalCode: this.postalCode.value
        };
    }
    set address(value) {
        if (!value) {
            return;
        }
        this.line1.patchValue(value.line1);
        this.line1.markAsPristine();
        this.line1.markAsUntouched();
        this.line1.updateValueAndValidity();
        this.line2.patchValue(value.line2);
        this.line2.markAsPristine();
        this.line2.markAsUntouched();
        this.line3.patchValue(value.line3);
        this.line3.markAsPristine();
        this.line3.markAsUntouched();
        this.city.patchValue(value.city);
        this.city.markAsPristine();
        this.city.markAsUntouched();
        this.city.updateValueAndValidity();
        this.stateCode.patchValue(value.stateCode);
        this.stateCode.markAsPristine();
        this.stateCode.markAsUntouched();
        this.stateCode.updateValueAndValidity();
        if (this._showCountries) {
            this.countryCode.patchValue(value.countryCode);
            this.countryCode.markAsPristine();
            this.countryCode.markAsUntouched();
            this.countryCode.updateValueAndValidity();
        }
        this.postalCode.patchValue(value.postalCode);
        this.postalCode.markAsPristine();
        this.postalCode.markAsUntouched();
        this.postalCode.updateValueAndValidity();
    }
    constructor() {
        this.line1ControlName = 'line1';
        this.line2ControlName = 'line2';
        this.line3ControlName = 'line3';
        this.postalCodeControlName = 'postalCode';
        this.cityControlName = 'city';
        this.stateCodeControlName = 'stateCode';
        this.countryCodeControlName = 'countryCode';
        this._showCountries = false;
        this.validationRegex = /^[^"%;^=?!+$|]*$/;
        this.defaultErrors = {
            line1: {
                required: `We need to know the address to move on.`,
                minlength: `This doesn't look right. The street address must have at least 3 characters. Check your format.`,
                pattern: `This doesn't look right. Check your format.`
            },
            line2: {
                pattern: `This doesn't look right. Check your format.`
            },
            line3: {
                pattern: `This doesn't look right. Check your format.`
            },
            postalCode: {
                required: `We need to know the ZIP Code to move on.`,
                zipcode: `This doesn't look right. Check your format.`
            },
            city: {
                required: `We need to know the city to move on.`,
                pattern: `This doesn't look right. Check your format.`
            },
            stateCode: {
                required: `We need to know the state to move on.`
            },
            countryCode: {
                required: `We need to know the country to move on.`
            },
        };
        this.showTooltip = true;
        this.payeeMode = false;
        this.i18n = false;
        this.showLine3 = false;
        this.showOptionalText = false;
        this.allowMilitary = false;
        this.allowTerritory = false;
        this.customErrors = {};
        this.i18nSupport = (countryCode) => {
            return this.i18n || countryCode === 'US';
        };
        this.setCountries();
        this.line1 = new UntypedFormControl(null, Validators.compose([
            Validators.required,
            Validators.minLength(3),
            Validators.pattern(this.validationRegex),
        ]));
        this.line2 = new UntypedFormControl(null, Validators.compose([
            Validators.pattern(this.validationRegex),
        ]));
        this.line3 = new UntypedFormControl(null, Validators.compose([
            Validators.pattern(this.validationRegex),
        ]));
        this.city = new UntypedFormControl(null, Validators.compose([
            Validators.required,
            Validators.pattern(this.validationRegex),
        ]));
        this.stateCode = new UntypedFormControl(null, Validators.compose([
            Validators.required,
            Validators.minLength(2)
        ]));
        this.countryCode = new UntypedFormControl('US', this.showCountries
            ? Validators.compose([
                Validators.required,
                ExtendedValidators.callback(this.i18nSupport, 'i18n')
            ])
            : null);
        this.postalCode = new UntypedFormControl(null, Validators.compose([
            Validators.required,
            ExtendedValidators.zipCode
        ]));
    }
    setCountries() {
        this.countrySelectItems = Object.entries(countries)
            .map(([value, text]) => ({ value, text }));
    }
    ngOnDestroy() {
        this.form?.removeControl(this.line1ControlName);
        this.form?.removeControl(this.line2ControlName);
        this.form?.removeControl(this.line3ControlName);
        this.form?.removeControl(this.cityControlName);
        this.form?.removeControl(this.stateCodeControlName);
        this.form?.removeControl(this.postalCodeControlName);
        this.form?.removeControl(this.countryCodeControlName);
    }
    static { this.ɵfac = function AddressComponent_Factory(t) { return new (t || AddressComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AddressComponent, selectors: [["sumday-address"]], inputs: { showCountries: "showCountries", readonly: "readonly", showTooltip: "showTooltip", payeeMode: "payeeMode", i18n: "i18n", showLine3: "showLine3", showOptionalText: "showOptionalText", allowMilitary: "allowMilitary", allowTerritory: "allowTerritory", customErrors: "customErrors", formGroup: "formGroup", address: "address" }, ngContentSelectors: _c1$f, decls: 3, vars: 3, consts: [[3, "formGroup"], ["formControlName", "countryCode", "autocomplete", "shipping country", 3, "readonly", "list", 4, "ngIf"], [4, "ngIf"], ["formControlName", "countryCode", "autocomplete", "shipping country", 3, "readonly", "list"], [3, "errorMessageMappings"], ["class", "validation", 4, "ngIf"], [1, "validation"], ["formControlName", "line1", "autocomplete", "shipping address-line1", 3, "readonly", "counter", "maxLength"], ["formControlName", "line2", "maxLength", "42", "autocomplete", "shipping address-line2", 3, "readonly", "counter", "maxLength"], ["formControlName", "line3", "maxLength", "42", "autocomplete", "shipping address-line3", 3, "readonly", "maxLength", 4, "ngIf"], ["formControlName", "city", "maxLength", "22", "autocomplete", "shipping address-level2", 3, "readonly"], ["container", ""], ["desktop", "6"], ["formControlName", "stateCode", "sumdayStateDropdown", "", "autocomplete", "shipping address-level1", 3, "readonly", "allowMilitary", "allowTerritory"], ["inputmode", "numeric", "formControlName", "postalCode", "mask", "postal-code", "autocomplete", "shipping postal-code", 3, "readonly"], ["formControlName", "line3", "maxLength", "42", "autocomplete", "shipping address-line3", 3, "readonly", "maxLength"]], template: function AddressComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$o);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, AddressComponent_sumday_select_1_Template, 4, 4, "sumday-select", 1);
            i0.ɵɵtemplate(2, AddressComponent_ng_container_2_Template, 20, 18, "ng-container", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showCountries);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.countryCode.value === "US");
        } }, dependencies: [i1$1.NgIf, i1$4.NgControlStatus, i1$4.NgControlStatusGroup, i1$4.FormGroupDirective, i1$4.FormControlName, i1.FormControlDirective, i1.FormGroupDirective, GridComponent, SelectComponent, TextComponent, ValidationsComponent, StateDropdownDirective], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddressComponent, [{
        type: Component,
        args: [{ selector: 'sumday-address', template: "<div [formGroup]=\"form\">\n  <sumday-select\n    *ngIf=\"showCountries\"\n    [readonly]=\"readonly\"\n    formControlName=\"countryCode\"\n    [list]=\"countrySelectItems\"\n    autocomplete=\"shipping country\"\n  >\n    Country\n    <sumday-validations\n      [errorMessageMappings]=\"errors.countryCode\">\n    </sumday-validations>\n\n\n    <div class=\"validation\" *ngIf=\"countryCode.hasError('i18n')\">\n      <ng-content select=\".i18n\"></ng-content>\n    </div>\n  </sumday-select>\n\n  <ng-container *ngIf=\"countryCode.value === 'US'\">\n    <sumday-text\n      [readonly]=\"readonly\"\n      [counter]=\"payeeMode\"\n      [maxLength]=\"payeeMode ? 40 : 42\"\n      formControlName=\"line1\"\n      autocomplete=\"shipping address-line1\"\n    >\n      Street address\n\n      <sumday-validations\n        [errorMessageMappings]=\"errors.line1\">\n      </sumday-validations>\n    </sumday-text>\n\n    <sumday-text\n      [readonly]=\"readonly\"\n      [counter]=\"payeeMode\"\n      [maxLength]=\"payeeMode ? 40 : 42\"\n      formControlName=\"line2\"\n      maxLength=\"42\"\n      autocomplete=\"shipping address-line2\"\n    >\n      Street address 2 {{ (showOptionalText) ? '(optional)' : '' }}\n\n      <sumday-validations\n        [errorMessageMappings]=\"errors.line2\">\n      </sumday-validations>\n    </sumday-text>\n\n    <sumday-text\n      [readonly]=\"readonly\"\n      [maxLength]=\"42\"\n      *ngIf=\"showLine3\"\n      formControlName=\"line3\"\n      maxLength=\"42\"\n      autocomplete=\"shipping address-line3\"\n    >\n      Street address 3  {{ (showOptionalText) ? '(optional)' : '' }}\n\n      <sumday-validations\n        [errorMessageMappings]=\"errors.line3\">\n      </sumday-validations>\n    </sumday-text>\n\n    <sumday-text\n      [readonly]=\"readonly\"\n      formControlName=\"city\"\n      maxLength=\"22\"\n      autocomplete=\"shipping address-level2\"\n    >\n      City\n\n      <sumday-validations\n        [errorMessageMappings]=\"errors.city\">\n      </sumday-validations>\n    </sumday-text>\n\n    <sumday-grid container>\n      <sumday-grid desktop=\"6\">\n        <sumday-select\n          [readonly]=\"readonly\"\n          formControlName=\"stateCode\"\n          sumdayStateDropdown\n          [allowMilitary]=\"allowMilitary\"\n          [allowTerritory]=\"allowTerritory\"\n          autocomplete=\"shipping address-level1\"\n        >\n          State\n\n          <sumday-validations\n            [errorMessageMappings]=\"errors.stateCode\">\n          </sumday-validations>\n        </sumday-select>\n      </sumday-grid>\n      <sumday-grid desktop=\"6\">\n        <sumday-text\n          inputmode=\"numeric\"\n          formControlName=\"postalCode\"\n          [readonly]=\"readonly\"\n          mask=\"postal-code\"\n          autocomplete=\"shipping postal-code\"\n        >\n          ZIP Code\n\n          <sumday-validations\n            [errorMessageMappings]=\"errors.postalCode\">\n          </sumday-validations>\n        </sumday-text>\n      </sumday-grid>\n    </sumday-grid>\n  </ng-container>\n</div>\n" }]
    }], function () { return []; }, { showCountries: [{
            type: Input
        }], readonly: [{
            type: Input
        }], showTooltip: [{
            type: Input
        }], payeeMode: [{
            type: Input
        }], i18n: [{
            type: Input
        }], showLine3: [{
            type: Input
        }], showOptionalText: [{
            type: Input
        }], allowMilitary: [{
            type: Input
        }], allowTerritory: [{
            type: Input
        }], customErrors: [{
            type: Input
        }], formGroup: [{
            type: Input
        }], address: [{
            type: Input
        }] }); })();

const _c0$n = [[["", "dialog-label", ""]], [["", "dialog-content", ""]]];
const _c1$e = ["[dialog-label]", "[dialog-content]"];
let dialogId = 0;
class DialogComponent {
    set id(setId) {
        if (setId) {
            this.inputId = setId;
        }
    }
    get shouldShow() {
        return this.shouldShowValue;
    }
    set shouldShow(newValue) {
        // only want to send close event if its was previously opened
        if (this.shouldShowValue && !newValue) {
            this.closeEvent.emit(true);
        }
        this.shouldShowValue = newValue;
        if (newValue) {
            this.element.nativeElement.classList.add('in');
        }
        else {
            this.element.nativeElement.classList.remove('in');
        }
        this.shouldShowChange.emit(this.shouldShowValue);
    }
    get isBrowser() { return isPlatformBrowser(this.platformId); }
    constructor(renderer, pageFocusService, element, window, ngZone, platformId) {
        this.renderer = renderer;
        this.pageFocusService = pageFocusService;
        this.element = element;
        this.window = window;
        this.ngZone = ngZone;
        this.platformId = platformId;
        this.inputId = `dialog-${dialogId++}`;
        this.useBackdrop = true;
        this.showClose = false;
        this.focusHeader = false;
        this.scrollToTopOnOpen = true;
        this.shouldShowChange = new EventEmitter();
        this.closeEvent = new EventEmitter();
        this.hasBoundEvents = false;
        this.COLUMN_CLASS = 'detail-column';
        this.MODAL_CLASS = 'options-column';
        this.BACKDROP_CLASS = 'modal-backdrop';
        this.OPEN_MODAL_CLASS = 'open-modal';
        this.HIDE_MODAL_CLASS = 'hide-modal';
        this.ANIMATE_MODAL_CLASS = 'in';
        this.externalTabbableElements = [];
        this.externalContainerElements = [];
        this.isMobileStyle = false;
        this.isBlockingFocus = false;
        this.isSafari = false;
        this.labelId = '';
        this.eventFunction = ($event) => {
            if ($event.keyCode === KeyCodes.ESC) {
                this.shouldShow = false;
            }
        };
    }
    ngOnInit() {
        this.labelId = `${this.inputId}-label`;
        this.element.nativeElement.setAttribute('aria-labelledby', this.labelledBy || this.labelId);
        this.element.nativeElement.classList.add(this.COLUMN_CLASS);
        if (this.useBackdrop) {
            this.element.nativeElement.classList.add(this.MODAL_CLASS);
            this.element.nativeElement.setAttribute('role', 'dialog');
        }
        else {
            this.element.nativeElement.setAttribute('role', 'tabpanel');
        }
        this.isSafari = /^((?!chrome|android).)*safari/i.test(this.window.nativeWindow.navigator.userAgent);
        if (this.isSafari) {
            // safari doesnt track document.activeElement for button clicks so we have to hold its hand
            this.window.nativeWindow.document.addEventListener('click', (event) => {
                if (this.shouldShow && !this.previouslyFocusedElement) {
                    this.previouslyFocusedElement = event.target;
                }
            });
        }
        this.testForMobile();
        this.window.events.resize
            .pipe(debounceTime(200))
            .subscribe(event => {
            this.window.nativeWindow.requestAnimationFrame(() => {
                let oldState = this.isMobileStyle;
                this.testForMobile();
                // if its currently showing in a non modal state and in desktop mode and gets changed to mobile
                if (this.shouldShow && !oldState && this.isMobileStyle && !this.useBackdrop) {
                    this.blockExternalFocus();
                }
                // if its currently showing in a non modal state and in mobile mode and gets changed to desktop
                if (this.shouldShow && oldState && !this.isMobileStyle && !this.useBackdrop) {
                    this.unblockExternalFocus();
                }
            });
        });
    }
    testForMobile() {
        let stylez = this.window.nativeWindow.getComputedStyle(this.element.nativeElement);
        this.isMobileStyle = stylez.position === 'fixed';
    }
    ngOnDestroy() {
        this.shouldShowValue = false;
        this.ngOnChanges({ 'shouldShow': {} });
    }
    blockExternalFocus() {
        if ((this.useBackdrop || this.isMobileStyle) && !this.isBlockingFocus) {
            this.pageFocusService.blockExternalFocus(this.element.nativeElement, this.externalContainerElements, this.externalTabbableElements);
            this.isBlockingFocus = true;
        }
    }
    unblockExternalFocus() {
        if (this.isBlockingFocus) {
            this.pageFocusService.unblockExternalFocus(this.externalContainerElements, this.externalTabbableElements);
            this.isBlockingFocus = false;
        }
    }
    setFocusOnFirstElement() {
        let tabbableElements = tabbable(this.element.nativeElement);
        if (tabbableElements.length === 1 || this.focusHeader) {
            let id = this.element.nativeElement.getAttribute('aria-labelledby');
            setTimeout(() => {
                let header = document.getElementById(id);
                if (header) {
                    header.tabIndex = -1;
                    this.focusElement(header);
                }
            }, 2);
        }
        else if (tabbableElements.length >= 2) {
            this.focusElement(tabbableElements[1]);
        }
    }
    focusElement(element) {
        this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
                element.focus();
            }, 500); // needs to be at least 500 for iOS
        });
    }
    ngOnChanges(changes) {
        if (!changes['shouldShow']) {
            return;
        }
        let body = document.body;
        if (this.shouldShowValue) {
            this.element.nativeElement.removeAttribute('aria-hidden');
        }
        else {
            this.element.nativeElement.setAttribute('aria-hidden', true);
        }
        // safari in any form does not play well with aria-modal so we cant add it
        if (!this.isSafari) {
            this.element.nativeElement.setAttribute('aria-modal', this.useBackdrop);
        }
        if (this.shouldShowValue) {
            if (!this.isSafari) {
                this.previouslyFocusedElement = document.activeElement;
            }
            this.blockExternalFocus();
            this.element.nativeElement.classList.add(this.ANIMATE_MODAL_CLASS);
            let styles = this.window.nativeWindow.getComputedStyle(this.element.nativeElement);
            if (styles.position === 'absolute') {
                body.classList.add(this.OPEN_MODAL_CLASS);
            }
            this.element.nativeElement.classList.remove(this.HIDE_MODAL_CLASS);
            this.bindEvents();
            this.addBackdrop();
            this.setFocusOnFirstElement();
            if (this.scrollToTopOnOpen) {
                this.window.nativeWindow.scrollTo(0, 0);
            }
        }
        else {
            body.classList.remove(this.OPEN_MODAL_CLASS);
            this.element.nativeElement.classList.remove(this.ANIMATE_MODAL_CLASS);
            this.element.nativeElement.classList.add(this.HIDE_MODAL_CLASS);
            this.unblockExternalFocus();
            this.unbindEvents();
            this.removeBackdrop();
            if (this.previouslyFocusedElement) {
                this.previouslyFocusedElement.focus();
            }
        }
    }
    close() {
        this.shouldShow = false;
    }
    bindEvents() {
        if (!this.hasBoundEvents && this.isBrowser) {
            this.window.nativeWindow.addEventListener('keydown', this.eventFunction);
            this.hasBoundEvents = true;
        }
    }
    unbindEvents() {
        if (!this.isBrowser) {
            return;
        }
        this.window.nativeWindow.removeEventListener('keydown', this.eventFunction);
        this.hasBoundEvents = false;
    }
    addBackdrop() {
        if (this.useBackdrop) {
            let backdrop = this.renderer.createElement('div');
            this.renderer.addClass(backdrop, this.BACKDROP_CLASS);
            this.renderer.appendChild(this.element.nativeElement, backdrop);
        }
    }
    removeBackdrop() {
        if (this.useBackdrop) {
            let backdrops = this.element.nativeElement.getElementsByClassName(this.BACKDROP_CLASS);
            if (!backdrops || !backdrops.length) {
                return;
            }
            for (let i = 0, len = backdrops.length; i < len; i += 1) {
                this.element.nativeElement.removeChild(backdrops[i]);
            }
        }
    }
    static { this.ɵfac = function DialogComponent_Factory(t) { return new (t || DialogComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.PageFocusService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.WindowRefService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(PLATFORM_ID)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DialogComponent, selectors: [["sumday-dialog"]], inputs: { labelledBy: "labelledBy", useBackdrop: "useBackdrop", showClose: "showClose", focusHeader: "focusHeader", scrollToTopOnOpen: "scrollToTopOnOpen", id: "id", shouldShow: "shouldShow" }, outputs: { shouldShowChange: "shouldShowChange", closeEvent: "closeEvent" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1$e, decls: 8, vars: 3, consts: [[1, "mobile-modal-navbar", "cancel"], ["role", "button", "tabindex", "0", "aria-label", "Close dialog", 3, "click"], [1, "icon", "hide-desktop"], [1, "label"], [1, "modal-body"], ["tabindex", "-1", 1, "h2", 3, "id"]], template: function DialogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$n);
            i0.ɵɵelementStart(0, "div", 0)(1, "a", 1);
            i0.ɵɵlistener("click", function DialogComponent_Template_a_click_1_listener() { return ctx.close(); });
            i0.ɵɵelement(2, "span", 2)(3, "span", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "div", 4)(5, "h3", 5);
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(7, 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵclassProp("show-close", ctx.showClose);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("id", ctx.labelId);
        } }, dependencies: [i1.RoleButtonDirective], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DialogComponent, [{
        type: Component,
        args: [{ selector: 'sumday-dialog', template: "<div class=\"mobile-modal-navbar cancel\" [class.show-close]=\"showClose\">\n  <a role=\"button\" tabindex=\"0\" (click)=\"close();\" aria-label=\"Close dialog\"><span class=\"icon hide-desktop\"></span><span class=\"label\"></span></a>\n</div>\n\n<div class=\"modal-body\">\n  <h3 class=\"h2\" tabindex=\"-1\" [id]=\"labelId\"><ng-content select=\"[dialog-label]\"></ng-content></h3>\n  <ng-content select=\"[dialog-content]\"></ng-content>\n</div>\n" }]
    }], function () { return [{ type: i0.Renderer2 }, { type: i1.PageFocusService }, { type: i0.ElementRef }, { type: i1.WindowRefService }, { type: i0.NgZone }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { labelledBy: [{
            type: Input
        }], useBackdrop: [{
            type: Input
        }], showClose: [{
            type: Input
        }], focusHeader: [{
            type: Input
        }], scrollToTopOnOpen: [{
            type: Input
        }], shouldShowChange: [{
            type: Output
        }], closeEvent: [{
            type: Output
        }], id: [{
            type: Input
        }], shouldShow: [{
            type: Input
        }] }); })();

function FooterComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1, "\n    ");
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵtext(3, "\n        ");
    i0.ɵɵelementStart(4, "sumday-select", 15);
    i0.ɵɵlistener("change", function FooterComponent_div_4_Template_sumday_select_change_4_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onChangeSelectedPlan($event)); });
    i0.ɵɵtext(5, "\n          Plan Info:\n        ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, "\n    ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, "\n  ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("overlay", false)("list", ctx_r0.planOptions);
} }
function FooterComponent_div_6_span_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", plan_r4.supportTty, " (TTY)");
} }
function FooterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, "\n    ");
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵtext(3, "\n      ");
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5, "\n        ");
    i0.ɵɵelementStart(6, "a", 17);
    i0.ɵɵtext(7, "\n          ");
    i0.ɵɵelement(8, "img", 18);
    i0.ɵɵtext(9, "\n        ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(10, "\n      ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(11, "\n\n      ");
    i0.ɵɵelementStart(12, "sumday-grid", 5);
    i0.ɵɵtext(13, "\n        ");
    i0.ɵɵelementStart(14, "sumday-grid", 6);
    i0.ɵɵtext(15, "\n          ");
    i0.ɵɵelementStart(16, "div", 8);
    i0.ɵɵtext(17, "\n            ");
    i0.ɵɵelement(18, "p", 19);
    i0.ɵɵtext(19, "\n          ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(20, "\n        ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(21, "\n        ");
    i0.ɵɵelementStart(22, "sumday-grid", 20);
    i0.ɵɵtext(23, "\n          ");
    i0.ɵɵelementStart(24, "div", 10);
    i0.ɵɵtext(25, "\n            ");
    i0.ɵɵprojection(26, 2);
    i0.ɵɵtext(27, "\n          ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(28, "\n          ");
    i0.ɵɵprojection(29, 3);
    i0.ɵɵtext(30, "\n        ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(31, "\n        ");
    i0.ɵɵelementStart(32, "sumday-grid", 21);
    i0.ɵɵtext(33, "\n          ");
    i0.ɵɵelementStart(34, "div", 10);
    i0.ɵɵtext(35, "\n            ");
    i0.ɵɵelementStart(36, "ul");
    i0.ɵɵtext(37, "\n              ");
    i0.ɵɵelementStart(38, "li")(39, "strong");
    i0.ɵɵtext(40, "Questions?");
    i0.ɵɵelementEnd()();
    i0.ɵɵtext(41, "\n              ");
    i0.ɵɵelementStart(42, "li")(43, "a", 22);
    i0.ɵɵtext(44, "Read the FAQs");
    i0.ɵɵelementEnd()();
    i0.ɵɵtext(45, "\n              ");
    i0.ɵɵelementStart(46, "li")(47, "a", 22);
    i0.ɵɵtext(48, "Contact Us");
    i0.ɵɵelementEnd()();
    i0.ɵɵtext(49, "\n              ");
    i0.ɵɵelementStart(50, "li");
    i0.ɵɵtext(51, "\n                Call Us\n                ");
    i0.ɵɵelementStart(52, "span", 23);
    i0.ɵɵtext(53);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(54, "\n                ");
    i0.ɵɵtemplate(55, FooterComponent_div_6_span_55_Template, 2, 1, "span", 24);
    i0.ɵɵtext(56, "\n              ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(57, "\n            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(58, "\n          ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(59, "\n          ");
    i0.ɵɵprojection(60, 4);
    i0.ɵɵtext(61, "\n        ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(62, "\n      ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(63, "\n    ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(64, "\n  ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r4 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵpropertyInterpolate("href", plan_r4.siteUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("src", "/assets/images/plan/logo/", plan_r4.id, ".svg", i0.ɵɵsanitizeUrl);
    i0.ɵɵproperty("alt", plan_r4.name);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("innerHtml", ctx_r1.legalText, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(25);
    i0.ɵɵpropertyInterpolate("href", plan_r4 == null ? null : plan_r4.urls == null ? null : plan_r4.urls.faqs, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate1("href", "/customer-support/", plan_r4.id, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(plan_r4.supportPhone);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", plan_r4.supportTty);
} }
const _c0$m = ["*", [["", "global-column", ""]], [["", "plan-about-links", ""]], [["", "plan-about-column", ""]], [["", "plan-questions-column", ""]]];
const _c1$d = ["*", "[global-column]", "[plan-about-links]", "[plan-about-column]", "[plan-questions-column]"];
class FooterComponent {
    constructor() {
        this.selectedPlanEvent = new EventEmitter();
        this.planOptions = [];
        this.onChangeSelectedPlan = (planOption) => {
            this.selectedPlan = planOption.value;
            this.selectedPlanEvent.emit(this.selectedPlan);
        };
    }
    set activePlan(activePlan) {
        this._activePlan = activePlan;
        if (activePlan) {
            this.selectedPlan = null;
        }
    }
    get activePlan() {
        return this._activePlan;
    }
    set plans(plans) {
        if (!plans) {
            return;
        }
        this.planOptions = plans.map(plan => ({
            text: plan.name,
            value: plan
        }));
    }
    static { this.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FooterComponent, selectors: [["sumday-footer"]], inputs: { legalText: "legalText", activePlan: "activePlan", plans: "plans" }, outputs: { selectedPlanEvent: "selectedPlanEvent" }, ngContentSelectors: _c1$d, decls: 55, vars: 3, consts: [["role", "contentinfo"], ["class", "plan-picker", 4, "ngIf"], ["class", "plan-footer", 4, "ngIf"], [1, "global-footer"], [1, "footer-container"], ["container", ""], ["desktop", "6"], ["src", "/assets/images/sumday-bny-logo.svg", "alt", "Sumday a BNY Mellon company"], [1, "legal-text"], ["desktop", "3", "print", "0", 3, "desktopOffset"], [1, "links"], ["href", "/privacy"], ["href", "/terms"], ["href", "/browser-compatibility"], [1, "plan-picker"], ["placeholder", "Select one", 3, "overlay", "list", "change"], [1, "plan-footer"], ["target", "_blank", 1, "logo", 3, "href"], [3, "src", "alt"], [3, "innerHtml"], ["desktop", "3", "desktopOffset", "1"], ["desktop", "2"], ["target", "_blank", 3, "href"], [1, "nowrap"], ["class", "nowrap", 4, "ngIf"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$m);
            i0.ɵɵelementStart(0, "footer", 0);
            i0.ɵɵtext(1, "\n  ");
            i0.ɵɵprojection(2);
            i0.ɵɵtext(3, "\n\n  ");
            i0.ɵɵtemplate(4, FooterComponent_div_4_Template, 8, 2, "div", 1);
            i0.ɵɵtext(5, "\n\n  ");
            i0.ɵɵtemplate(6, FooterComponent_div_6_Template, 65, 8, "div", 2);
            i0.ɵɵtext(7, "\n\n  ");
            i0.ɵɵelementStart(8, "div", 3);
            i0.ɵɵtext(9, "\n    ");
            i0.ɵɵelementStart(10, "div", 4);
            i0.ɵɵtext(11, "\n      ");
            i0.ɵɵelementStart(12, "sumday-grid", 5);
            i0.ɵɵtext(13, "\n        ");
            i0.ɵɵelementStart(14, "sumday-grid", 6);
            i0.ɵɵtext(15, "\n          ");
            i0.ɵɵelement(16, "img", 7);
            i0.ɵɵtext(17, "\n\n          ");
            i0.ɵɵelementStart(18, "div", 8);
            i0.ɵɵtext(19, "\n            ");
            i0.ɵɵelementStart(20, "p");
            i0.ɵɵtext(21, "Sumday is a service mark of The Bank of New York Mellon.");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(22, "\n            ");
            i0.ɵɵelementStart(23, "p");
            i0.ɵɵtext(24, "BNY Mellon is the corporate brand of The Bank of New York Mellon Corporation.");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(25, "\n          ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(26, "\n        ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(27, "\n\n        ");
            i0.ɵɵelementStart(28, "sumday-grid", 9);
            i0.ɵɵtext(29, "\n          ");
            i0.ɵɵelementStart(30, "div", 10);
            i0.ɵɵtext(31, "\n            ");
            i0.ɵɵelementStart(32, "ul");
            i0.ɵɵtext(33, "\n              ");
            i0.ɵɵelementStart(34, "li")(35, "a", 11);
            i0.ɵɵtext(36, "Online Privacy Statement");
            i0.ɵɵelementEnd()();
            i0.ɵɵtext(37, "\n              ");
            i0.ɵɵelementStart(38, "li")(39, "a", 12);
            i0.ɵɵtext(40, "Site Terms of Use");
            i0.ɵɵelementEnd()();
            i0.ɵɵtext(41, "\n              ");
            i0.ɵɵelementStart(42, "li")(43, "a", 13);
            i0.ɵɵtext(44, "Browser Compatibility");
            i0.ɵɵelementEnd()();
            i0.ɵɵtext(45, "\n            ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(46, "\n          ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(47, "\n          ");
            i0.ɵɵprojection(48, 1);
            i0.ɵɵtext(49, "\n        ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(50, "\n      ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(51, "\n    ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(52, "\n  ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(53, "\n");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(54, "\n");
        } if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", !ctx.activePlan && ctx.planOptions.length > 1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.activePlan || ctx.selectedPlan);
            i0.ɵɵadvance(22);
            i0.ɵɵproperty("desktopOffset", 1);
        } }, dependencies: [i1$1.NgIf, i1.CdnSrcDirective, i1.TargetBlankDirective, GridComponent, SelectComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{ selector: 'sumday-footer', preserveWhitespaces: true, template: "<footer role=\"contentinfo\">\n  <ng-content></ng-content>\n\n  <div class=\"plan-picker\" *ngIf=\"!activePlan && planOptions.length > 1\">\n    <div class=\"footer-container\">\n        <sumday-select\n          (change)=\"onChangeSelectedPlan($event)\"\n          [overlay]=\"false\"\n          [list]=\"planOptions\"\n          placeholder=\"Select one\"\n        >\n          Plan Info:\n        </sumday-select>\n    </div>\n  </div>\n\n  <div class=\"plan-footer\" *ngIf=\"activePlan || selectedPlan as plan\">\n    <div class=\"footer-container\">\n      <div>\n        <a class=\"logo\" href=\"{{plan.siteUrl}}\" target=\"_blank\">\n          <img\n            src=\"/assets/images/plan/logo/{{plan.id}}.svg\"\n            [alt]=\"plan.name\"\n          />\n        </a>\n      </div>\n\n      <sumday-grid container>\n        <sumday-grid desktop=\"6\">\n          <div class=\"legal-text\">\n            <p [innerHtml]=\"legalText\"></p>\n          </div>\n        </sumday-grid>\n        <sumday-grid desktop=\"3\" desktopOffset=\"1\">\n          <div class=\"links\">\n            <ng-content select=\"[plan-about-links]\"></ng-content>\n          </div>\n          <ng-content select=\"[plan-about-column]\"></ng-content>\n        </sumday-grid>\n        <sumday-grid desktop=\"2\">\n          <div class=\"links\">\n            <ul>\n              <li><strong>Questions?</strong></li>\n              <li><a href=\"{{ plan?.urls?.faqs }}\" target=\"_blank\">Read the FAQs</a></li>\n              <li><a href=\"/customer-support/{{ plan.id }}\" target=\"_blank\">Contact Us</a></li>\n              <li>\n                Call Us\n                <span class=\"nowrap\">{{plan.supportPhone}}</span>\n                <span *ngIf=\"plan.supportTty\" class=\"nowrap\">{{plan.supportTty}} (TTY)</span>\n              </li>\n            </ul>\n          </div>\n          <ng-content select=\"[plan-questions-column]\"></ng-content>\n        </sumday-grid>\n      </sumday-grid>\n    </div>\n  </div>\n\n  <div class=\"global-footer\">\n    <div class=\"footer-container\">\n      <sumday-grid container>\n        <sumday-grid desktop=\"6\">\n          <img src=\"/assets/images/sumday-bny-logo.svg\" alt=\"Sumday a BNY Mellon company\"/>\n\n          <div class=\"legal-text\">\n            <p>Sumday is a service mark of The Bank of New York Mellon.</p>\n            <p>BNY Mellon is the corporate brand of The Bank of New York Mellon Corporation.</p>\n          </div>\n        </sumday-grid>\n\n        <sumday-grid desktop=\"3\" [desktopOffset]=\"1\" print=\"0\">\n          <div class=\"links\">\n            <ul>\n              <li><a href=\"/privacy\">Online Privacy Statement</a></li>\n              <li><a href=\"/terms\">Site Terms of Use</a></li>\n              <li><a href=\"/browser-compatibility\">Browser Compatibility</a></li>\n            </ul>\n          </div>\n          <ng-content select=\"[global-column]\"></ng-content>\n        </sumday-grid>\n      </sumday-grid>\n    </div>\n  </div>\n</footer>\n" }]
    }], null, { legalText: [{
            type: Input
        }], selectedPlanEvent: [{
            type: Output
        }], activePlan: [{
            type: Input
        }], plans: [{
            type: Input
        }] }); })();

class BaseFootnoteComponent {
    constructor(document) {
        this.document = document;
        this.index = 1;
        this.iosTimer = 200;
    }
    ngOnInit() {
        this.id = `${this.idPrefix}${this.index}`;
    }
    linkTo($event) {
        $event.preventDefault();
        const linkTo = this.document.querySelector(`#${this.linkToIdPrefix}${this.index}`);
        setTimeout(() => {
            linkTo.focus();
        }, this.iosTimer); // deal with iOS VO focusing issues
    }
    static { this.ɵfac = function BaseFootnoteComponent_Factory(t) { return new (t || BaseFootnoteComponent)(i0.ɵɵdirectiveInject(DOCUMENT)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: BaseFootnoteComponent, inputs: { index: "index" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseFootnoteComponent, [{
        type: Directive
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { index: [{
            type: Input
        }] }); })();

const _c0$l = function () { return ["./"]; };
const _c1$c = ["*"];
class FootnoteComponent extends BaseFootnoteComponent {
    constructor() {
        super(...arguments);
        this.headingLevel = 3;
        this.idPrefix = 'footnote-';
        this.linkToIdPrefix = 'footnote-link-';
    }
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵFootnoteComponent_BaseFactory; return function FootnoteComponent_Factory(t) { return (ɵFootnoteComponent_BaseFactory || (ɵFootnoteComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FootnoteComponent)))(t || FootnoteComponent); }; }(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FootnoteComponent, selectors: [["sumday-footnote"]], inputs: { headingLevel: "headingLevel" }, features: [i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1$c, decls: 8, vars: 7, consts: [["tabindex", "-1", "role", "heading", 3, "id"], [1, "return-link", 3, "routerLink", "id", "click"], [1, "screen-reader-only"]], template: function FootnoteComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "p")(1, "span", 0);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(3);
            i0.ɵɵelementStart(4, "a", 1);
            i0.ɵɵlistener("click", function FootnoteComponent_Template_a_click_4_listener($event) { return ctx.linkTo($event); });
            i0.ɵɵtext(5, "Return ");
            i0.ɵɵelementStart(6, "span", 2);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("id", ctx.id);
            i0.ɵɵattribute("aria-level", ctx.headingLevel);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1("Footnote ", ctx.index, ": ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(6, _c0$l))("id", ctx.id);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("to footnote ", ctx.index, "");
        } }, dependencies: [i1$2.RouterLink], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FootnoteComponent, [{
        type: Component,
        args: [{ selector: 'sumday-footnote', template: "<p>\n  <span [id]=\"id\" tabindex=\"-1\" role=\"heading\" [attr.aria-level]=\"headingLevel\">Footnote {{index}}: </span>\n  <ng-content></ng-content>\n  <a\n    [routerLink]=\"['./']\"\n    [id]=\"id\"\n    (click)=\"linkTo($event)\"\n    class=\"return-link\"\n  >Return <span class=\"screen-reader-only\">to footnote {{index}}</span></a>\n</p>" }]
    }], null, { headingLevel: [{
            type: Input
        }] }); })();

const _c0$k = function () { return ["./"]; };
class FootnoteLinkComponent extends BaseFootnoteComponent {
    constructor() {
        super(...arguments);
        this.idPrefix = 'footnote-link-';
        this.linkToIdPrefix = 'footnote-';
    }
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵFootnoteLinkComponent_BaseFactory; return function FootnoteLinkComponent_Factory(t) { return (ɵFootnoteLinkComponent_BaseFactory || (ɵFootnoteLinkComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FootnoteLinkComponent)))(t || FootnoteLinkComponent); }; }(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FootnoteLinkComponent, selectors: [["sumday-footnote-link"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 4, consts: [[3, "routerLink", "id", "click"], [1, "screen-reader-only"]], template: function FootnoteLinkComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "sup")(1, "a", 0);
            i0.ɵɵlistener("click", function FootnoteLinkComponent_Template_a_click_1_listener($event) { return ctx.linkTo($event); });
            i0.ɵɵelementStart(2, "span", 1);
            i0.ɵɵtext(3, "Footnote ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(3, _c0$k))("id", ctx.id);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.index);
        } }, dependencies: [i1$2.RouterLink], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FootnoteLinkComponent, [{
        type: Component,
        args: [{ selector: 'sumday-footnote-link', template: "<sup><a [routerLink]=\"['./']\" [id]=\"id\" (click)=\"linkTo($event)\"><span class=\"screen-reader-only\">Footnote </span>{{ index }}</a></sup>" }]
    }], null, null); })();

function FormBoxComponent_img_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 9);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.image, i0.ɵɵsanitizeUrl);
} }
function FormBoxComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.icon);
} }
const _c0$j = [[["", "content", ""]], [["", "input", ""]], [["", "validation", ""]]];
const _c1$b = ["[content]", "[input]", "[validation]"];
class FormBoxComponent {
    constructor() { }
    static { this.ɵfac = function FormBoxComponent_Factory(t) { return new (t || FormBoxComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormBoxComponent, selectors: [["sumday-form-box"]], inputs: { icon: "icon", image: "image" }, ngContentSelectors: _c1$b, decls: 12, vars: 2, consts: [["container", ""], ["desktop", "7"], [1, "content"], ["aria-hidden", "true", "alt", "", 3, "src", 4, "ngIf"], ["class", "icon", 3, "ngClass", 4, "ngIf"], [1, "body"], ["desktop", "5"], [1, "input-container"], [1, "validation-container"], ["aria-hidden", "true", "alt", "", 3, "src"], [1, "icon", 3, "ngClass"]], template: function FormBoxComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$j);
            i0.ɵɵelementStart(0, "sumday-grid", 0)(1, "sumday-grid", 1)(2, "div", 2);
            i0.ɵɵtemplate(3, FormBoxComponent_img_3_Template, 1, 1, "img", 3);
            i0.ɵɵtemplate(4, FormBoxComponent_div_4_Template, 1, 1, "div", 4);
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(7, "sumday-grid", 6)(8, "div", 7);
            i0.ɵɵprojection(9, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 8);
            i0.ɵɵprojection(11, 2);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.image);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.icon);
        } }, dependencies: [i1$1.NgClass, i1$1.NgIf, i1.CdnSrcDirective, GridComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormBoxComponent, [{
        type: Component,
        args: [{ selector: 'sumday-form-box', template: "<sumday-grid container>\n  <sumday-grid desktop=\"7\">\n    <div class=\"content\">\n      <img *ngIf=\"image\" [src]=\"image\" aria-hidden=\"true\" alt=\"\"/>\n      <div *ngIf=\"icon\" [ngClass]=\"icon\" class=\"icon\"></div>\n      <div class=\"body\">\n        <ng-content select=\"[content]\"></ng-content>\n      </div>\n    </div>\n  </sumday-grid>\n  <sumday-grid desktop=\"5\">\n    <div class=\"input-container\">\n      <ng-content select=\"[input]\"></ng-content>\n    </div>\n\n    <div class=\"validation-container\">\n      <ng-content select=\"[validation]\"></ng-content>\n    </div>\n  </sumday-grid>\n</sumday-grid>\n" }]
    }], function () { return []; }, { icon: [{
            type: Input
        }], image: [{
            type: Input
        }] }); })();

const _c0$i = ["menuButton"];
const _c1$a = ["mobileNav"];
const _c2$2 = ["mainNav"];
const _c3$1 = ["accountNav"];
function HeaderComponent_ul_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵtext(1, "\n            ");
    i0.ɵɵelementStart(2, "li");
    i0.ɵɵtext(3, "\n              ");
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵtext(5, "\n                ");
    i0.ɵɵelement(6, "img", 16);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8, "\n            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(9, "\n          ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵpropertyInterpolate1("src", "/assets/images/plan/icon/", ctx_r2.plan.id, ".svg", i0.ɵɵsanitizeUrl);
    i0.ɵɵproperty("alt", ctx_r2.plan.name);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\n                ", ctx_r2.accountName || ctx_r2.plan.name, "\n              ");
} }
function HeaderComponent_div_36_div_13_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "dots");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\n              ", i0.ɵɵpipeBind1(2, 1, ctx_r7.accountNumber), "\n            ");
} }
function HeaderComponent_div_36_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, HeaderComponent_div_36_div_13_span_2_Template, 3, 3, "span", 24);
    i0.ɵɵtext(3, "\n          ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\n            ", ctx_r6.accountName, "\n            ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.accountNumber);
} }
function HeaderComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, "\n    ");
    i0.ɵɵelementStart(2, "div", 18);
    i0.ɵɵtext(3, "\n      ");
    i0.ɵɵelementStart(4, "div", 19);
    i0.ɵɵtext(5, "\n        ");
    i0.ɵɵelement(6, "img", 20);
    i0.ɵɵtext(7, "\n        ");
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵtext(9, "\n          ");
    i0.ɵɵelementStart(10, "div", 21);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12, "\n          ");
    i0.ɵɵtemplate(13, HeaderComponent_div_36_div_13_Template, 4, 2, "div", 22);
    i0.ɵɵtext(14, "\n        ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(15, "\n      ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(16, "\n\n      ");
    i0.ɵɵprojection(17, 5);
    i0.ɵɵtext(18, "\n    ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(19, "\n  ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵpropertyInterpolate1("src", "/assets/images/plan/icon/", ctx_r4.plan.id, ".svg", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r4.plan.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.accountName || ctx_r4.accountNumber);
} }
const _c4$1 = [[["", "logo", ""]], [["", "mobileMenu", ""]], [["", "mainMenu", ""]], [["", "additionalHeaderContent", ""]], [["", "accountMenu", ""]], "*"];
const _c5 = ["[logo]", "[mobileMenu]", "[mainMenu]", "[additionalHeaderContent]", "[accountMenu]", "*"];
class HeaderComponent {
    constructor(changeDetector, router) {
        this.changeDetector = changeDetector;
        this.router = router;
        this.open = false;
        this.hidden = false;
        this.mobileNavIsOpen = new EventEmitter();
        // Hide the nav when you click a link
        this.router.events
            .pipe(filter(event => event instanceof NavigationStart))
            .subscribe(navInfo => this.toggleMenu(false, true));
    }
    ngAfterContentChecked() {
        this.toggleEmptyMenu(this.mainNav);
        this.toggleEmptyMenu(this.accountNav);
        this.toggleEmptyMenu(this.mobileNav);
    }
    toggleEmptyMenu(menu) {
        if (!menu) {
            return;
        }
        let noneTextNodeLiItems = Array.from(menu.nativeElement.childNodes).filter((node) => {
            return (node.nodeType !== 8 && !(node.nodeType === 3 && node.nodeValue.trim().length === 0));
        });
        // hide if there are no nodes or the menu is hidden because of screen resolution
        if (noneTextNodeLiItems.length === 0 || menu.nativeElement.offsetParent === null) {
            menu.nativeElement.parentNode.setAttribute('aria-hidden', true);
        }
        else {
            // menu.nativeElement.parentNode.classList.remove('hide');
            menu.nativeElement.parentNode.removeAttribute('aria-hidden');
        }
    }
    escapeMobileMenu() {
        this.toggleMenu(false, true);
    }
    toggleMenu(open = !this.open, focusButton = false) {
        this.open = open;
        this.changeDetector.detectChanges();
        if (open) {
            // We delay it by 300ms for the open animation to finish
            setTimeout(() => this.mobileNavIsOpen.emit(true), 300);
        }
        else {
            this.mobileNavIsOpen.emit(false);
            if (focusButton) {
                this.menuButton.nativeElement.focus();
            }
        }
    }
    static { this.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.Router)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["sumday-header"]], viewQuery: function HeaderComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$i, 5);
            i0.ɵɵviewQuery(_c1$a, 5);
            i0.ɵɵviewQuery(_c2$2, 5);
            i0.ɵɵviewQuery(_c3$1, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.mobileNav = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.mainNav = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accountNav = _t.first);
        } }, hostVars: 4, hostBindings: function HeaderComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassProp("open", ctx.open)("hidden", ctx.hidden);
        } }, inputs: { accountName: "accountName", accountNumber: "accountNumber", plan: "plan" }, outputs: { mobileNavIsOpen: "mobileNavIsOpen" }, ngContentSelectors: _c5, decls: 53, vars: 4, consts: [["id", "nav-primary", 1, "nav-section", "ios-safe-padding-top"], [1, "nav-container"], [1, "navbar"], ["type", "button", "aria-controls", "mobile-nav-component", "aria-haspopup", "true", "aria-label", "open navigation", 1, "nav-icon-hamburger", "no-default-styles", 3, "click"], ["menuButton", ""], [1, "mobile-menu", 3, "escapeMenu"], ["aria-label", "Main navigation", "id", "mobile-nav-component"], ["mobileNav", ""], [4, "ngIf"], ["aria-label", "Main navigation", 1, "main-menu"], ["mainNav", ""], ["class", "nav-section", "id", "nav-content", 4, "ngIf"], ["id", "nav-secondary", 1, "nav-section"], ["aria-label", "account navigation", 1, "account-menu"], ["accountNav", ""], [1, "plan"], [3, "src", "alt"], ["id", "nav-content", 1, "nav-section"], [1, "content-container"], [1, "plan-info"], ["alt", "", 3, "src"], [1, "plan-name"], ["class", "account-info", 4, "ngIf"], [1, "account-info"], ["class", "account-number", 4, "ngIf"], [1, "account-number"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c4$1);
            i0.ɵɵelementStart(0, "header");
            i0.ɵɵtext(1, "\n  ");
            i0.ɵɵelementStart(2, "div", 0);
            i0.ɵɵtext(3, "\n    ");
            i0.ɵɵelementStart(4, "div", 1);
            i0.ɵɵtext(5, "\n      ");
            i0.ɵɵelementStart(6, "div", 2);
            i0.ɵɵtext(7, "\n        ");
            i0.ɵɵprojection(8);
            i0.ɵɵtext(9, "\n\n        ");
            i0.ɵɵelementStart(10, "button", 3, 4);
            i0.ɵɵlistener("click", function HeaderComponent_Template_button_click_10_listener() { return ctx.toggleMenu(); });
            i0.ɵɵelementEnd();
            i0.ɵɵtext(12, "\n      ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(13, "\n\n      ");
            i0.ɵɵelementStart(14, "div", 5);
            i0.ɵɵlistener("escapeMenu", function HeaderComponent_Template_div_escapeMenu_14_listener() { return ctx.escapeMobileMenu(); });
            i0.ɵɵtext(15, "\n        ");
            i0.ɵɵelementStart(16, "nav", 6, 7);
            i0.ɵɵtext(18, "\n          ");
            i0.ɵɵtemplate(19, HeaderComponent_ul_19_Template, 10, 3, "ul", 8);
            i0.ɵɵtext(20, "\n          ");
            i0.ɵɵprojection(21, 1);
            i0.ɵɵtext(22, "\n        ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(23, "\n      ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(24, "\n\n      ");
            i0.ɵɵelementStart(25, "div");
            i0.ɵɵtext(26, "\n        ");
            i0.ɵɵelementStart(27, "nav", 9, 10);
            i0.ɵɵtext(29, "\n          ");
            i0.ɵɵprojection(30, 2);
            i0.ɵɵtext(31, "\n        ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(32, "\n      ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(33, "\n    ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(34, "\n  ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(35, "\n\n  ");
            i0.ɵɵtemplate(36, HeaderComponent_div_36_Template, 20, 3, "div", 11);
            i0.ɵɵtext(37, "\n\n  ");
            i0.ɵɵprojection(38, 3);
            i0.ɵɵtext(39, "\n\n  ");
            i0.ɵɵelementStart(40, "div", 12);
            i0.ɵɵtext(41, "\n    ");
            i0.ɵɵelementStart(42, "div", 1);
            i0.ɵɵtext(43, "\n      ");
            i0.ɵɵelementStart(44, "nav", 13, 14);
            i0.ɵɵtext(46, "\n        ");
            i0.ɵɵprojection(47, 4);
            i0.ɵɵtext(48, "\n      ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(49, "\n    ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(50, "\n  ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(51, "\n");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(52, "\n");
        } if (rf & 2) {
            i0.ɵɵadvance(10);
            i0.ɵɵattribute("tabindex", ctx.open ? -1 : 0)("aria-expanded", ctx.open || null);
            i0.ɵɵadvance(9);
            i0.ɵɵproperty("ngIf", ctx.plan);
            i0.ɵɵadvance(17);
            i0.ɵɵproperty("ngIf", ctx.plan);
        } }, dependencies: [i1$1.NgIf, i1.NavDirective, i1.CdnSrcDirective, i1.DotsPipe], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{ selector: 'sumday-header', preserveWhitespaces: true, template: "<header>\n  <div class=\"nav-section ios-safe-padding-top\" id=\"nav-primary\">\n    <div class=\"nav-container\">\n      <div class=\"navbar\">\n        <ng-content select=\"[logo]\"></ng-content>\n\n        <button\n          #menuButton\n          class=\"nav-icon-hamburger no-default-styles\"\n          type=\"button\"\n          (click)=\"toggleMenu()\"\n          [attr.tabindex]=\"open ? -1 : 0\"\n          aria-controls=\"mobile-nav-component\"\n          aria-haspopup=\"true\"\n          aria-label=\"open navigation\"\n          [attr.aria-expanded]=\"open || null\"\n        ></button>\n      </div>\n\n      <div class=\"mobile-menu\" (escapeMenu)=\"escapeMobileMenu()\">\n        <nav #mobileNav aria-label=\"Main navigation\" id=\"mobile-nav-component\">\n          <ul *ngIf=\"plan\">\n            <li>\n              <div class=\"plan\">\n                <img\n                  src=\"/assets/images/plan/icon/{{plan.id}}.svg\"\n                  [alt]=\"plan.name\"\n                />\n                {{ accountName || plan.name }}\n              </div>\n            </li>\n          </ul>\n          <ng-content select=\"[mobileMenu]\"></ng-content>\n        </nav>\n      </div>\n\n      <div>\n        <nav #mainNav aria-label=\"Main navigation\" class=\"main-menu\">\n          <ng-content select=\"[mainMenu]\"></ng-content>\n        </nav>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"nav-section\" id=\"nav-content\" *ngIf=\"plan\">\n    <div class=\"content-container\">\n      <div class=\"plan-info\">\n        <img\n          src=\"/assets/images/plan/icon/{{plan.id}}.svg\"\n          alt=\"\"\n        />\n        <div>\n          <div class=\"plan-name\">{{ plan.name }}</div>\n          <div class=\"account-info\" *ngIf=\"accountName || accountNumber\">\n            {{ accountName }}\n            <span class=\"account-number\" *ngIf=\"accountNumber\">\n              {{ accountNumber | dots }}\n            </span>\n          </div>\n        </div>\n      </div>\n\n      <ng-content></ng-content>\n    </div>\n  </div>\n\n  <ng-content select=\"[additionalHeaderContent]\"></ng-content>\n\n  <div class=\"nav-section\" id=\"nav-secondary\">\n    <div class=\"nav-container\">\n      <nav #accountNav aria-label=\"account navigation\" class=\"account-menu\">\n        <ng-content select=\"[accountMenu]\"></ng-content>\n      </nav>\n    </div>\n  </div>\n</header>\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1$2.Router }]; }, { open: [{
            type: HostBinding,
            args: ['class.open']
        }], hidden: [{
            type: HostBinding,
            args: ['class.hidden']
        }], menuButton: [{
            type: ViewChild,
            args: ['menuButton', { static: false }]
        }], mobileNav: [{
            type: ViewChild,
            args: ['mobileNav', { static: false }]
        }], mainNav: [{
            type: ViewChild,
            args: ['mainNav', { static: false }]
        }], accountNav: [{
            type: ViewChild,
            args: ['accountNav', { static: false }]
        }], mobileNavIsOpen: [{
            type: Output
        }], accountName: [{
            type: Input
        }], accountNumber: [{
            type: Input
        }], plan: [{
            type: Input
        }] }); })();

function NotificationComponent_ng_template_0_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("icon ", ctx_r4.icon, "");
} }
function NotificationComponent_ng_template_0_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function NotificationComponent_ng_template_0_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.dismiss()); });
    i0.ɵɵelementEnd();
} }
function NotificationComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, NotificationComponent_ng_template_0_span_1_Template, 1, 3, "span", 4);
    i0.ɵɵelementStart(2, "div")(3, "div", 5);
    i0.ɵɵprojection(4);
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(5, 1);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, NotificationComponent_ng_template_0_button_6_Template, 1, 0, "button", 6);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("role", ctx_r1.role);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.icon);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.showDismissButton);
} }
function NotificationComponent_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function NotificationComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NotificationComponent_div_2_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵclassMapInterpolate1("notification type-", ctx_r2.type, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function NotificationComponent_a_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function NotificationComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵtemplate(1, NotificationComponent_a_3_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵclassMapInterpolate1("notification type-", ctx_r3.type, " arrow");
    i0.ɵɵproperty("routerLink", ctx_r3.link);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
const _c0$h = ["*", [["", 8, "button-container"]]];
const _c1$9 = ["*", ".button-container"];
class NotificationComponent {
    constructor() {
        this.type = NotificationType.Default;
        this.showDismissButton = false;
        this.dismissEvent = new EventEmitter();
        this.element = 'div';
        this.role = null;
    }
    dismiss() {
        this.dismissEvent.emit();
    }
    ngOnInit() {
        this.role = ([
            NotificationType.Success,
            NotificationType.Error,
            NotificationType.Maintenance
        ]
            .includes(this.type)) ? 'alert' : null;
        this.element = this.link
            ? 'a'
            : 'div';
    }
    static { this.ɵfac = function NotificationComponent_Factory(t) { return new (t || NotificationComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotificationComponent, selectors: [["sumday-notification"]], inputs: { icon: "icon", link: "link", type: "type", showDismissButton: "showDismissButton" }, outputs: { dismissEvent: "dismissEvent" }, ngContentSelectors: _c1$9, decls: 4, vars: 2, consts: [["content", ""], [3, "class", 4, "ngIf"], [3, "class", "routerLink", 4, "ngIf"], [1, "content"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], [1, "text"], ["class", "btn-icon btn-inverse icon-close", "aria-label", "Dismiss this message", 3, "click", 4, "ngIf"], ["aria-hidden", "true"], ["aria-label", "Dismiss this message", 1, "btn-icon", "btn-inverse", "icon-close", 3, "click"], [4, "ngTemplateOutlet"], [3, "routerLink"]], template: function NotificationComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$h);
            i0.ɵɵtemplate(0, NotificationComponent_ng_template_0_Template, 7, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(2, NotificationComponent_div_2_Template, 2, 4, "div", 1);
            i0.ɵɵtemplate(3, NotificationComponent_a_3_Template, 2, 5, "a", 2);
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.link);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.link);
        } }, dependencies: [i1$1.NgIf, i1$1.NgTemplateOutlet, i1$2.RouterLink], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationComponent, [{
        type: Component,
        args: [{ selector: 'sumday-notification', template: "<ng-template #content>\n  <div class=\"content\" [attr.role]=\"role\">\n    <span *ngIf=\"icon\" aria-hidden=\"true\" class=\"icon {{icon}}\"></span>\n    <div>\n      <div class=\"text\">\n        <ng-content></ng-content>\n      </div>\n      <ng-content select=\".button-container\"></ng-content>\n    </div>\n  </div>\n  <button *ngIf=\"showDismissButton\" (click)=\"dismiss()\" class=\"btn-icon btn-inverse icon-close\" aria-label=\"Dismiss this message\"></button>\n</ng-template>\n\n<div *ngIf=\"!link\"\n     class=\"notification type-{{type}}\">\n  <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n</div>\n\n<a *ngIf=\"link\"\n   class=\"notification type-{{type}} arrow\"\n   [routerLink]=\"link\">\n  <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n</a>\n" }]
    }], function () { return []; }, { icon: [{
            type: Input
        }], link: [{
            type: Input
        }], type: [{
            type: Input
        }], showDismissButton: [{
            type: Input
        }], dismissEvent: [{
            type: Output
        }] }); })();

class ProgressBarComponent {
    get percent() { return this._percent; }
    set percent(percent) {
        this._percent = percent;
        this.barWidth = Math.min(percent, 100);
    }
    static { this.ɵfac = function ProgressBarComponent_Factory(t) { return new (t || ProgressBarComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProgressBarComponent, selectors: [["sumday-progress-bar"]], inputs: { labelId: "labelId", percent: "percent" }, decls: 4, vars: 4, consts: [[1, "progress-bar"], [1, "screen-reader-only"], [1, "fill"]], template: function ProgressBarComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "div", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵattribute("aria-labelledby", ctx.labelId);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1("", ctx.percent, "%");
            i0.ɵɵadvance(1);
            i0.ɵɵstyleProp("width", ctx.barWidth + "%");
        } }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressBarComponent, [{
        type: Component,
        args: [{ selector: 'sumday-progress-bar', template: "<div class=\"progress-bar\">\n  <span [attr.aria-labelledby]=\"labelId\" class=\"screen-reader-only\">{{ percent }}%</span>\n  <div [style.width]=\"barWidth + '%'\" class=\"fill\"></div>\n</div>\n" }]
    }], null, { labelId: [{
            type: Input
        }], percent: [{
            type: Input
        }] }); })();

class ScreenReaderAnnouncementComponent {
    constructor(_ngZone) {
        this._ngZone = _ngZone;
        this.text = '';
    }
    ngOnChanges(changes) {
        if (changes.text &&
            changes.text.currentValue &&
            changes.text.currentValue !== this.text) {
            this._ngZone.runOutsideAngular(() => {
                setTimeout(() => {
                    this._ngZone.run(() => {
                        this.text = `${this.text}`;
                    });
                    setTimeout(() => {
                        this._ngZone.run(() => {
                            this.text = '';
                        });
                        // eslint-disable-next-line max-len
                    }, 7000); // ios sucks, if you remove the text in < time than it takes to read it cuts off.  If you leave the text it can be focused
                }, 150);
            });
        }
    }
    static { this.ɵfac = function ScreenReaderAnnouncementComponent_Factory(t) { return new (t || ScreenReaderAnnouncementComponent)(i0.ɵɵdirectiveInject(i0.NgZone)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScreenReaderAnnouncementComponent, selectors: [["sumday-screen-reader-announcement"]], inputs: { text: "text" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["role", "status", "aria-atomic", "true", "aria-relevant", "additions", "aria-live", "polite", 1, "screen-reader-only", 3, "innerHtml"]], template: function ScreenReaderAnnouncementComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("innerHtml", ctx.text, i0.ɵɵsanitizeHtml);
        } }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScreenReaderAnnouncementComponent, [{
        type: Component,
        args: [{ selector: 'sumday-screen-reader-announcement', template: "<div\n  class=\"screen-reader-only\"\n  role=\"status\"\n  aria-atomic=\"true\"\n  aria-relevant=\"additions\"\n  aria-live=\"polite\" [innerHtml]=\"text\">\n</div>\n" }]
    }], function () { return [{ type: i0.NgZone }]; }, { text: [{
            type: Input
        }] }); })();

class SocialLinksComponent {
    constructor() {
        this.disabled = false;
    }
    getFacebookLink() {
        return this.link
            ? `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.link)}`
            : null;
    }
    getTwitterLink() {
        return this.tweet
            ? `http://twitter.com/share?url=${encodeURIComponent(this.link)}&text=${encodeURIComponent(this.tweet)}`
            : null;
    }
    getMailTo() {
        if (this.email) {
            let mailTo = [];
            Object.entries(this.email).forEach(([key, value]) => {
                if (value) {
                    mailTo.push(`${key}=${encodeURIComponent(value.trim())}`);
                }
            });
            return `mailto:?${mailTo.join('&')}`;
        }
        else {
            return null;
        }
    }
    static { this.ɵfac = function SocialLinksComponent_Factory(t) { return new (t || SocialLinksComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SocialLinksComponent, selectors: [["sumday-social-links"]], inputs: { link: "link", tweet: "tweet", email: "email", disabled: "disabled" }, decls: 4, vars: 6, consts: [[1, "button-container"], ["target", "_blank", "aria-label", "share on facebook", 1, "button", "btn-icon", "icon-facebook"], ["target", "_blank", "aria-label", "share on twitter", 1, "button", "btn-icon", "icon-twitter"], ["target", "_blank", "aria-label", "share with an email", 1, "button", "btn-icon", "icon-mail"]], template: function SocialLinksComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "a", 1)(2, "a", 2)(3, "a", 3);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵattribute("href", ctx.getFacebookLink(), i0.ɵɵsanitizeUrl)("disabled", ctx.disabled ? true : null);
            i0.ɵɵadvance(1);
            i0.ɵɵattribute("href", ctx.getTwitterLink(), i0.ɵɵsanitizeUrl)("disabled", ctx.disabled ? true : null);
            i0.ɵɵadvance(1);
            i0.ɵɵattribute("href", ctx.getMailTo(), i0.ɵɵsanitizeUrl)("disabled", ctx.disabled ? true : null);
        } }, dependencies: [i1.TargetBlankDirective], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SocialLinksComponent, [{
        type: Component,
        args: [{ selector: 'sumday-social-links', template: "<div class=\"button-container\">\n  <a\n    [attr.href]=\"getFacebookLink()\"\n    [attr.disabled]=\"disabled ? true : null\"\n    target=\"_blank\"\n    class=\"button btn-icon icon-facebook\"\n    aria-label=\"share on facebook\"\n  ></a>\n\n  <a\n    [attr.href]=\"getTwitterLink()\"\n    [attr.disabled]=\"disabled ? true : null\"\n    target=\"_blank\"\n    class=\"button btn-icon icon-twitter\"\n    aria-label=\"share on twitter\"\n  ></a>\n\n  <a\n    [attr.href]=\"getMailTo()\"\n    [attr.disabled]=\"disabled ? true : null\"\n    target=\"_blank\"\n    class=\"button btn-icon icon-mail\"\n    aria-label=\"share with an email\"\n  ></a>\n</div>\n" }]
    }], function () { return []; }, { link: [{
            type: Input
        }], tweet: [{
            type: Input
        }], email: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

function StepsComponent_ul_0_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "button", 3);
    i0.ɵɵlistener("click", function StepsComponent_ul_0_li_1_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const step_r2 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.getStepFunction(step_r2)); });
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const step_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("routerLink", ctx_r1.getStepLink(step_r2))("ngClass", ctx_r1.getState(i_r3))("disabled", ctx_r1.getIsDisabled(i_r3));
    i0.ɵɵattribute("tabIndex", ctx_r1.getTabIndex(i_r3))("aria-current", ctx_r1.getAriaCurrentValue(i_r3));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r1.getCurrentText(i_r3), "Step");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i_r3 + 1, "");
} }
function StepsComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 1);
    i0.ɵɵtemplate(1, StepsComponent_ul_0_li_1_Template, 5, 7, "li", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.steps);
} }
class StepsComponent {
    constructor() { }
    canAccessStep(stepIndex) {
        return stepIndex <= this.maxAccessibleStepIndex;
    }
    getStepLink(step) {
        // Use it as a routerLink if it's a string
        return (Array.isArray(step) || typeof step === 'string') ? step : null;
    }
    getStepFunction(step) {
        if (typeof step === 'function') {
            step();
        }
    }
    getState(stepIndex) {
        return {
            disabled: !this.canAccessStep(stepIndex),
            current: this.currentStepIndex === stepIndex
        };
    }
    getIsDisabled(stepIndex) {
        return (!this.canAccessStep(stepIndex)) ? true : null;
    }
    getCurrentText(stepIndex) {
        if (this.currentStepIndex === stepIndex) {
            return 'Current ';
        }
        return '';
    }
    getAriaCurrentValue(stepIndex) {
        if (this.currentStepIndex === stepIndex) {
            return 'step';
        }
        return null;
    }
    getTabIndex(stepIndex) {
        if (this.canAccessStep(stepIndex)) {
            return 0;
        }
        return null;
    }
    static { this.ɵfac = function StepsComponent_Factory(t) { return new (t || StepsComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StepsComponent, selectors: [["sumday-steps"]], inputs: { steps: "steps", currentStepIndex: "currentStepIndex", maxAccessibleStepIndex: "maxAccessibleStepIndex" }, decls: 1, vars: 1, consts: [["class", "steps", 4, "ngIf"], [1, "steps"], [4, "ngFor", "ngForOf"], [1, "no-default-styles", 3, "routerLink", "ngClass", "disabled", "click"], [1, "screen-reader-only"]], template: function StepsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, StepsComponent_ul_0_Template, 2, 1, "ul", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", (ctx.steps == null ? null : ctx.steps.length) > 1);
        } }, dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, i1$2.RouterLink], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StepsComponent, [{
        type: Component,
        args: [{ selector: 'sumday-steps', template: "<ul *ngIf=\"steps?.length > 1\" class=\"steps\">\n  <li *ngFor=\"let step of steps; let i = index;\">\n    <button\n      class=\"no-default-styles\"\n      (click)=\"getStepFunction(step)\"\n      [routerLink]=\"getStepLink(step)\"\n      [ngClass]=\"getState(i)\"\n      [disabled]=\"getIsDisabled(i)\"\n      [attr.tabIndex]=\"getTabIndex(i)\"\n      [attr.aria-current]=\"getAriaCurrentValue(i)\"><span class=\"screen-reader-only\">{{getCurrentText(i)}}Step</span> {{i+1}}</button>\n  </li>\n</ul>\n" }]
    }], function () { return []; }, { steps: [{
            type: Input
        }], currentStepIndex: [{
            type: Input
        }], maxAccessibleStepIndex: [{
            type: Input
        }] }); })();

const _c0$g = ["*"];
class TablistComponent {
    constructor(_element) {
        this._element = _element;
        this.tabs = [];
        this.panelId = null;
        this.hasKeyboardFocusedItem = false;
        this.clickEvent = ($event) => {
            for (let i = 0, len = this.tabs.length; i < len; i += 1) {
                let tab = this.tabs[i];
                if (tab.tabIndex === 0) {
                    tab.tabIndex = -1;
                    $event.currentTarget['tabIndex'] = 0;
                    this.hasKeyboardFocusedItem = false;
                    break;
                }
            }
        };
        this.tabKeyboardEvent = ($event) => {
            if ($event.keyCode >= KeyCodes.ARROW_LEFT && $event.keyCode <= KeyCodes.ARROW_DOWN) {
                $event.preventDefault();
                $event.stopPropagation();
                for (let i = 0, len = this.tabs.length; i < len; i += 1) {
                    let tab = this.tabs[i];
                    if (tab.tabIndex === 0) {
                        let direction = -1;
                        if ($event.keyCode > KeyCodes.ARROW_UP) { // they used right or down
                            direction = 1;
                        }
                        if (this.tabs[i + direction]) {
                            tab.tabIndex = -1;
                            let nextTab = this.tabs[i + direction];
                            nextTab.tabIndex = 0;
                            nextTab.click();
                            setTimeout(() => {
                                nextTab.focus();
                                this.hasKeyboardFocusedItem = true;
                            }, 10);
                        }
                        break;
                    }
                }
            }
        };
    }
    ngOnDestroy() {
        this.removeEvents();
    }
    removeEvents() {
        for (let i = 0, len = this.tabs.length; i < len; i += 1) {
            let tab = this.tabs[i];
            tab.removeEventListener('keydown', this.tabKeyboardEvent);
            tab.removeEventListener('click', this.clickEvent);
        }
        if (this.panelId && document.getElementById(this.panelId)) {
            document.getElementById(this.panelId).removeEventListener('keydown', this.tabKeyboardEvent);
        }
    }
    setupEvents() {
        this.tabs = Array.prototype.slice.call(this._element.nativeElement.querySelectorAll('[role="tab"]'), 0);
        for (let i = 0, len = this.tabs.length; i < len; i += 1) {
            let tab = this.tabs[i];
            this.panelId = tab.getAttribute('aria-controls');
            tab.addEventListener('keydown', this.tabKeyboardEvent);
            tab.addEventListener('click', this.clickEvent);
        }
        if (this.panelId) {
            document.getElementById(this.panelId).addEventListener('keydown', this.tabKeyboardEvent);
        }
    }
    ngAfterViewInit() {
        this.setupEvents();
        this.domObserver = new MutationObserver(mutations => {
            mutations.forEach((mutation) => {
                // check to see if the size of the list has changed
                // this happens on infinite scroll
                if (this.tabs.length !== this._element.nativeElement.querySelectorAll('.content-row').length) {
                    // if it has we need to dump the old events and add new ones
                    this.removeEvents();
                    this.setupEvents();
                    if (this.hasKeyboardFocusedItem) {
                        setTimeout(() => {
                            const item = this._element.nativeElement.querySelector('.content-row.active');
                            if (item) {
                                item.focus();
                            }
                        }, 10);
                    }
                }
            });
        });
        this.domObserver.observe(this._element.nativeElement, { childList: true });
    }
    static { this.ɵfac = function TablistComponent_Factory(t) { return new (t || TablistComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TablistComponent, selectors: [["sumday-tablist"]], ngContentSelectors: _c0$g, decls: 3, vars: 0, consts: [["role", "tablist"], ["role", "presentation"]], template: function TablistComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "ul", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd()();
        } }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TablistComponent, [{
        type: Component,
        args: [{ selector: 'sumday-tablist', template: "<div role=\"tablist\">\n  <ul role=\"presentation\">\n    <ng-content></ng-content>\n  </ul>\n</div>\n" }]
    }], function () { return [{ type: i0.ElementRef }]; }, null); })();

const _c0$f = ["*"];
class TabRowComponent {
    constructor() {
        this.selected = false;
        this.controls = '';
        this.extraClass = '';
    }
    ngOnInit() {
        if (this.controls.length === 0) {
            throw Error('sumday-tabrow requires you to set \'controls\' for the aria-controls property');
        }
    }
    static { this.ɵfac = function TabRowComponent_Factory(t) { return new (t || TabRowComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TabRowComponent, selectors: [["sumday-tabrow"]], inputs: { selected: "selected", controls: "controls", extraClass: "extraClass" }, ngContentSelectors: _c0$f, decls: 3, vars: 8, consts: [["role", "tab"], [1, "row-content"]], template: function TabRowComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("content-row ", ctx.extraClass, "");
            i0.ɵɵclassProp("active", ctx.selected);
            i0.ɵɵattribute("aria-controls", ctx.controls)("aria-current", ctx.selected)("tabindex", ctx.selected ? 0 : -1);
        } }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabRowComponent, [{
        type: Component,
        args: [{ selector: 'sumday-tabrow', template: "<div\n  class=\"content-row {{extraClass}}\"\n  role=\"tab\"\n  [attr.aria-controls]=\"controls\"\n  [attr.aria-current]=\"selected\"\n  [class.active]=\"selected\"\n  [attr.tabindex]=\"(selected) ? 0 : -1\">\n  <div class=\"row-content\">\n    <ng-content></ng-content>\n  </div>\n</div>" }]
    }], null, { selected: [{
            type: Input
        }], controls: [{
            type: Input
        }], extraClass: [{
            type: Input
        }] }); })();

const _c0$e = ["input"];
class BaseToggleFormControl {
    set id(setId) {
        if (setId) {
            this.inputId = `${setId}-input`;
        }
    }
    constructor() {
        this.disabled = false;
        this.ariaLabel = null;
        this.ariaDescribedBy = null;
        this.ariaErrorMessage = null;
        this.value = true;
        this.checked = false;
        this.onChangeCallback = () => { };
        this.onTouchedCallback = () => { };
    }
    getValue(checked) {
        return this.checked
            ? this.value
            : null;
    }
    isChecked(value) {
        // It's checked if the formcontrol value is the same as this input's internal value
        return this.value === value;
    }
    writeValue(value) {
        // We don't want to send a change event if nothing's actually changed
        if (this.isChecked(value) !== this.checked) {
            // Only fire the actual change event on the activated toggle
            if (this.isChecked(value)) {
                this.onChange(!this.checked);
                // All other toggles in the group just update their internal status
            }
            else {
                this.checked = !this.checked;
            }
        }
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onToggle(e) {
        let target = e.target;
        this.onChange(target.checked);
    }
    onChange(checked) {
        this.checked = checked;
        this.onTouched();
        this.onChangeCallback(this.getValue(this.checked));
    }
    onTouched() {
        this.onTouchedCallback();
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    static { this.ɵfac = function BaseToggleFormControl_Factory(t) { return new (t || BaseToggleFormControl)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: BaseToggleFormControl, viewQuery: function BaseToggleFormControl_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$e, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputRef = _t.first);
        } }, hostVars: 1, hostBindings: function BaseToggleFormControl_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵattribute("data-value", ctx.value);
        } }, inputs: { disabled: "disabled", errorMessageMappings: "errorMessageMappings", fieldParams: "fieldParams", ariaLabel: "ariaLabel", ariaDescribedBy: "ariaDescribedBy", ariaErrorMessage: "ariaErrorMessage", useBottomFocus: "useBottomFocus", formControl: "formControl", formControlName: "formControlName", id: "id", value: "value" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseToggleFormControl, [{
        type: Directive
    }], function () { return []; }, { inputRef: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }], disabled: [{
            type: Input
        }], errorMessageMappings: [{
            type: Input
        }], fieldParams: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], ariaDescribedBy: [{
            type: Input
        }], ariaErrorMessage: [{
            type: Input
        }], useBottomFocus: [{
            type: Input
        }], formControl: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], id: [{
            type: Input
        }], value: [{
            type: HostBinding,
            args: ['attr.data-value']
        }, {
            type: Input
        }] }); })();

function CheckboxComponent__svg_circle_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "circle", 9);
} }
function CheckboxComponent__svg_path_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "path", 10);
} }
function CheckboxComponent_sumday_validations_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(0, "sumday-validations", 11);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("errorMessageMappings", ctx_r3.errorMessageMappings[ctx_r3.formControlName])("fieldParams", ctx_r3.fieldParams);
} }
const _c0$d = ["*"];
let id$6 = 0;
class CheckboxComponent extends BaseToggleFormControl {
    constructor() {
        super();
        this.inputId = `checkbox-${id$6++}-input`;
        this.type = ToggleType.Checkbox;
    }
    static { this.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["sumday-checkbox"]], features: [i0.ɵɵProvidersFeature([{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => CheckboxComponent),
                    multi: true
                }]), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0$d, decls: 10, vars: 19, consts: [[1, "toggle"], [3, "type", "checked", "id", "name", "disabled", "change"], ["input", ""], [3, "id"], [1, "toggle-mark"], ["width", "100%", "height", "100%", "focusable", "false", "role", "presentation", "viewPort", "0 0 100 100", "viewBox", "0 0 100 100", "preserveAspectRatio", "xMidYMid meet", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 3, "ngSwitch"], ["class", "radio", "role", "presentation", "cx", "50%", "cy", "50%", "r", "48", 4, "ngSwitchCase"], ["class", "check", "role", "presentation", "d", "M10 45l28,28l55,-55", 4, "ngSwitchCase"], [3, "errorMessageMappings", "fieldParams", 4, "ngIf"], ["role", "presentation", "cx", "50%", "cy", "50%", "r", "48", 1, "radio"], ["role", "presentation", "d", "M10 45l28,28l55,-55", 1, "check"], [3, "errorMessageMappings", "fieldParams"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "input", 1, 2);
            i0.ɵɵlistener("change", function CheckboxComponent_Template_input_change_1_listener($event) { return ctx.onToggle($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "label", 3)(4, "span", 4);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(5, "svg", 5);
            i0.ɵɵtemplate(6, CheckboxComponent__svg_circle_6_Template, 1, 0, "circle", 6);
            i0.ɵɵtemplate(7, CheckboxComponent__svg_path_7_Template, 1, 0, "path", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵprojection(8);
            i0.ɵɵtemplate(9, CheckboxComponent_sumday_validations_9_Template, 1, 2, "sumday-validations", 8);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵclassProp("bottom-focus", ctx.useBottomFocus)("has-internal-validation", ctx.errorMessageMappings);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("type", ctx.type)("checked", ctx.checked)("id", ctx.inputId)("name", ctx.formControlName)("disabled", ctx.disabled);
            i0.ɵɵattribute("aria-disabled", ctx.disabled)("aria-label", ctx.ariaLabel)("aria-labelledby", ctx.inputId + "Label")("aria-describedby", ctx.ariaDescribedBy);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("id", ctx.inputId + "Label");
            i0.ɵɵattribute("for", ctx.inputId);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngSwitch", ctx.type);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", "radio");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", "checkbox");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.errorMessageMappings);
        } }, dependencies: [i1$1.NgIf, i1$1.NgSwitch, i1$1.NgSwitchCase, ValidationsComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{ selector: 'sumday-checkbox', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CheckboxComponent),
                        multi: true
                    }], template: "<div class=\"toggle\" [class.bottom-focus]=\"useBottomFocus\" [class.has-internal-validation]=\"errorMessageMappings\">\n  <input\n    #input\n    [type]=\"type\"\n    [checked]=\"checked\"\n    [id]=\"inputId\"\n    [name]=\"formControlName\"\n    [disabled]=\"disabled\"\n    [attr.aria-disabled]=\"disabled\"\n    [attr.aria-label]=\"ariaLabel\"\n    [attr.aria-labelledby]=\"inputId + 'Label'\"\n    [attr.aria-describedby]=\"ariaDescribedBy\"\n    (change)=\"onToggle($event)\"\n  />\n\n  <label [id]=\"inputId + 'Label'\" [attr.for]=\"inputId\">\n     <span\n      class=\"toggle-mark\">\n       <svg width=\"100%\" height=\"100%\"\n          focusable=\"false\"\n          role=\"presentation\"\n          viewPort=\"0 0 100 100\"\n          viewBox=\"0 0 100 100\"\n          preserveAspectRatio=\"xMidYMid meet\"\n          version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\n          [ngSwitch]=\"type\">\n        <circle *ngSwitchCase=\"'radio'\" class=\"radio\" role=\"presentation\" cx=\"50%\" cy=\"50%\" r=\"48\"></circle>\n        <path *ngSwitchCase=\"'checkbox'\" class=\"check\" role=\"presentation\"  d=\"M10 45l28,28l55,-55\"></path>\n      </svg>\n    </span>\n\n    <ng-content></ng-content>\n\n    <sumday-validations *ngIf=\"errorMessageMappings\" [errorMessageMappings]=\"errorMessageMappings[formControlName]\" [fieldParams]=\"fieldParams\"></sumday-validations>\n  </label>\n\n</div>\n" }]
    }], function () { return []; }, null); })();

function ChecklistComponent__svg_circle_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "circle", 9);
} }
function ChecklistComponent__svg_path_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "path", 10);
} }
function ChecklistComponent_sumday_validations_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(0, "sumday-validations", 11);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("errorMessageMappings", ctx_r3.errorMessageMappings[ctx_r3.formControlName])("fieldParams", ctx_r3.fieldParams);
} }
const _c0$c = ["*"];
let id$5 = 0;
class ChecklistComponent extends BaseToggleFormControl {
    constructor(controlContainer) {
        super();
        this.inputId = `checklist-${id$5++}-input`;
        this.type = ToggleType.Checkbox;
        this.controlContainer = controlContainer;
    }
    ngOnInit() {
        // Gets the form control so we can get the existing value for the group and modify it
        if (!this.control) {
            if (this.formControl) {
                this.control = this.formControl;
            }
            else if (this.controlContainer) {
                if (this.formControlName) {
                    this.control = this.controlContainer.control.get(this.formControlName);
                }
                else {
                    isDevMode() && console.warn(`Missing FormControlName directive from sumday-checklist component`);
                }
            }
            else {
                isDevMode() && console.warn(`Can't find parent FormGroup directive of sumday-checklist component`);
            }
        }
    }
    getValue(checked) {
        if (this.control.value && !Array.isArray(this.control.value)) {
            isDevMode() && console.warn(`${this.formControlName} should be an array to be used with a checklist`);
        }
        let value = this.control.value || [];
        if (checked && !value.includes(this.value)) {
            value.push(this.value);
        }
        else {
            value = value.filter(e => e !== this.value);
        }
        return value;
    }
    isChecked(value) {
        // It's checked if the formcontrol value contains this input's internal value
        return value ? value.includes(this.value) : false;
    }
    static { this.ɵfac = function ChecklistComponent_Factory(t) { return new (t || ChecklistComponent)(i0.ɵɵdirectiveInject(i1$4.ControlContainer, 5)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChecklistComponent, selectors: [["sumday-checklist"]], features: [i0.ɵɵProvidersFeature([{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => ChecklistComponent),
                    multi: true
                }]), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0$c, decls: 10, vars: 19, consts: [[1, "toggle"], [3, "type", "checked", "id", "name", "disabled", "change"], ["input", ""], [3, "id"], [1, "toggle-mark"], ["width", "100%", "height", "100%", "focusable", "false", "role", "presentation", "viewPort", "0 0 100 100", "viewBox", "0 0 100 100", "preserveAspectRatio", "xMidYMid meet", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 3, "ngSwitch"], ["class", "radio", "role", "presentation", "cx", "50%", "cy", "50%", "r", "48", 4, "ngSwitchCase"], ["class", "check", "role", "presentation", "d", "M10 45l28,28l55,-55", 4, "ngSwitchCase"], [3, "errorMessageMappings", "fieldParams", 4, "ngIf"], ["role", "presentation", "cx", "50%", "cy", "50%", "r", "48", 1, "radio"], ["role", "presentation", "d", "M10 45l28,28l55,-55", 1, "check"], [3, "errorMessageMappings", "fieldParams"]], template: function ChecklistComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "input", 1, 2);
            i0.ɵɵlistener("change", function ChecklistComponent_Template_input_change_1_listener($event) { return ctx.onToggle($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "label", 3)(4, "span", 4);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(5, "svg", 5);
            i0.ɵɵtemplate(6, ChecklistComponent__svg_circle_6_Template, 1, 0, "circle", 6);
            i0.ɵɵtemplate(7, ChecklistComponent__svg_path_7_Template, 1, 0, "path", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵprojection(8);
            i0.ɵɵtemplate(9, ChecklistComponent_sumday_validations_9_Template, 1, 2, "sumday-validations", 8);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵclassProp("bottom-focus", ctx.useBottomFocus)("has-internal-validation", ctx.errorMessageMappings);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("type", ctx.type)("checked", ctx.checked)("id", ctx.inputId)("name", ctx.formControlName)("disabled", ctx.disabled);
            i0.ɵɵattribute("aria-disabled", ctx.disabled)("aria-label", ctx.ariaLabel)("aria-labelledby", ctx.inputId + "Label")("aria-describedby", ctx.ariaDescribedBy);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("id", ctx.inputId + "Label");
            i0.ɵɵattribute("for", ctx.inputId);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngSwitch", ctx.type);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", "radio");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", "checkbox");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.errorMessageMappings);
        } }, dependencies: [i1$1.NgIf, i1$1.NgSwitch, i1$1.NgSwitchCase, ValidationsComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChecklistComponent, [{
        type: Component,
        args: [{ selector: 'sumday-checklist', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => ChecklistComponent),
                        multi: true
                    }], template: "<div class=\"toggle\" [class.bottom-focus]=\"useBottomFocus\" [class.has-internal-validation]=\"errorMessageMappings\">\n  <input\n    #input\n    [type]=\"type\"\n    [checked]=\"checked\"\n    [id]=\"inputId\"\n    [name]=\"formControlName\"\n    [disabled]=\"disabled\"\n    [attr.aria-disabled]=\"disabled\"\n    [attr.aria-label]=\"ariaLabel\"\n    [attr.aria-labelledby]=\"inputId + 'Label'\"\n    [attr.aria-describedby]=\"ariaDescribedBy\"\n    (change)=\"onToggle($event)\"\n  />\n\n  <label [id]=\"inputId + 'Label'\" [attr.for]=\"inputId\">\n     <span\n      class=\"toggle-mark\">\n       <svg width=\"100%\" height=\"100%\"\n          focusable=\"false\"\n          role=\"presentation\"\n          viewPort=\"0 0 100 100\"\n          viewBox=\"0 0 100 100\"\n          preserveAspectRatio=\"xMidYMid meet\"\n          version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\n          [ngSwitch]=\"type\">\n        <circle *ngSwitchCase=\"'radio'\" class=\"radio\" role=\"presentation\" cx=\"50%\" cy=\"50%\" r=\"48\"></circle>\n        <path *ngSwitchCase=\"'checkbox'\" class=\"check\" role=\"presentation\"  d=\"M10 45l28,28l55,-55\"></path>\n      </svg>\n    </span>\n\n    <ng-content></ng-content>\n\n    <sumday-validations *ngIf=\"errorMessageMappings\" [errorMessageMappings]=\"errorMessageMappings[formControlName]\" [fieldParams]=\"fieldParams\"></sumday-validations>\n  </label>\n\n</div>\n" }]
    }], function () { return [{ type: i1$4.ControlContainer, decorators: [{
                type: Host
            }, {
                type: SkipSelf
            }] }]; }, null); })();

function RadioComponent__svg_circle_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "circle", 9);
} }
function RadioComponent__svg_path_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "path", 10);
} }
function RadioComponent_sumday_validations_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(0, "sumday-validations", 11);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("errorMessageMappings", ctx_r3.errorMessageMappings[ctx_r3.formControlName])("fieldParams", ctx_r3.fieldParams);
} }
const _c0$b = ["*"];
let id$4 = 0;
class RadioComponent extends BaseToggleFormControl {
    constructor() {
        super();
        this.inputId = `radio-${id$4++}-input`;
        this.type = ToggleType.Radio;
    }
    static { this.ɵfac = function RadioComponent_Factory(t) { return new (t || RadioComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RadioComponent, selectors: [["sumday-radio"]], features: [i0.ɵɵProvidersFeature([{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => RadioComponent),
                    multi: true
                }]), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0$b, decls: 10, vars: 19, consts: [[1, "toggle"], [3, "type", "checked", "id", "name", "disabled", "change"], ["input", ""], [3, "id"], [1, "toggle-mark"], ["width", "100%", "height", "100%", "focusable", "false", "role", "presentation", "viewPort", "0 0 100 100", "viewBox", "0 0 100 100", "preserveAspectRatio", "xMidYMid meet", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 3, "ngSwitch"], ["class", "radio", "role", "presentation", "cx", "50%", "cy", "50%", "r", "48", 4, "ngSwitchCase"], ["class", "check", "role", "presentation", "d", "M10 45l28,28l55,-55", 4, "ngSwitchCase"], [3, "errorMessageMappings", "fieldParams", 4, "ngIf"], ["role", "presentation", "cx", "50%", "cy", "50%", "r", "48", 1, "radio"], ["role", "presentation", "d", "M10 45l28,28l55,-55", 1, "check"], [3, "errorMessageMappings", "fieldParams"]], template: function RadioComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "input", 1, 2);
            i0.ɵɵlistener("change", function RadioComponent_Template_input_change_1_listener($event) { return ctx.onToggle($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "label", 3)(4, "span", 4);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(5, "svg", 5);
            i0.ɵɵtemplate(6, RadioComponent__svg_circle_6_Template, 1, 0, "circle", 6);
            i0.ɵɵtemplate(7, RadioComponent__svg_path_7_Template, 1, 0, "path", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵprojection(8);
            i0.ɵɵtemplate(9, RadioComponent_sumday_validations_9_Template, 1, 2, "sumday-validations", 8);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵclassProp("bottom-focus", ctx.useBottomFocus)("has-internal-validation", ctx.errorMessageMappings);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("type", ctx.type)("checked", ctx.checked)("id", ctx.inputId)("name", ctx.formControlName)("disabled", ctx.disabled);
            i0.ɵɵattribute("aria-disabled", ctx.disabled)("aria-label", ctx.ariaLabel)("aria-labelledby", ctx.inputId + "Label")("aria-describedby", ctx.ariaDescribedBy);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("id", ctx.inputId + "Label");
            i0.ɵɵattribute("for", ctx.inputId);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngSwitch", ctx.type);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", "radio");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", "checkbox");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.errorMessageMappings);
        } }, dependencies: [i1$1.NgIf, i1$1.NgSwitch, i1$1.NgSwitchCase, ValidationsComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioComponent, [{
        type: Component,
        args: [{ selector: 'sumday-radio', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => RadioComponent),
                        multi: true
                    }], template: "<div class=\"toggle\" [class.bottom-focus]=\"useBottomFocus\" [class.has-internal-validation]=\"errorMessageMappings\">\n  <input\n    #input\n    [type]=\"type\"\n    [checked]=\"checked\"\n    [id]=\"inputId\"\n    [name]=\"formControlName\"\n    [disabled]=\"disabled\"\n    [attr.aria-disabled]=\"disabled\"\n    [attr.aria-label]=\"ariaLabel\"\n    [attr.aria-labelledby]=\"inputId + 'Label'\"\n    [attr.aria-describedby]=\"ariaDescribedBy\"\n    (change)=\"onToggle($event)\"\n  />\n\n  <label [id]=\"inputId + 'Label'\" [attr.for]=\"inputId\">\n     <span\n      class=\"toggle-mark\">\n       <svg width=\"100%\" height=\"100%\"\n          focusable=\"false\"\n          role=\"presentation\"\n          viewPort=\"0 0 100 100\"\n          viewBox=\"0 0 100 100\"\n          preserveAspectRatio=\"xMidYMid meet\"\n          version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\n          [ngSwitch]=\"type\">\n        <circle *ngSwitchCase=\"'radio'\" class=\"radio\" role=\"presentation\" cx=\"50%\" cy=\"50%\" r=\"48\"></circle>\n        <path *ngSwitchCase=\"'checkbox'\" class=\"check\" role=\"presentation\"  d=\"M10 45l28,28l55,-55\"></path>\n      </svg>\n    </span>\n\n    <ng-content></ng-content>\n\n    <sumday-validations *ngIf=\"errorMessageMappings\" [errorMessageMappings]=\"errorMessageMappings[formControlName]\" [fieldParams]=\"fieldParams\"></sumday-validations>\n  </label>\n\n</div>\n" }]
    }], function () { return []; }, null); })();

const _c0$a = ["tooltip"];
const _c1$8 = ["tooltipButton"];
const _c2$1 = ["tooltipBubble"];
function TooltipComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.headline);
} }
const _c3 = function (a0) { return { "hidden": a0 }; };
const _c4 = ["*"];
let currentlyOpen; // Keeps track if which tooltip is open, globally
class TooltipComponent {
    constructor() {
        this.direction = 'top-left';
        this.idProperty = 'tooltipId';
        this.moveCount = 0;
    }
    ngOnInit() {
        this.idProperty = `tooltip_${Date.now()}${Math.floor(Math.random() * 1000000)}`;
        this.isOpen = false;
        this.currentDirection = this.direction;
        setTimeout(() => this.checkDirection());
    }
    ngAfterViewInit() {
        // The timeout *shouldn't* be necessary, but it is, and idk why
        setTimeout(() => this.checkDirection());
    }
    // We're using HostListener for some of the events so we don't flicker between the icon and the tooltip
    onWindowResize(event) {
        // Reset the direction on resize, so we double check it just in case
        this.resetDirection();
        this.checkDirection();
    }
    onClickEvent(event, targetElement) {
        // if they click outside we want to close
        if (targetElement !== this.tooltipButton.nativeElement) {
            this.closeTooltip();
        }
    }
    onFocusOut() {
        this.closeTimer = setTimeout(() => this.isOpen = false, 50);
    }
    onFocusIn() {
        clearTimeout(this.closeTimer);
    }
    onClick(event) {
        // This is here to prevent any possible parent labels from accidentally focusing on an input when opening a tooltip
        event.preventDefault();
        this.toggle();
    }
    toggle() {
        if (this.isOpen) {
            this.closeTooltip();
        }
        else {
            this.openTooltip();
        }
    }
    onEscape() {
        this.closeTooltip();
    }
    openTooltip() {
        // Close any open tooltips and set this as the new active one
        if (currentlyOpen) {
            currentlyOpen.closeTooltip();
        }
        this.checkDirection();
        this.isOpen = true;
        currentlyOpen = this;
    }
    closeTooltip() {
        this.isOpen = false;
        currentlyOpen = null;
    }
    resetDirection() {
        this.currentDirection = this.direction;
        this.tooltipBubble.nativeElement.style.marginLeft = null;
        this.moveCount = 0;
    }
    checkDirection() {
        // If we've already changed directions twice, then don't recheck it, so we don't get stuck in a loop
        if (this.moveCount < 3) {
            let direction = this.currentDirection.split('-');
            let hasMoved = false;
            let bubble = this.tooltipBubble.nativeElement;
            let box = bubble.getBoundingClientRect();
            // We don't want it to collide with the mobile header, to keep it 45px away from the top just in case
            if (box.top + window.scrollY < 45) {
                switch (this.moveCount) {
                    case 0:
                        direction[0] = 'bottom';
                        hasMoved = true;
                        break;
                }
            }
            if (box.bottom > window.innerHeight) {
                switch (this.moveCount) {
                    case 0:
                        direction[0] = 'top';
                        hasMoved = true;
                        break;
                }
            }
            // For horizontal misalignment, first we try to flip it to the other side
            // Then we center it if that didn't work
            // Then we offset the centered block if we need to (plus 10px leeway so it's not on the window edge)
            if (box.left < 0) {
                switch (this.moveCount) {
                    case 0:
                        direction[1] = 'right';
                        hasMoved = true;
                        break;
                    case 1:
                        direction.splice(1, 1);
                        hasMoved = true;
                        break;
                    case 2:
                        let offset = -box.left + 10;
                        bubble.style.marginLeft = Math.round(offset) + 'px';
                        hasMoved = true;
                        break;
                }
            }
            if (box.right > window.innerWidth) {
                switch (this.moveCount) {
                    case 0:
                        direction[1] = 'left';
                        hasMoved = true;
                        break;
                    case 1:
                        direction.splice(1, 1);
                        hasMoved = true;
                        break;
                    case 2:
                        let offset = window.innerWidth - box.right - 10;
                        bubble.style.marginLeft = Math.round(offset) + 'px';
                        hasMoved = true;
                        break;
                }
            }
            this.currentDirection = direction.join('-');
            if (hasMoved) {
                this.moveCount++;
            }
        }
    }
    static { this.ɵfac = function TooltipComponent_Factory(t) { return new (t || TooltipComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TooltipComponent, selectors: [["sumday-tooltip"]], viewQuery: function TooltipComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$a, 5);
            i0.ɵɵviewQuery(_c1$8, 5);
            i0.ɵɵviewQuery(_c2$1, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltipButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltipBubble = _t.first);
        } }, hostBindings: function TooltipComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("resize", function TooltipComponent_resize_HostBindingHandler($event) { return ctx.onWindowResize($event); }, false, i0.ɵɵresolveWindow)("click", function TooltipComponent_click_HostBindingHandler($event) { return ctx.onClickEvent($event, $event.target); }, false, i0.ɵɵresolveDocument)("focusout", function TooltipComponent_focusout_HostBindingHandler() { return ctx.onFocusOut(); })("focusin", function TooltipComponent_focusin_HostBindingHandler() { return ctx.onFocusIn(); });
        } }, inputs: { headline: "headline", copy: "copy", direction: "direction" }, ngContentSelectors: _c4, decls: 10, vars: 13, consts: [["type", "button", "aria-haspopup", "true", 1, "tooltip-icon", "no-default-styles", 3, "click", "keydown.Escape"], ["tooltipButton", ""], ["role", "tooltip", "aria-live", "polite", 3, "ngClass", "id"], ["tooltip", ""], [1, "tooltip-bubble"], ["tooltipBubble", ""], ["class", "headline", 4, "ngIf"], [1, "copy"], [1, "arrow"], [1, "headline"]], template: function TooltipComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "button", 0, 1);
            i0.ɵɵlistener("click", function TooltipComponent_Template_button_click_0_listener($event) { return ctx.onClick($event); })("keydown.Escape", function TooltipComponent_Template_button_keydown_Escape_0_listener() { return ctx.onEscape(); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 2, 3)(4, "div", 4, 5);
            i0.ɵɵtemplate(6, TooltipComponent_div_6_Template, 2, 1, "div", 6);
            i0.ɵɵelementStart(7, "div", 7);
            i0.ɵɵprojection(8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(9, "div", 8);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵattribute("aria-label", ctx.headline)("aria-describedby", ctx.idProperty)("aria-expanded", ctx.isOpen || null)("aria-controls", ctx.idProperty);
            i0.ɵɵadvance(2);
            i0.ɵɵclassMapInterpolate1("info-tooltip tooltip-", ctx.currentDirection, "");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c3, !ctx.isOpen))("id", ctx.idProperty);
            i0.ɵɵattribute("aria-hidden", !ctx.isOpen);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.headline);
        } }, dependencies: [i1$1.NgClass, i1$1.NgIf], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipComponent, [{
        type: Component,
        args: [{ selector: 'sumday-tooltip', template: "<button\n  #tooltipButton\n  type=\"button\"\n  class=\"tooltip-icon no-default-styles\"\n  aria-haspopup=\"true\"\n  [attr.aria-label]=\"headline\"\n  [attr.aria-describedby]=\"idProperty\"\n  [attr.aria-expanded]=\"isOpen || null\"\n  [attr.aria-controls]=\"idProperty\"\n  (click)=\"onClick($event)\"\n  (keydown.Escape)=\"onEscape()\"\n></button>\n\n<div\n  #tooltip\n  role=\"tooltip\"\n  aria-live=\"polite\"\n  class=\"info-tooltip tooltip-{{currentDirection}}\"\n  [ngClass]=\"{'hidden': !isOpen}\"\n  [attr.aria-hidden]=\"!isOpen\"\n  [id]=\"idProperty\"\n>\n  <div #tooltipBubble class=\"tooltip-bubble\">\n    <div *ngIf=\"headline\" class=\"headline\">{{headline}}</div>\n    <div class=\"copy\"><ng-content></ng-content></div>\n  </div>\n\n  <div class=\"arrow\"></div>\n</div>\n" }]
    }], function () { return []; }, { headline: [{
            type: Input
        }], copy: [{
            type: Input
        }], direction: [{
            type: Input
        }], tooltip: [{
            type: ViewChild,
            args: ['tooltip']
        }], tooltipButton: [{
            type: ViewChild,
            args: ['tooltipButton']
        }], tooltipBubble: [{
            type: ViewChild,
            args: ['tooltipBubble']
        }], onWindowResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], onClickEvent: [{
            type: HostListener,
            args: ['document:click', ['$event', '$event.target']]
        }], onFocusOut: [{
            type: HostListener,
            args: ['focusout']
        }], onFocusIn: [{
            type: HostListener,
            args: ['focusin']
        }] }); })();

const _c0$9 = ["input"];
function UploaderComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 13);
    i0.ɵɵelement(2, "circle", 14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-busy", ctx_r1.uploadProgress < 100)("aria-valuenow", ctx_r1.uploadProgress)("aria-valuemin", 0)("aria-valuemax", 100);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("r", ctx_r1.progressRadius)("stroke-dashoffset", ctx_r1.progressStrokeOffset)("stroke-dasharray", ctx_r1.progressStrokeLength);
} }
function UploaderComponent_ng_container_7_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("Select any ", ctx_r10.validTypes, "");
} }
function UploaderComponent_ng_container_7_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("You can upload up to ", ctx_r11.maxFiles, " files (", ctx_r11.validTypes, ")");
} }
function UploaderComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 15)(2, "span", 16);
    i0.ɵɵprojection(3, 1);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, UploaderComponent_ng_container_7_p_4_Template, 2, 1, "p", 7);
    i0.ɵɵtemplate(5, UploaderComponent_ng_container_7_p_5_Template, 2, 2, "p", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r2.labelId);
    i0.ɵɵattribute("for", ctx_r2.inputId);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-describedby", ctx_r2.errorMessageId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.maxFiles === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.maxFiles > 1);
} }
function UploaderComponent_ng_container_8_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "File selected");
    i0.ɵɵelementContainerEnd();
} }
function UploaderComponent_ng_container_8_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Uploading...");
    i0.ɵɵelementContainerEnd();
} }
function UploaderComponent_ng_container_8_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Success!");
    i0.ɵɵelementContainerEnd();
} }
function UploaderComponent_ng_container_8_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, UploaderComponent_ng_container_8_ng_container_3_ng_container_1_Template, 2, 0, "ng-container", 7);
    i0.ɵɵtemplate(2, UploaderComponent_ng_container_8_ng_container_3_ng_container_2_Template, 2, 0, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r13.done);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.done);
} }
function UploaderComponent_ng_container_8_li_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r17 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", file_r17.name, " ");
} }
function UploaderComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 17);
    i0.ɵɵtemplate(2, UploaderComponent_ng_container_8_ng_container_2_Template, 2, 0, "ng-container", 7);
    i0.ɵɵtemplate(3, UploaderComponent_ng_container_8_ng_container_3_Template, 3, 2, "ng-container", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ul", 18);
    i0.ɵɵtemplate(5, UploaderComponent_ng_container_8_li_5_Template, 2, 1, "li", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r3.uploadProgress);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.uploadProgress);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.files);
} }
function UploaderComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function UploaderComponent_button_9_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.reset()); });
    i0.ɵɵelementEnd();
} }
function UploaderComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function UploaderComponent_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.removeFiles()); });
    i0.ɵɵelementEnd();
} }
function UploaderComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" The size of the file you\u2019re trying to upload is over ", ctx_r6.maxSize, ". Try again with a smaller file. ");
} }
function UploaderComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("The maximum is ", ctx_r7.maxFiles, " files.");
} }
function UploaderComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Make sure the type of file is either ", ctx_r8.validTypes, " then try again. ");
} }
function UploaderComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1, "Looks like your document didn't upload. Try again");
    i0.ɵɵelementEnd();
} }
const _c1$7 = [[["", 8, "validation"]], "*"];
const _c2 = [".validation", "*"];
var UploadError;
(function (UploadError) {
    UploadError["Size"] = "size";
    UploadError["Type"] = "type";
    UploadError["Fail"] = "fail";
    UploadError["Count"] = "count";
})(UploadError || (UploadError = {}));
let id$3 = 0;
class UploaderComponent extends BaseControlValueAccessor {
    // These should really be of type 'DragEvent', but Safari is the new IE, so we can't use it -- @ytilis
    onDragOver(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!this.done || this.resettable) {
            this.dragging = true;
        }
    }
    onDragLeave(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!this.done || this.resettable) {
            this.dragging = false;
        }
    }
    onDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!this.done || this.resettable) {
            this.dragging = false;
            if (this.done) {
                this.reset();
            }
            this.processFiles(e.dataTransfer.files);
        }
    }
    constructor() {
        super();
        this.inputId = `file-${id$3++}-input`;
        this.resettable = false;
        this.disabled = false;
        this.maxSize = '20MB';
        this.maxFiles = 1;
        this.fileExtensions = ['PDF', 'PNG', 'JPG'];
        this.UploadError = UploadError;
        this.done = false;
        this.dragging = false;
        this.canceledUpload = false;
        this.labelId = `file-${id$3++}-input-label`;
        this.mimeTypes = [];
        this.progressRadius = 48;
        this.progressStrokeOffset = null;
        this.progressStrokeLength = 2 * Math.PI * this.progressRadius;
    }
    ngOnChanges(changes) {
        if (changes['uploadRequest'] && this.uploadRequest) {
            if (this.canceledUpload) {
                this.canceledUpload = false;
            }
            else {
                this.watchProgress();
            }
        }
        else {
            this.mimeTypes = this.fileExtensions.map((ext) => mimeTypes.getType(ext));
            this.accept = this.fileExtensions.map((ext) => `.${ext.toLowerCase()}`).join(',');
            // Build valid type message from valid extensions
            let extensions = [...this.fileExtensions];
            let lastExt = extensions.pop();
            this.validTypes = [extensions.join(`, `), lastExt].filter((i) => !!i).join(' or ');
        }
    }
    watchProgress() {
        this.uploadStatus = this.uploadRequest.subscribe((event) => {
            switch (event.type) {
                case HttpEventType.Sent:
                    break;
                case HttpEventType.UploadProgress:
                    if (this.files && this.files.length > 0) {
                        this.setProgress((100 * event.loaded) / event.total);
                    }
                    break;
                case HttpEventType.ResponseHeader:
                    if (event.status !== 200) {
                        // If the upload failed, reset the progress and mark it as failed
                        if (this.files && this.files.length > 0) {
                            this.error = UploadError.Fail;
                        }
                        this.setProgress(null);
                    }
                    break;
                case HttpEventType.Response:
                    break;
            }
        });
    }
    setProgress(percentage) {
        percentage = parseInt(percentage, 10);
        if (isNaN(percentage)) {
            this.uploadProgress = null;
            this.progressStrokeOffset = 0;
        }
        else {
            percentage = Math.min(100, percentage);
            percentage = Math.max(0, percentage);
            let c = Math.PI * this.progressRadius * 2;
            let strokeOffset = ((100 - percentage) / 100) * c;
            this.uploadProgress = percentage;
            this.progressStrokeOffset = strokeOffset;
        }
        this.done = this.uploadProgress === 100;
    }
    reset() {
        this.setProgress(null);
        this.removeFiles();
    }
    removeFiles() {
        this.error = null;
        this.files = null;
        this.input.nativeElement.value = null;
        this.onChange(null);
    }
    writeValue(files) {
        this.value = files;
        this.files = files;
        // We always want to reset the progress when the value changes
        this.setProgress(null);
        this.error = null;
    }
    processFiles(files) {
        this.error = null;
        if (this.maxFiles && files.length > this.maxFiles) {
            this.error = UploadError.Count;
        }
        for (let i = 0; i < files.length; i++) {
            if (files[i].size > new FileSizePipe().transform(this.maxSize)) {
                this.error = UploadError.Size;
            }
            if (this.mimeTypes.length === 0 || !this.mimeTypes.includes(files[i].type)) {
                this.error = UploadError.Type;
            }
        }
        if (!this.error) {
            this.files = files;
            this.onChange(files);
        }
    }
    static { this.ɵfac = function UploaderComponent_Factory(t) { return new (t || UploaderComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UploaderComponent, selectors: [["sumday-uploader"]], viewQuery: function UploaderComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$9, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
        } }, hostBindings: function UploaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("dragover", function UploaderComponent_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); }, false, i0.ɵɵresolveWindow)("dragleave", function UploaderComponent_dragleave_HostBindingHandler($event) { return ctx.onDragLeave($event); }, false, i0.ɵɵresolveWindow)("drop", function UploaderComponent_drop_HostBindingHandler($event) { return ctx.onDrop($event); });
        } }, inputs: { inputId: "inputId", resettable: "resettable", disabled: "disabled", maxSize: "maxSize", maxFiles: "maxFiles", fileExtensions: "fileExtensions", uploadStatus: "uploadStatus", uploadRequest: "uploadRequest" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => UploaderComponent),
                    multi: true,
                },
            ]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c2, decls: 18, vars: 27, consts: [[1, "uploader"], ["type", "file", 3, "change"], ["input", ""], [1, "indicator"], ["class", "progress-circle", "role", "progressbar", 4, "ngIf"], [1, "icon"], [1, "text"], [4, "ngIf"], ["type", "button", "class", "icon-dividend btn-icon btn-dark btn-transparent", "aria-label", "reset", 3, "click", 4, "ngIf"], ["type", "button", "class", "icon-close btn-icon btn-dark btn-transparent", "aria-label", "Remove files", 3, "click", 4, "ngIf"], [3, "ngSwitch"], ["class", "validation", 4, "ngSwitchCase"], ["role", "progressbar", 1, "progress-circle"], ["width", "100%", "height", "100%", "viewPort", "0 0 100 100", "viewBox", "0 0 100 100", "preserveAspectRatio", "xMidYMid meet", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", "focusable", "false"], ["cx", "50%", "cy", "50%", "fill", "transparent", 1, "bar"], [3, "id"], ["role", "button", "aria-controls", "filename", "tabindex", "0"], ["role", "status", "aria-live", "polite", "aria-atomic", "true", 1, "label"], [1, "files"], [4, "ngFor", "ngForOf"], ["type", "button", "aria-label", "reset", 1, "icon-dividend", "btn-icon", "btn-dark", "btn-transparent", 3, "click"], ["type", "button", "aria-label", "Remove files", 1, "icon-close", "btn-icon", "btn-dark", "btn-transparent", 3, "click"], [1, "validation"]], template: function UploaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c1$7);
            i0.ɵɵelementStart(0, "div", 0)(1, "input", 1, 2);
            i0.ɵɵlistener("change", function UploaderComponent_Template_input_change_1_listener($event) { return ctx.processFiles($event.target.files); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "label", 3);
            i0.ɵɵtemplate(4, UploaderComponent_span_4_Template, 3, 7, "span", 4);
            i0.ɵɵelement(5, "span", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 6);
            i0.ɵɵtemplate(7, UploaderComponent_ng_container_7_Template, 6, 5, "ng-container", 7);
            i0.ɵɵtemplate(8, UploaderComponent_ng_container_8_Template, 6, 3, "ng-container", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, UploaderComponent_button_9_Template, 1, 0, "button", 8);
            i0.ɵɵtemplate(10, UploaderComponent_button_10_Template, 1, 0, "button", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "div");
            i0.ɵɵprojection(12);
            i0.ɵɵelementContainerStart(13, 10);
            i0.ɵɵtemplate(14, UploaderComponent_div_14_Template, 2, 1, "div", 11);
            i0.ɵɵtemplate(15, UploaderComponent_div_15_Template, 2, 1, "div", 11);
            i0.ɵɵtemplate(16, UploaderComponent_div_16_Template, 2, 1, "div", 11);
            i0.ɵɵtemplate(17, UploaderComponent_div_17_Template, 2, 0, "div", 11);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵclassProp("done", ctx.done)("dragging", ctx.dragging)("selected", (ctx.files == null ? null : ctx.files.length) > 0 && !ctx.uploadProgress)("uploading", ctx.uploadProgress);
            i0.ɵɵadvance(1);
            i0.ɵɵattributeInterpolate2("aria-labelledby", "", ctx.labelId, " ", ctx.errorMessageId, "");
            i0.ɵɵattribute("id", ctx.inputId)("accept", ctx.mimeTypes.join(","))("multiple", ctx.maxFiles > 1 ? true : null)("aria-disabled", ctx.disabled)("aria-describedby", ctx.describedByAttr);
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("for", (ctx.files == null ? null : ctx.files.length) > 0 ? null : ctx.inputId);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.uploadProgress);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.files || (ctx.files == null ? null : ctx.files.length) === 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.files == null ? null : ctx.files.length) > 0 || ctx.uploadProgress && ctx.uploadProgress < 100);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.resettable && ctx.done);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.files == null ? null : ctx.files.length) > 0 && !ctx.uploadProgress);
            i0.ɵɵadvance(1);
            i0.ɵɵattribute("id", ctx.errorMessageId);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngSwitch", ctx.error);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", ctx.UploadError.Size);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", ctx.UploadError.Count);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", ctx.UploadError.Type);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", ctx.UploadError.Fail);
        } }, dependencies: [i1$1.NgForOf, i1$1.NgIf, i1$1.NgSwitch, i1$1.NgSwitchCase, i1.RoleButtonDirective], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UploaderComponent, [{
        type: Component,
        args: [{ selector: 'sumday-uploader', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => UploaderComponent),
                        multi: true,
                    },
                ], template: "<div\n  class=\"uploader\"\n  [class.done]=\"done\"\n  [class.dragging]=\"dragging\"\n  [class.selected]=\"files?.length > 0 && !uploadProgress\"\n  [class.uploading]=\"uploadProgress\"\n>\n  <input\n    #input\n    type=\"file\"\n    [attr.id]=\"inputId\"\n    [attr.accept]=\"mimeTypes.join(',')\"\n    [attr.multiple]=\"maxFiles > 1 ? true : null\"\n    [attr.aria-disabled]=\"disabled\"\n    [attr.aria-describedby]=\"describedByAttr\"\n    attr.aria-labelledby=\"{{ labelId }} {{ errorMessageId }}\"\n    (change)=\"processFiles($event.target.files)\"\n  />\n\n  <label class=\"indicator\" [attr.for]=\"files?.length > 0 ? null : inputId\">\n    <span\n      *ngIf=\"uploadProgress\"\n      class=\"progress-circle\"\n      role=\"progressbar\"\n      [attr.aria-busy]=\"uploadProgress < 100\"\n      [attr.aria-valuenow]=\"uploadProgress\"\n      [attr.aria-valuemin]=\"0\"\n      [attr.aria-valuemax]=\"100\"\n    >\n      <svg\n        width=\"100%\"\n        height=\"100%\"\n        viewPort=\"0 0 100 100\"\n        viewBox=\"0 0 100 100\"\n        preserveAspectRatio=\"xMidYMid meet\"\n        version=\"1.1\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        focusable=\"false\"\n      >\n        <circle\n          class=\"bar\"\n          cx=\"50%\"\n          cy=\"50%\"\n          fill=\"transparent\"\n          [attr.r]=\"progressRadius\"\n          [attr.stroke-dashoffset]=\"progressStrokeOffset\"\n          [attr.stroke-dasharray]=\"progressStrokeLength\"\n        ></circle>\n      </svg>\n    </span>\n    <span class=\"icon\"></span>\n  </label>\n\n  <div class=\"text\">\n    <ng-container *ngIf=\"!files || files?.length === 0\">\n      <label [id]=\"labelId\" [attr.for]=\"inputId\">\n        <span role=\"button\" aria-controls=\"filename\" tabindex=\"0\" [attr.aria-describedby]=\"errorMessageId\">\n          <ng-content></ng-content>\n        </span>\n      </label>\n\n      <p *ngIf=\"maxFiles === 1\">Select any {{ validTypes }}</p>\n      <p *ngIf=\"maxFiles > 1\">You can upload up to {{ maxFiles }} files ({{ validTypes }})</p>\n    </ng-container>\n\n    <ng-container *ngIf=\"files?.length > 0 || (uploadProgress && uploadProgress < 100)\">\n      <span class=\"label\" role=\"status\" aria-live=\"polite\" aria-atomic=\"true\">\n        <ng-container *ngIf=\"!uploadProgress\">File selected</ng-container>\n        <ng-container *ngIf=\"uploadProgress\">\n          <ng-container *ngIf=\"!done\">Uploading...</ng-container>\n          <ng-container *ngIf=\"done\">Success!</ng-container>\n        </ng-container>\n      </span>\n      <ul class=\"files\">\n        <li *ngFor=\"let file of files\">\n          {{ file.name }}\n        </li>\n      </ul>\n    </ng-container>\n  </div>\n\n  <button\n    type=\"button\"\n    *ngIf=\"resettable && done\"\n    class=\"icon-dividend btn-icon btn-dark btn-transparent\"\n    (click)=\"reset()\"\n    aria-label=\"reset\"\n  ></button>\n\n  <button\n    type=\"button\"\n    *ngIf=\"files?.length > 0 && !uploadProgress\"\n    class=\"icon-close btn-icon btn-dark btn-transparent\"\n    (click)=\"removeFiles()\"\n    aria-label=\"Remove files\"\n  ></button>\n</div>\n\n<div [attr.id]=\"errorMessageId\">\n  <ng-content select=\".validation\"></ng-content>\n\n  <ng-container [ngSwitch]=\"error\">\n    <div *ngSwitchCase=\"UploadError.Size\" class=\"validation\">\n      The size of the file you\u2019re trying to upload is over {{ maxSize }}. Try again with a smaller file.\n    </div>\n\n    <div *ngSwitchCase=\"UploadError.Count\" class=\"validation\">The maximum is {{ maxFiles }} files.</div>\n\n    <div *ngSwitchCase=\"UploadError.Type\" class=\"validation\">\n      Make sure the type of file is either {{ validTypes }} then try again.\n    </div>\n\n    <div *ngSwitchCase=\"UploadError.Fail\" class=\"validation\">Looks like your document didn't upload. Try again</div>\n  </ng-container>\n</div>\n" }]
    }], function () { return []; }, { input: [{
            type: ViewChild,
            args: ['input']
        }], inputId: [{
            type: Input
        }], resettable: [{
            type: Input
        }], disabled: [{
            type: Input
        }], maxSize: [{
            type: Input
        }], maxFiles: [{
            type: Input
        }], fileExtensions: [{
            type: Input
        }], uploadStatus: [{
            type: Input
        }], uploadRequest: [{
            type: Input
        }], onDragOver: [{
            type: HostListener,
            args: ['window:dragover', ['$event']]
        }], onDragLeave: [{
            type: HostListener,
            args: ['window:dragleave', ['$event']]
        }], onDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }] }); })();

function TakeOverModalComponent_div_0_p_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 11);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r1.takeoverOptions == null ? null : ctx_r1.takeoverOptions.subtitle, i0.ɵɵsanitizeHtml);
} }
function TakeOverModalComponent_div_0_p_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 12);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r2.takeoverOptions == null ? null : ctx_r2.takeoverOptions.message, i0.ɵɵsanitizeHtml);
} }
function TakeOverModalComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("click", function TakeOverModalComponent_div_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.closeModal()); });
    i0.ɵɵelementStart(1, "div", 2)(2, "div", 3);
    i0.ɵɵelement(3, "div", 4);
    i0.ɵɵelementStart(4, "div", 5)(5, "h1", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 7);
    i0.ɵɵtemplate(8, TakeOverModalComponent_div_0_p_8_Template, 1, 1, "p", 8);
    i0.ɵɵtemplate(9, TakeOverModalComponent_div_0_p_9_Template, 1, 1, "p", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 10);
    i0.ɵɵlistener("click", function TakeOverModalComponent_div_0_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.closeModal()); });
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("takeover-modal ", ctx_r0.takeoverOptions == null ? null : ctx_r0.takeoverOptions.type, "");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.takeoverOptions == null ? null : ctx_r0.takeoverOptions.title);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.takeoverOptions == null ? null : ctx_r0.takeoverOptions.subtitle);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.takeoverOptions == null ? null : ctx_r0.takeoverOptions.message);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.takeoverOptions == null ? null : ctx_r0.takeoverOptions.link);
} }
class TakeOverModalComponent {
    constructor(_dialogService, router, _windowRef, element, platformId) {
        this._dialogService = _dialogService;
        this.router = router;
        this._windowRef = _windowRef;
        this.element = element;
        this.platformId = platformId;
        this.showTakeoverModal = false;
    }
    ngOnInit() {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(data => {
            if (this.showTakeoverModal) {
                this.showTakeoverModal = false;
            }
        });
        this._dialogService.confirmation.subscribe((takeoverOptions) => {
            this.takeoverOptions = takeoverOptions;
            this.showTakeoverModal = true;
            this.pageWrapperElement = this._windowRef.nativeWindow.document.querySelector('.page-wrapper');
            if (this.pageWrapperElement) {
                this.pageWrapperElement.setAttribute('hidden', 'true');
                this.pageWrapperElement.setAttribute('aria-hidden', 'true');
            }
            setTimeout(() => {
                let button = this.element.nativeElement.querySelector('button');
                if (button) {
                    this.previouslyFocusedElement = document.activeElement;
                    button.focus();
                }
            }, 500);
        });
        this._dialogService.closed.subscribe(navigate => {
            if (this.pageWrapperElement) {
                this.pageWrapperElement.removeAttribute('hidden');
                this.pageWrapperElement.removeAttribute('aria-hidden');
            }
            this.showTakeoverModal = navigate;
            if (!navigate) {
                if (this.previouslyFocusedElement) {
                    this.previouslyFocusedElement.focus();
                }
            }
        });
    }
    closeModal() {
        this._dialogService.close();
    }
    static { this.ɵfac = function TakeOverModalComponent_Factory(t) { return new (t || TakeOverModalComponent)(i0.ɵɵdirectiveInject(i1.DialogService), i0.ɵɵdirectiveInject(i1$2.Router), i0.ɵɵdirectiveInject(i1.WindowRefService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PLATFORM_ID)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TakeOverModalComponent, selectors: [["sumday-takeover-modal"]], decls: 1, vars: 1, consts: [[3, "class", "click", 4, "ngIf"], [3, "click"], [1, "page-container"], [1, "message"], [1, "icon"], ["role", "alertdialog", "aria-labelledby", "takeoverTitle", "aria-describedby", "takeoverDescription", 1, "messaging"], ["id", "takeoverTitle"], ["id", "takeoverDescription"], ["class", "h2 text-normal", 3, "innerHtml", 4, "ngIf"], ["class", "lead", 3, "innerHtml", 4, "ngIf"], ["type", "button", 1, "btn-forward", "dismiss", 3, "click"], [1, "h2", "text-normal", 3, "innerHtml"], [1, "lead", 3, "innerHtml"]], template: function TakeOverModalComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, TakeOverModalComponent_div_0_Template, 12, 7, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.showTakeoverModal);
        } }, dependencies: [i1$1.NgIf, i1.H1Directive], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TakeOverModalComponent, [{
        type: Component,
        args: [{ selector: 'sumday-takeover-modal', template: "<div class=\"takeover-modal {{takeoverOptions?.type}}\" *ngIf=\"showTakeoverModal\" (click)=\"closeModal()\">\n  <div class=\"page-container\">\n    <div class=\"message\">\n      <div class=\"icon\"></div>\n      <div class=\"messaging\" role=\"alertdialog\" aria-labelledby=\"takeoverTitle\" aria-describedby=\"takeoverDescription\">\n        <h1\n          id=\"takeoverTitle\"\n        >{{takeoverOptions?.title}}</h1>\n        <div id=\"takeoverDescription\">\n          <p\n            class=\"h2 text-normal\"\n            *ngIf=\"takeoverOptions?.subtitle\"\n            [innerHtml]=\"takeoverOptions?.subtitle\"\n          ></p>\n          <p\n            class=\"lead\"\n            *ngIf=\"takeoverOptions?.message\"\n            [innerHtml]=\"takeoverOptions?.message\"\n          ></p>\n        </div>\n        <button\n          type=\"button\"\n          class=\"btn-forward dismiss\"\n          (click)=\"closeModal()\"\n        >{{takeoverOptions?.link}}</button>\n      </div>\n    </div>\n  </div>\n</div>\n" }]
    }], function () { return [{ type: i1.DialogService }, { type: i1$2.Router }, { type: i1.WindowRefService }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();

function LoaderComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.loadingMessage);
} }
function LoaderComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("@fadeInOut", undefined);
} }
function LoaderComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@fadeInOut", undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", ctx_r2.size, "px");
    i0.ɵɵclassProp("center", ctx_r2.center);
} }
function LoaderComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("@fadeInOut", undefined);
} }
function LoaderComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 6);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 7)(3, "defs")(4, "pattern", 8)(5, "g", 9)(6, "g");
    i0.ɵɵelement(7, "path", 10)(8, "animateTransform", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "g");
    i0.ɵɵelement(10, "path", 12)(11, "animateTransform", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "g");
    i0.ɵɵelement(13, "path", 14)(14, "animateTransform", 15);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelement(15, "rect", 16);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@fadeInOut", undefined);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("id", ctx_r4.id);
    i0.ɵɵadvance(11);
    i0.ɵɵattribute("fill", ctx_r4.fill);
} }
const _c0$8 = ["*"];
let id$2 = 0;
class LoaderComponent {
    set condition(condition) {
        if (condition) {
            this.savedType = this.type;
            this.type = LoaderType.Content;
            this.resetFocus();
        }
        else {
            this.handleFocus();
            if (this.type === LoaderType.Content) {
                this.type = this.savedType;
            }
        }
    }
    constructor(element, cd, document) {
        this.element = element;
        this.cd = cd;
        this.document = document;
        this.LoaderType = LoaderType;
        this.savedType = null;
        this.previouslyFocusedItem = null;
        this.timer = null;
        this.id = `loader-${id$2++}`;
        this.type = LoaderType.Spin;
        this.center = false;
        this.size = 100;
        this.loadingMessage = 'loading content';
    }
    resetFocus() {
        this.cd.detectChanges(); // need to force a digest so the button shows up before we try this
        if (this.element.nativeElement.contains(this.previouslyFocusedItem)) {
            this.setFocus(this.previouslyFocusedItem);
            this.previouslyFocusedItem = null;
        }
    }
    /*
    if the loader contains an element that triggers the loader we have to set the focus on the loader container element.
    If we don't the browser could lose focus and reset itself to the body tag.
    This will store the currently focused item and will try and return the focus when the loading completes
    */
    handleFocus() {
        const focusedItem = this.document.activeElement;
        if (this.element.nativeElement.contains(focusedItem) && focusedItem !== this.previouslyFocusedItem) {
            this.previouslyFocusedItem = focusedItem;
            this.element.nativeElement.tabIndex = -1;
            this.setFocus(this.element.nativeElement);
        }
    }
    setFocus(element) {
        // clear the timer incase the loading finishes before we have time to set the new focus
        clearTimeout(this.timer);
        if (!element) {
            return;
        }
        // the timeout is because certain screen readers need it
        this.timer = setTimeout(() => {
            element.focus();
        }, 400);
    }
    ngOnInit() {
        this.fill = `url(#${this.id})`;
    }
    ngOnDestroy() {
        clearTimeout(this.timer);
    }
    static { this.ɵfac = function LoaderComponent_Factory(t) { return new (t || LoaderComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(DOCUMENT)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoaderComponent, selectors: [["sumday-loader"]], inputs: { id: "id", type: "type", center: "center", size: "size", loadingMessage: "loadingMessage", condition: "condition" }, ngContentSelectors: _c0$8, decls: 6, vars: 6, consts: [["class", "screen-reader-only", 4, "ngIf"], [3, "ngSwitch"], [4, "ngSwitchCase"], [1, "screen-reader-only"], [1, "spin"], [1, "dots"], [1, "wave"], ["version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "focusable", "false"], ["width", "500", "height", "150", "x", "0", "y", "0", "viewBox", "0 0 500 150", "preserveAspectRatio", "xMidYMid slice", "patternUnits", "userSpaceOnUse", 3, "id"], ["stroke", "#000", "stroke-width", "2", "fill", "none", "fill-rule", "evenodd", "transform", "translate(0, -175)"], ["d", "M 0 250 Q 150 125 300 250 Q 400 325 500 250 Q 650 125 800 250 Q 900 325 1000 250", 1, "wave1"], ["attributeName", "transform", "type", "translate", "keyTimes", "0;1", "repeatCount", "indefinite", "dur", "5.5s", "values", "-500;0"], ["d", "M 0 250 Q 150 175 300 250 Q 400 300 500 250 Q 650 175 800 250 Q 900 300 1000 250", 1, "wave2"], ["attributeName", "transform", "type", "translate", "keyTimes", "0;1", "repeatCount", "indefinite", "dur", "4s", "values", "-500;0"], ["d", "M 0 250 Q 100 200 200 250 Q 350 325 500 250 Q 600 200 700 250 Q 850 325 1000 250", 1, "wave3"], ["attributeName", "transform", "type", "translate", "keyTimes", "0;1", "repeatCount", "indefinite", "dur", "3s", "values", "-500;0"], ["x", "0", "y", "0", 1, "rect"]], template: function LoaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, LoaderComponent_span_0_Template, 2, 1, "span", 0);
            i0.ɵɵelementContainerStart(1, 1);
            i0.ɵɵtemplate(2, LoaderComponent_div_2_Template, 2, 1, "div", 2);
            i0.ɵɵtemplate(3, LoaderComponent_div_3_Template, 2, 5, "div", 2);
            i0.ɵɵtemplate(4, LoaderComponent_div_4_Template, 2, 1, "div", 2);
            i0.ɵɵtemplate(5, LoaderComponent_div_5_Template, 16, 3, "div", 2);
            i0.ɵɵelementContainerEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.type !== ctx.LoaderType.Content);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitch", ctx.type);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", ctx.LoaderType.Content);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", ctx.LoaderType.Spin);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", ctx.LoaderType.Dots);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", ctx.LoaderType.Wave);
        } }, dependencies: [i1$1.NgIf, i1$1.NgSwitch, i1$1.NgSwitchCase], encapsulation: 2, data: { animation: [
                trigger('fadeInOut', [
                    transition(':enter', [
                        style({
                            opacity: 0,
                        }),
                        animate('.5s ease-in-out', style({
                            opacity: 1,
                        }))
                    ]),
                    transition(':leave', [
                        style({
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                        }),
                        animate('.5s ease-in-out', style({
                            opacity: 0,
                        }))
                    ])
                ]),
            ] } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoaderComponent, [{
        type: Component,
        args: [{ selector: 'sumday-loader', animations: [
                    trigger('fadeInOut', [
                        transition(':enter', [
                            style({
                                opacity: 0,
                            }),
                            animate('.5s ease-in-out', style({
                                opacity: 1,
                            }))
                        ]),
                        transition(':leave', [
                            style({
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                            }),
                            animate('.5s ease-in-out', style({
                                opacity: 0,
                            }))
                        ])
                    ]),
                ], template: "<span *ngIf=\"type !== LoaderType.Content\" class=\"screen-reader-only\">{{ loadingMessage }}</span>\n<ng-container [ngSwitch]=\"type\">\n  <div *ngSwitchCase=\"LoaderType.Content\" [@fadeInOut]>\n    <ng-content></ng-content>\n  </div>\n  <div *ngSwitchCase=\"LoaderType.Spin\" [@fadeInOut]><div class=\"spin\" [class.center]=\"center\" [style.width.px]=\"size\"></div></div>\n  <div *ngSwitchCase=\"LoaderType.Dots\" [@fadeInOut]><div class=\"dots\"></div></div>\n  <div *ngSwitchCase=\"LoaderType.Wave\" [@fadeInOut]><div class=\"wave\">\n    <svg\n      version=\"1.1\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n      focusable=\"false\"\n    >\n      <defs>\n        <pattern\n          [id]=\"id\"\n          width=\"500\"\n          height=\"150\"\n          x=\"0\" y=\"0\"\n          viewBox=\"0 0 500 150\"\n          preserveAspectRatio=\"xMidYMid slice\"\n          patternUnits=\"userSpaceOnUse\"\n        >\n          <g\n            stroke=\"#000\"\n            stroke-width=\"2\"\n            fill=\"none\"\n            fill-rule=\"evenodd\"\n            transform=\"translate(0, -175)\"\n          >\n            <g>\n              <path class=\"wave1\" d=\"M 0 250 Q 150 125 300 250 Q 400 325 500 250 Q 650 125 800 250 Q 900 325 1000 250\"></path>\n              <animateTransform attributeName=\"transform\" type=\"translate\" keyTimes=\"0;1\" repeatCount=\"indefinite\" dur=\"5.5s\" values=\"-500;0\"></animateTransform>\n            </g>\n            <g>\n              <path class=\"wave2\" d=\"M 0 250 Q 150 175 300 250 Q 400 300 500 250 Q 650 175 800 250 Q 900 300 1000 250\"></path>\n              <animateTransform attributeName=\"transform\" type=\"translate\" keyTimes=\"0;1\" repeatCount=\"indefinite\" dur=\"4s\" values=\"-500;0\"></animateTransform>\n            </g>\n            <g>\n              <path class=\"wave3\" d=\"M 0 250 Q 100 200 200 250 Q 350 325 500 250 Q 600 200 700 250 Q 850 325 1000 250\"></path>\n              <animateTransform attributeName=\"transform\" type=\"translate\" keyTimes=\"0;1\" repeatCount=\"indefinite\" dur=\"3s\" values=\"-500;0\"></animateTransform>\n            </g>\n          </g>\n        </pattern>\n      </defs>\n      <rect class=\"rect\" x=\"0\" y=\"0\" [attr.fill]=\"fill\"></rect>\n    </svg>\n  </div></div>\n</ng-container>\n" }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { id: [{
            type: Input
        }], type: [{
            type: Input
        }], center: [{
            type: Input
        }], size: [{
            type: Input
        }], loadingMessage: [{
            type: Input
        }], condition: [{
            type: Input
        }] }); })();

/* eslint-disable @typescript-eslint/no-unused-expressions */
class PreviewCheckComponent {
    set amount(amt) {
        if (typeof (amt) === 'number') {
            amt = amt.toString();
        }
        if (typeof (amt) === 'string') {
            if (amt === '') {
                amt = '0';
            }
            this._amount = amt;
        }
        else {
            console.warn(`Check amount must be a string or number`);
        }
    }
    get amount() {
        return this._amount;
    }
    constructor(canvasService, currencyPipe) {
        this.canvasService = canvasService;
        this.currencyPipe = currencyPipe;
        this.changes = new Subject();
        this._amount = '0';
        this.name = '';
        this.logo = '';
        this.memo = '';
        this.beneficiary = '';
        this.checkNo = '0000000000';
        this.accountNo = '0000000000';
        this.bankAccountNo = '00000000';
        this.bankRoutingNo = '011001234';
        this.showEnvelope = false;
        // Initial blank check placeholder
        this.canvas = this.canvasService.createCanvas(800, 350);
        this.imageData = this.canvasService.canvasEle.toDataURL();
        this.changes.pipe(
        // Prevent a redraw during the initial flood of input changes
        debounceTime(100)).subscribe(changes => {
            this.canvas = this.canvasService.createCanvas(800, 350);
            this.showEnvelope ? this.drawEnvelope() : this.drawCheck();
        });
    }
    ngOnInit() {
        this.changes.next({});
    }
    ngOnChanges(changes) {
        this.changes.next(changes);
    }
    async drawCheck() {
        let date = dayjs(new Date().getFullYear()).format('MM/DD/YYYY');
        // Reset drawing
        this.blankCanvas();
        // Logo
        await this.addLogo(20, 20);
        // Numeric Amount
        this.canvas.strokeStyle = '#D8D8d8';
        this.canvas.strokeRect(600, 84, 180, 35);
        this.canvas.strokeRect(600, 119, 180, 35);
        this.canvas.strokeStyle = '#000000';
        this.canvasService.font(600);
        this.canvas.textAlign = CanvasTextAlign.End;
        this.canvas.fillText(this.currencyPipe.transform(this.amount), 760, 140);
        this.canvas.textAlign = CanvasTextAlign.Start;
        // Labels
        this.canvasService.font(600);
        this.canvas.fillText(`Pay to the order of:`, 20, 90);
        this.canvas.fillText(`Amount:`, 20, 230);
        this.canvas.fillText(`The Bank of New York Mellon`, 20, 260);
        this.canvas.fillText(`Memo:`, 20, 285);
        this.canvas.fillText(`Amount`, 665, 105);
        // Values
        this.canvasService.font(400);
        this.canvas.fillText(`${this.memo || ''}`, 65, 285);
        this.canvas.fillText(`${NumberUtils.numberToText(this.amount)}`, 75, 230);
        this.addAddress(20, 115);
        // Top Right numbers
        this.canvasService.textRow([`Date:`, date], 600, 45, 5, '12px');
        this.canvasService.textRow([`Account #:`, this.accountNo], 600, 65, 5, '12px');
        this.canvas.textAlign = CanvasTextAlign.End;
        this.canvasService.textColumn([
            `${this.checkNo}`,
            `5-123/110`,
        ], 760, 25);
        this.canvas.textAlign = CanvasTextAlign.Start;
        // Signature
        this.canvas.fillRect(530, 300, 240, 1);
        this.canvas.fillText(`AUTHORIZED SIGNATURE`, 590, 320);
        // Routing Numbers
        this.canvasService.font(400, '22px', 'MICR');
        this.canvasService.textRow([
            // C & A are used for the MICR marks to denote the number blocks on the bottom of the checks
            `C${this.checkNo}C`,
            `A${this.bankRoutingNo}A`,
            `C${this.bankAccountNo}C`,
        ], 40, 330, 20);
        // Void
        this.canvas.rotate(-Math.PI / 10);
        this.canvas.globalAlpha = 0.3;
        this.canvasService.font(600, '250px');
        this.canvas.strokeText(`VOID`, 75, 375);
        this.imageData = this.canvasService.canvasEle.toDataURL();
    }
    async drawEnvelope() {
        // Reset drawing
        this.blankCanvas();
        // Logo
        await this.addLogo(40, 20);
        // Return Address
        this.canvasService.font(400, '14px');
        this.canvasService.textColumn([
            `P.O. Box 9891`,
            `Providence, RI 02490-9651`,
        ], 40, 80);
        // Postage
        this.canvasService.font(600, '12px');
        this.canvas.textAlign = CanvasTextAlign.Center;
        this.canvasService.textColumn([
            `PRESORTED`,
            `First-Class Mail`,
            `U.S. Postage Paid`,
        ], 700, 60, 15);
        this.canvas.strokeStyle = '#403947';
        this.canvas.strokeRect(650, 20, 100, 100);
        this.canvas.textAlign = CanvasTextAlign.Start;
        // Address
        this.canvasService.font(400, '16px');
        this.addAddress(40, 190);
        this.imageData = this.canvasService.canvasEle.toDataURL();
    }
    blankCanvas() {
        // Background
        this.canvas.fillStyle = '#FFFFFF';
        this.canvas.fillRect(0, 0, this.canvasService.width, this.canvasService.height);
        // Border
        this.canvas.fillStyle = '#403947';
        this.canvas.strokeRect(0, 0, this.canvasService.width, this.canvasService.height);
    }
    addAddress(x = 0, y = 0) {
        this.canvasService.textColumn([
            ...(Array.isArray(this.name)) ? this.name : [this.name],
            this.beneficiary ? `FBO ${this.beneficiary}` : null,
            this.address && this.address.line1,
            this.address && this.address.line2,
            this.address && this.lastAddressLine(),
        ].filter(l => l), x, y, 20);
    }
    lastAddressLine() {
        let address = [];
        if (this.address.city) {
            address.push(this.address.city);
        }
        if (this.address.stateCode) {
            if (this.address.city) {
                address.push(`, `);
            }
            address.push(this.address.stateCode);
        }
        if (this.address.postalCode) {
            address.push(this.address.postalCode);
        }
        return address.join(' ');
    }
    async addLogo(x, y, h = 40) {
        // This allows us to insert the image in greyscale
        this.canvas.globalCompositeOperation = CanvasGlobalComposition.Luminosity;
        let logoImg = await this.canvasService.addImage(this.logo);
        this.canvas.drawImage(logoImg, x, y, CanvasService.scaleImageWidth(logoImg, h), h);
        // Restores default behavior
        this.canvas.globalCompositeOperation = CanvasGlobalComposition.SourceOver;
    }
    static { this.ɵfac = function PreviewCheckComponent_Factory(t) { return new (t || PreviewCheckComponent)(i0.ɵɵdirectiveInject(i1.CanvasService), i0.ɵɵdirectiveInject(i1$1.CurrencyPipe)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PreviewCheckComponent, selectors: [["sumday-preview-check"]], inputs: { address: "address", name: "name", logo: "logo", memo: "memo", beneficiary: "beneficiary", checkNo: "checkNo", accountNo: "accountNo", bankAccountNo: "bankAccountNo", bankRoutingNo: "bankRoutingNo", showEnvelope: "showEnvelope", amount: "amount" }, features: [i0.ɵɵProvidersFeature([CanvasService]), i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["alt", "Preview of what your check will look like", 3, "src"]], template: function PreviewCheckComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "img", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("src", ctx.imageData, i0.ɵɵsanitizeUrl);
        } }, dependencies: [i1.CdnSrcDirective], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PreviewCheckComponent, [{
        type: Component,
        args: [{ selector: 'sumday-preview-check', providers: [CanvasService], template: "<img [src]=\"imageData\" alt=\"Preview of what your check will look like\" />\n" }]
    }], function () { return [{ type: i1.CanvasService }, { type: i1$1.CurrencyPipe }]; }, { address: [{
            type: Input
        }], name: [{
            type: Input
        }], logo: [{
            type: Input
        }], memo: [{
            type: Input
        }], beneficiary: [{
            type: Input
        }], checkNo: [{
            type: Input
        }], accountNo: [{
            type: Input
        }], bankAccountNo: [{
            type: Input
        }], bankRoutingNo: [{
            type: Input
        }], showEnvelope: [{
            type: Input
        }], amount: [{
            type: Input
        }] }); })();

dayjs__default.extend(utc);
const responsiveWidth = 599;
function defaultOptions(config) {
    return {
        chart: {
            animation: !config.disableAnimation,
        },
        legend: {
            enabled: !config.hideLegend,
            accessibility: {
                enabled: true
            }
        },
        tooltip: {
            enabled: !config.isStatic,
            followPointer: false,
            followTouchMove: false
        },
        plotOptions: {
            pie: {
                borderColor: null
            },
            bar: {
                dataLabels: {
                    enabled: false
                }
            },
            spline: {
                marker: {
                    enabled: true
                }
            },
            area: {
                marker: {
                    symbol: 'circle',
                    radius: 0,
                    states: {
                        hover: {
                            radius: 5
                        }
                    }
                },
                events: {
                    legendItemClick: (e) => e.preventDefault()
                }
            },
            series: {
                enableMouseTracking: !config.isStatic,
                states: {
                    hover: {
                        enabled: !config.isStatic
                    }
                },
                animation: !config.disableAnimation,
            }
        },
        responsive: {},
        xAxis: {
            labels: {
                enabled: !config.disableXLabels
            }
        },
        yAxis: {
            labels: {
                enabled: !config.disableYLabels
            }
        },
        accessibility: {
            enabled: true,
            description: config.screenReaderText
        },
        exporting: {
            enabled: config.enableExport,
            buttons: {
                contextButton: config.enableExport ? {
                    menuItems: getOptions()?.exporting?.buttons?.contextButton?.menuItems.slice(0, 2)
                } : {}
            },
        },
        title: {
            text: config.title ? config.title : ''
        },
        subtitle: {
            text: config.subtitle ? config.subtitle : ''
        },
        time: {
            useUTC: false
        },
        credits: {
            enabled: false
        },
    };
}
function pieOptions(config) {
    return merge$1(defaultOptions(config), {
        chart: {
            type: ChartType.Pie,
            height: '100%',
        },
        legend: {
            align: 'right',
            verticalAlign: 'middle',
            layout: 'vertical',
            itemMarginBottom: 15,
            navigation: {
                animation: false
            },
        },
        plotOptions: {
            series: {
                states: {
                    inactive: {
                        opacity: 1
                    },
                },
                point: {
                    events: {
                        legendItemClick: () => false
                    }
                },
            }
        },
        responsive: {
            rules: [{
                    condition: {
                        maxWidth: config.responsiveWidth || responsiveWidth
                    },
                    chartOptions: {
                        chart: {
                            height: config.hideLegend ? null : `${100 + (config.numberOfItems * 20)}%`,
                        },
                        legend: {
                            align: 'center',
                            verticalAlign: 'bottom',
                            layout: 'vertical',
                            maxHeight: (100 + (config.numberOfItems * 40)) || config.width || 300,
                        }
                    }
                }]
        }
    });
}
function barOptions(config) {
    return merge$1(defaultOptions(config), {
        chart: {
            type: ChartType.Bar,
        },
        xAxis: {
            enabled: !config.disableXLabels,
            type: 'category',
            title: {
                text: config.axisTitleX || ''
            },
        },
        yAxis: {
            enabled: !config.disableYLabels,
            title: {
                text: config.axisTitleY || ''
            },
            gridLineDashStyle: 'Dash',
            gridLineColor: Color.LightPlum,
            gridLineWidth: 1,
        },
        legend: {
            align: 'right',
            verticalAlign: 'top',
            layout: 'vertical',
            x: 0,
            y: 100,
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true
                },
                events: {
                    legendItemClick: (e) => e.preventDefault()
                }
            }
        },
    });
}
function columnOptions(config) {
    return merge$1(barOptions(config), {
        chart: {
            type: ChartType.Column,
        }
    });
}
function lineOptions(config) {
    return merge$1(defaultOptions(config), {
        chart: {
            type: ChartType.Line,
        },
        legend: {
            layout: 'horizontal',
            align: 'left',
        },
        xAxis: {
            enabled: !config.disableXLabels,
            title: {
                text: config.axisTitleX || ''
            },
            labels: {
                x: 0,
                y: 25
            },
            crosshair: {
                color: Color.Plum,
                width: 1,
                dashStyle: 'Solid',
                zIndex: 3
            }
        },
        yAxis: {
            enabled: !config.disableYLabels,
            title: {
                text: config.axisTitleY || ''
            },
            gridLineDashStyle: 'Dash',
            gridLineColor: Color.LightPlum,
            gridLineWidth: 1,
            plotLines: [{
                    color: Color.MediumPlum,
                    dashStyle: 'Dash',
                    width: 1,
                    value: 0,
                    zIndex: 3
                }],
        },
        plotOptions: {
            series: {
                events: {
                    legendItemClick: (e) => e.preventDefault()
                },
                marker: {
                    symbol: 'circle',
                    radius: 0,
                    states: {
                        hover: {
                            radius: 5
                        }
                    }
                },
                zoneAxis: 'x',
            },
        },
    });
}
function areaOptions(config) {
    return merge$1(defaultOptions(config), {
        chart: {
            type: 'area',
        },
        legend: {
            layout: 'horizontal',
            align: 'left',
        },
        xAxis: {
            enabled: !config.disableXLabels,
            // we are manually setting the min to avoid the columns being centered in the area chart
            startOnTick: false,
            endOnTick: false,
            crosshair: {
                color: Color.Plum,
                width: 1,
                dashStyle: 'Solid',
                zIndex: 4
            }
        },
        yAxis: {
            enabled: !config.disableYLabels,
            gridLineDashStyle: 'Dash',
            gridLineColor: Color.LightPlum,
            gridLineWidth: 1,
            gridZIndex: 4,
            lineColor: Color.MediumPlum,
            title: {
                text: ''
            }
        },
        plotOptions: {
            area: {
                marker: {
                    symbol: 'circle',
                    radius: 0,
                    states: {
                        hover: {
                            radius: 5
                        }
                    }
                },
                events: {
                    legendItemClick: (e) => e.preventDefault()
                }
            }
        }
    });
}
function getBaseChartOptionsByType(type, config) {
    let options = null;
    switch (type) {
        case ChartType.Pie:
            options = pieOptions(config);
            break;
        case ChartType.Bar:
            options = barOptions(config);
            break;
        case ChartType.Line:
            options = lineOptions(config);
            break;
        case ChartType.Area:
            options = areaOptions(config);
            break;
        case ChartType.Column:
            options = columnOptions(config);
            break;
        default:
            throw new Error(`Unknown chart type ${type}`);
    }
    if (config.minimal) {
        let minimalOptions = {
            chart: {
                spacingTop: 0,
                spacingRight: 0,
                spacingBottom: 0,
                spacingLeft: 0,
                plotBorderWidth: 0,
                margin: [0, 0, 0, 0],
            }
        };
        options = merge$1(options, minimalOptions);
    }
    // keeping this outside of individual settings as it pertains to multiple charts
    if (config.axisType === 'datetime') {
        let previousYear = null;
        let dateTimeOptions = {
            xAxis: {
                dateTimeLabelFormats: {
                    month: `%b<br/>%Y`,
                    day: '%b %d',
                    year: '%Y'
                },
                labels: {
                    formatter: function () {
                        let format = '';
                        let year = dayjs__default(this.value).utc().year();
                        if (this['tickPositionInfo'].unitName === 'month') {
                            if (!previousYear || year !== previousYear) {
                                // show year
                                format = this['dateTimeLabelFormat'];
                                previousYear = year;
                            }
                            else {
                                // show month
                                format = '%b';
                            }
                        }
                        else if (this['tickPositionInfo'].unitName === 'day') {
                            if (!previousYear || year !== previousYear) {
                                // show year
                                format = `%b %d<br/>%Y`;
                                previousYear = year;
                            }
                            else {
                                // show day
                                format = this['dateTimeLabelFormat'];
                            }
                        }
                        else {
                            format = this['dateTimeLabelFormat'];
                        }
                        return dateFormat(format, this.value, true);
                    }
                }
            }
        };
        options = merge$1(options, dateTimeOptions);
    }
    let xAxis = options.xAxis;
    let yAxis = options.yAxis;
    if (config.axisType) {
        xAxis.type = config.axisType;
    }
    if (config.axisCategoriesX) {
        // this is an override regardless of chart type
        xAxis.categories = config.axisCategoriesX;
    }
    if (config.disableXMarkers) {
        xAxis.lineWidth = 0;
        xAxis.tickWidth = 0;
    }
    if (config.disableYMarkers) {
        yAxis.lineWidth = 0;
        yAxis.tickWidth = 0;
    }
    if (config.hideGrid) {
        xAxis.gridLineWidth = 0;
        xAxis.minorGridLineWidth = 0;
        xAxis.plotLines = [];
        yAxis.gridLineWidth = 0;
        yAxis.minorGridLineWidth = 0;
        yAxis.plotLines = [];
    }
    if (config.responsiveWidth) {
        if (options.responsive.rules && options.responsive.rules[0]) {
            options.responsive.rules[0].condition.maxWidth = config.responsiveWidth;
        }
    }
    if (config.height) {
        options.chart.height = config.height;
    }
    return options;
}

class ChartUtilsService {
    constructor(currencyPipe) {
        this.currencyPipe = currencyPipe;
        this.defaultNumberFormatter = (inputNumber, decimals, decimalPoint, thousandsSep) => {
            // doing this the long form in order to pass digitsInfo
            return this.currencyPipe.transform(inputNumber, 'en-US', '$', `1.0`);
        };
    }
    numericSymbolLogic(numericSymbols, numSymMagnitude, numericSymbolDetector, value, numberFormatter) {
        numberFormatter = numberFormatter || this.defaultNumberFormatter;
        let i = numericSymbols && numericSymbols.length;
        let multi, ret;
        // Decide whether we should add a numeric symbol like k (thousands) or M (millions). If we are to enable this in tooltip or other
        // places as well, we can move this logic to the numberFormatter and enable it by a parameter.
        while (i-- && typeof ret === 'undefined') {
            multi = Math.pow(numSymMagnitude, i + 1);
            if (
            // Only accept a numeric symbol when the distance is more than a full unit. So for example if the symbol is k, we don't accept
            // numbers like 0.5k.
            numericSymbolDetector >= multi
                // Accept one decimal before the symbol. Accepts 0.5k but not 0.25k. How does this work with the previous?
                && (value * 10) % multi === 0
                && numericSymbols[i] !== null
                && value !== 0) { // HighCharts issue #5480
                ret = numberFormatter(value / multi, -1) + numericSymbols[i];
            }
        }
        return ret;
    }
    modifySeriesData(chartSeries, maxItems) {
        chartSeries.forEach((series) => {
            // if the data set is larger than the max items
            if (series.data && series.data.length > maxItems) {
                // Kos - there is a typing issue in the compare function that...angers me.
                let seriesData = series.data;
                seriesData.sort((a, b) => {
                    let value1, value2;
                    if (typeof (a) === 'object') {
                        // if it is an array of SumdayChartDataOptionsType
                        value1 = a.y;
                        value2 = b.y;
                    }
                    else if (Array.isArray(a)) {
                        // if it is an array of arrays
                        value1 = a[1];
                        value2 = b[1];
                    }
                    else {
                        // if it is an array of numbers
                        value1 = a;
                        value2 = b;
                    }
                    return ((value1 > value2) ? -1 : ((value1 < value2) ? 1 : 0));
                });
                // take the largest items for the new data set
                let newDataSet = seriesData.splice(0, (maxItems - 1));
                if (Array.isArray(seriesData[0])) {
                    // if it is an array of arrays
                    // Kos - taking the first value of the first of the array, as it is normally `[[timestamp, value], ...]` and we need a timestamp
                    // this is probably not the best solution...
                    newDataSet.push([
                        seriesData[0][0],
                        seriesData.reduce((a, b) => a + b, 0)
                    ]);
                }
                else if (typeof (seriesData[0]) === 'number') {
                    // if it is an array of numbers
                    newDataSet.push([
                        seriesData.reduce((a, b) => a + b, 0)
                    ]);
                }
                else {
                    // otherwise, it is an array of PointOptionsObject
                    newDataSet.push({
                        name: 'Other',
                        color: Color.LightPlum,
                        y: seriesData.reduce((total, currentValue, index, arr) => total + currentValue.y, 0),
                    });
                }
                series.data = newDataSet;
            }
        });
    }
    static { this.ɵfac = function ChartUtilsService_Factory(t) { return new (t || ChartUtilsService)(i0.ɵɵinject(i1$1.CurrencyPipe)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ChartUtilsService, factory: ChartUtilsService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChartUtilsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.CurrencyPipe }]; }, null); })();

exportModule(HighCharts);
offlineExportModule(HighCharts);
accessibilityModule(HighCharts);
fillPatternModule(HighCharts);
let id$1 = 0;
// this is assets/images/chart/purple-dots.svg base64 encoded
const PURPLE_DOT = 'PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxNHB4IiBoZWlnaHQ9IjE0cHgiIHZpZXdCb3g9IjAgMCAxNCA' +
    'xNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48dGl' +
    '0bGU+cHVycGxlLWRvdHM8L3RpdGxlPjxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPjxnIGlkPSJwdXJwbGUtZG90cyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2l' +
    'kdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGc+PGNpcmNsZSBpZD0iT3ZhbCIgZmlsbD0iIzRDMzE2QyIgZmlsbC1ydWxlPSJub256ZXJvIiBjeD0' +
    'iMC45NzI5IiBjeT0iMC45NzI4IiByPSIxIj48L2NpcmNsZT48Y2lyY2xlIGlkPSJPdmFsIiBmaWxsPSIjNEMzMTZDIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGN4PSI3LjY3NTg' +
    'iIGN5PSIwLjk3MjgiIHI9IjEiPjwvY2lyY2xlPjxjaXJjbGUgaWQ9Ik92YWwiIGZpbGw9IiM0QzMxNkMiIGZpbGwtcnVsZT0ibm9uemVybyIgY3g9IjExLjAyNzMiIGN5PSI' +
    'xMS4wMjcyIiByPSIxIj48L2NpcmNsZT48Y2lyY2xlIGlkPSJPdmFsIiBmaWxsPSIjNEMzMTZDIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGN4PSI0LjMyNDMiIGN5PSIxMS4wMjc' +
    'yIiByPSIxIj48L2NpcmNsZT48Y2lyY2xlIGlkPSJPdmFsIiBmaWxsPSIjNEMzMTZDIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGN4PSIwLjk3MjkiIGN5PSI3LjY3NTciIHI9IjE' +
    'iPjwvY2lyY2xlPjxjaXJjbGUgaWQ9Ik92YWwiIGZpbGw9IiM0QzMxNkMiIGZpbGwtcnVsZT0ibm9uemVybyIgY3g9IjcuNjc1OCIgY3k9IjcuNjc1NyIgcj0iMSI+PC9jaXJ' +
    'jbGU+PGNpcmNsZSBpZD0iT3ZhbCIgZmlsbD0iIzRDMzE2QyIgZmlsbC1ydWxlPSJub256ZXJvIiBjeD0iMTEuMDI3MyIgY3k9IjQuMzI0MiIgcj0iMSI+PC9jaXJjbGU+PGN' +
    'pcmNsZSBpZD0iT3ZhbCIgZmlsbD0iIzRDMzE2QyIgZmlsbC1ydWxlPSJub256ZXJvIiBjeD0iNC4zMjQzIiBjeT0iNC4zMjQyIiByPSIxIj48L2NpcmNsZT48cmVjdCBpZD0' +
    'iUmVjdGFuZ2xlLUNvcHktNDEiIGZpbGwtb3BhY2l0eT0iMCIgZmlsbD0iI0Q4RDhEOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy4zMDAwMDAsIDEyLjcwMDAwMCkgcm90YXR' +
    'lKDkwLjAwMDAwMCkgdHJhbnNsYXRlKC03LjMwMDAwMCwgLTEyLjcwMDAwMCkgIiB4PSI2LjYiIHk9IjkuMyIgd2lkdGg9IjEuNCIgaGVpZ2h0PSI2LjgiPjwvcmVjdD48cmV' +
    'jdCBpZD0iUmVjdGFuZ2xlLUNvcHktNDAiIGZpbGwtb3BhY2l0eT0iMCIgZmlsbD0iI0Q4RDhEOCIgeD0iMTIuMSIgeT0iMS4xIiB3aWR0aD0iMS40IiBoZWlnaHQ9IjYuOCI' +
    '+PC9yZWN0PjwvZz48L2c+PC9zdmc+';
class ChartComponent {
    set chartSeries(data) {
        this.data = data;
        if (this.sumdayChart) {
            this.refresh();
        }
    }
    get chartSeries() {
        return this.data;
    }
    constructor(currencyPipe, windowRef, chartUtils, applicationRef, renderer) {
        this.currencyPipe = currencyPipe;
        this.windowRef = windowRef;
        this.chartUtils = chartUtils;
        this.applicationRef = applicationRef;
        this.renderer = renderer;
        this.inputId = `sumday-chart-${id$1++}`;
        this.hideLegend = false;
        this.hideGrid = false;
        this.enableExport = false;
        this.isStatic = false;
        this.unitIsCurrency = false;
        this.unitPrefix = '';
        this.unitSuffix = '';
        this.unit = '';
        this.formatYAxisLabels = false;
        this.formatXAxisLabels = false;
        this.disableXLabels = false;
        this.disableXMarkers = false;
        this.disableYLabels = false;
        this.disableYMarkers = false;
        this.tooltipOutside = false;
        this.minimal = false;
    }
    // We're using HostListener to subscribe rather than the standard subscriptions
    onWindowResize(event) {
        if (this.sumdayChart) {
            this.refresh(true, this.sumdayChart.chartWidth);
        }
    }
    onBeforePrint(event) {
        this.refresh(true);
    }
    onAfterPrint(event) {
        if (this.isPrinting) {
            // Kos - because of a bug in Chrome, we are manually ensuring that the root component is displayed after printing is complete
            let rootComponent = this.applicationRef.components[0].location.nativeElement;
            this.renderer.removeStyle(rootComponent, 'display');
            this.height = this.oldHeight;
            this.isPrinting = false;
            return this.refresh(true, this.oldWidth);
        }
    }
    ngOnInit() {
        this.colors = [
            Color.ChartColor_1,
            Color.ChartColor_2,
            Color.ChartColor_3,
            Color.ChartColor_4,
            Color.ChartColor_5,
            Color.ChartColor_6,
            Color.ChartColor_7,
            Color.ChartColor_8,
            Color.ChartColor_9,
            Color.ChartColor_10,
            Color.ChartColor_11,
            Color.ChartColor_12,
            Color.ChartColor_13,
            Color.ChartColor_14,
            Color.ChartColor_15
        ];
        let defaultOptions = HighCharts.defaultOptions, format = HighCharts.format, _this = this;
        HighCharts.Axis.prototype.defaultLabelFormatter = function () {
            // FTR: This function came directly from HighCharts support, and is used to better customize the axis labels.
            let axis = this.axis;
            let value = this.value;
            let time = axis.chart.time;
            let categories = axis.categories;
            // @ts-ignore: TS2339: Property 'dateTimeLabelFormat' does not exist on type 'AxisLabelsFormatterContextObject'
            let dateTimeLabelFormat = this.dateTimeLabelFormat;
            let lang = defaultOptions.lang;
            let numericSymbols = lang.numericSymbols;
            let numSymMagnitude = lang.numericSymbolMagnitude || 1000;
            let i = numericSymbols && numericSymbols.length;
            let ret, formatOption = axis.options.labels.format;
            // make sure the same symbol is added for all labels on a linear axis
            // @ts-ignore: TS2339: Property 'tickInterval' does not exist on type 'Axis'
            let numericSymbolDetector = axis.isLog ? Math.abs(value) : axis.tickInterval;
            let instancedChart = this.chart;
            let numberFormatter = _this.chartUtils.defaultNumberFormatter;
            if (formatOption) {
                ret = format(formatOption, this, instancedChart);
            }
            else if (categories) {
                ret = value;
            }
            else if (dateTimeLabelFormat) { // datetime axis
                ret = time.dateFormat(dateTimeLabelFormat, value);
            }
            else if (i && numericSymbolDetector >= 1000) {
                ret = _this.chartUtils.numericSymbolLogic(numericSymbols, numSymMagnitude, numericSymbolDetector, value, numberFormatter);
            }
            if (typeof ret === 'undefined') {
                if (Math.abs(value) >= 10000) { // add thousands separators
                    ret = numberFormatter(value, -1);
                }
                else { // small numbers
                    ret = numberFormatter(value, -1, void 0, ','); // #2466
                }
            }
            return ret;
        };
        setOptions(this.getDefaultOptions());
    }
    ngOnChanges() {
        if (this.sumdayChart) {
            this.refresh(true);
        }
    }
    ngAfterViewInit() {
        this.refresh();
    }
    getDefaultOptions() {
        let _this = this;
        return {
            colors: this.colors,
            chart: {
                events: {
                    redraw: () => {
                        // this is empty to fix a double redraw issue
                    },
                    beforePrint: function () {
                        _this.isPrinting = true;
                        _this.oldWidth = _this.sumdayChart.chartWidth;
                        _this.oldHeight = _this.sumdayChart.chartHeight;
                        this.setSize(_this.windowRef.nativeWindow.innerWidth, _this.windowRef.nativeWindow.innerHeight, false);
                        // as we sometimes saw that the chart height was still limited, we are manually updating the height here as well...
                        this.chartHeight = _this.windowRef.nativeWindow.innerHeight;
                        _this.refresh(true, undefined, true);
                    },
                    afterPrint: function () {
                        _this.isPrinting = false;
                    }
                },
            },
            xAxis: {
                lineColor: Color.MediumPlum,
                tickColor: Color.MediumPlum,
                labels: {
                    style: {
                        opacity: 0.7,
                        color: Color.Plum,
                        fontSize: '14px'
                    }
                }
            },
            yAxis: {
                lineColor: Color.MediumPlum,
                labels: {
                    style: {
                        opacity: 0.7,
                        color: Color.Plum,
                        fontSize: '14px'
                    }
                }
            },
            legend: {
                itemStyle: {
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: 'normal'
                },
            },
            plotOptions: {
                series: {
                    marker: {
                        lineWidth: 1
                    },
                    states: {
                        hover: {
                            lineWidthPlus: 0,
                            halo: {
                                size: 0
                            }
                        },
                        inactive: {
                            opacity: 0.3
                        }
                    }
                }
            },
            tooltip: {
                outside: this.tooltipOutside,
                borderWidth: 0,
                borderRadius: 7,
                backgroundColor: Color.White,
                style: {
                    color: Color.Plum,
                    fontSize: '14px',
                    lineHeight: '21px'
                }
            }
        };
    }
    refresh(disableAnimation = false, width, clearHeight = false) {
        this.options = getBaseChartOptionsByType(this.chartType, {
            isStatic: this.isStatic,
            hideLegend: this.hideLegend,
            axisTitleX: this.axisTitleX,
            axisTitleY: this.axisTitleY,
            hideGrid: this.hideGrid,
            enableExport: this.enableExport,
            title: this.title,
            subtitle: this.subtitle,
            axisType: this.axisType,
            axisCategoriesX: this.axisCategoriesX,
            screenReaderText: this.screenReaderText,
            unitIsCurrency: this.unitIsCurrency,
            unitPrefix: this.unitPrefix,
            unitSuffix: this.unitSuffix,
            unit: this.unit,
            formatYAxisLabels: this.formatYAxisLabels,
            formatXAxisLabels: this.formatXAxisLabels,
            disableXLabels: this.disableXLabels,
            disableXMarkers: this.disableXMarkers,
            disableYLabels: this.disableYLabels,
            disableYMarkers: this.disableYMarkers,
            height: (!clearHeight) ? this.height : null,
            responsiveWidth: this.responsiveWidth,
            minimal: this.minimal,
            disableAnimation,
            width,
            numberOfItems: (this.chartSeries && this.chartSeries.length > 0)
                ? this.chartSeries[0].data.length
                : null,
        });
        if (this.maxItems) {
            this.chartUtils.modifySeriesData(this.chartSeries, this.maxItems);
        }
        this.options.series = this.chartSeries;
        this.addAreaOptionsRequiringSeries();
        this.addTooltip();
        this.formatLabels();
        this.formatDataLabels();
        this.formatLegend();
        if (this.extras) {
            this.options = merge$1(this.options, this.extras);
        }
        this.sumdayChart = chart(this.inputId, this.options);
    }
    formatUnit(value) {
        return this.unitIsCurrency
            ? this.currencyFormatter(value)
            : this.unitFormatter(value);
    }
    currencyFormatter(value) {
        return this.currencyPipe.transform(value);
    }
    unitFormatter(value) {
        value = Math.round(value * 100) / 100;
        if (value >= 0) {
            return `${this.unitPrefix}${value}${this.unitSuffix}`;
        }
        else {
            return `-${this.unitPrefix}${value * -1}${this.unitSuffix}`;
        }
    }
    addTooltip() {
        let _this = this;
        switch (this.chartType) {
            case ChartType.Area:
            case ChartType.Line:
                this.options.tooltip.useHTML = true;
                this.options.tooltip.formatter = tooltipFormatter;
                break;
            case ChartType.Bar:
            case ChartType.Column:
                this.options.tooltip.useHTML = true;
                this.options.tooltip.formatter = formatter;
                break;
            case ChartType.Pie:
                this.options.tooltip.useHTML = true;
                this.options.tooltip.formatter = function () {
                    // due to the use of "this", this is not an arrow function
                    // Kos - also due to javascript being really bad at maths, we are forcing decimal precision here
                    let percentage = Math.round(this.point.percentage * 100) / 100;
                    return `${this.point.name}<br/><strong>${percentage}%</strong>`;
                };
                break;
            default:
                break;
        }
        function formatter() {
            // due to the use of "this", this is not an arrow function
            // Kos - IF we get the e2e back on its feet, this was throwing an error unless typed as "any"
            let point = this.point;
            if (point.tooltipText) {
                return `${point.tooltipText}<br/><strong>${_this.formatUnit(point.y)}</strong>`;
            }
            return `<strong>${_this.formatUnit(point.y)}</strong>`;
        }
        function tooltipFormatter() {
            // due to the use of "this", this is not an arrow function
            let columnText;
            // this.series.chart.options.xAxis[0].type;
            if (_this.axisType === 'datetime') {
                // TS2339: Property 'info' does not exists on type 'number[]'.
                // @ts-ignore
                let unitName = this.series.xAxis.tickPositions.info.unitName;
                let format = 'MMM yyyy';
                if (unitName === 'day') {
                    format = 'MMM dd yyyy';
                }
                columnText = `${new DatePipe('en-us').transform(new Date(this.x), format)}`;
            }
            else {
                columnText = this.x;
            }
            let tooltipHTML = `<strong>${columnText}</strong><br/>`;
            tooltipHTML += `${this.point.series.name}<br>${_this.formatUnit(this.point.y)}`;
            return tooltipHTML;
        }
    }
    formatLabels() {
        if (!this.unitIsCurrency) {
            if (this.formatYAxisLabels || !this.disableYLabels) {
                let yAxis = this.options.yAxis;
                yAxis.labels = yAxis.labels || {};
                yAxis.labels.formatter = ((ctx) => this.unitFormatter(ctx.value));
            }
            if ((this.formatXAxisLabels || !this.disableXLabels) && this.axisType !== 'datetime') {
                let xAxis = this.options.xAxis;
                xAxis.labels = xAxis.labels || {};
                xAxis.labels.formatter = ((ctx) => this.unitFormatter(ctx.value));
            }
        }
    }
    formatDataLabels() {
        switch (this.chartType) {
            case ChartType.Bar:
            case ChartType.Column:
                if (this.options?.plotOptions?.series?.dataLabels) {
                    let _this = this;
                    if (!Array.isArray(this.options.plotOptions.series.dataLabels)) {
                        let dataLabels = this.options.plotOptions.series.dataLabels;
                        dataLabels.formatter = (function () {
                            return _this.formatUnit(this.y);
                        });
                    }
                    else {
                        let dataLabels = this.options.plotOptions.series.dataLabels;
                        dataLabels.forEach(label => {
                            label.formatter = (function () {
                                return _this.formatUnit(this.y);
                            });
                        });
                    }
                }
                break;
            default:
                break;
        }
    }
    formatLegend() {
        if (this.chartType === ChartType.Pie) {
            if (this.unitIsCurrency) {
                let _this = this;
                this.options.legend.labelFormatter = function () {
                    // due to the use of "this", this is not an arrow function
                    let ctx = this;
                    return `<strong>${_this.formatUnit(ctx.y)}</strong><br/>${ctx.name}`;
                };
            }
            else {
                this.options.legend = this.options.legend || {};
                this.options.legend.labelFormatter = function () {
                    let ctx = this;
                    ctx.percentage = Math.round(ctx.percentage * 100) / 100;
                    return `<strong>${ctx.percentage}%</strong><br/>${ctx.name}`;
                };
            }
        }
    }
    addAreaOptionsRequiringSeries() {
        if (this.chartType === ChartType.Area) {
            let series1 = this.chartSeries[0];
            // we are manually setting the max to avoid the columns being centered in the area chart
            if (this.axisType !== 'datetime') {
                this.options.xAxis.min = 0.5;
                this.options.xAxis.max = series1.data.length - 1.5;
            }
            if (this.chartSeries.length === 1) {
                series1.color = Color.ChartColor_2;
                series1.fillColor = Color.ChartColor_3;
                if (this.options.chart.type === ChartType.Line || this.options.chart.type === ChartType.Area) {
                    this.options.xAxis.crosshair = false;
                }
            }
            if (this.chartSeries.length === 2) {
                let series2 = this.chartSeries[1];
                series1.color = Color.ChartColor_2;
                series1.fillColor = Color.ChartColor_3;
                let pattern = {
                    image: `data:image/svg+xml;base64,${PURPLE_DOT}`,
                    width: 14,
                    height: 14,
                };
                series2.color = Color.ChartColor_4;
                series2.fillColor = { pattern: pattern };
            }
        }
    }
    static { this.ɵfac = function ChartComponent_Factory(t) { return new (t || ChartComponent)(i0.ɵɵdirectiveInject(i1$1.CurrencyPipe), i0.ɵɵdirectiveInject(i1.WindowRefService), i0.ɵɵdirectiveInject(ChartUtilsService), i0.ɵɵdirectiveInject(i0.ApplicationRef), i0.ɵɵdirectiveInject(i0.Renderer2)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChartComponent, selectors: [["sumday-chart"]], hostBindings: function ChartComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("resize", function ChartComponent_resize_HostBindingHandler($event) { return ctx.onWindowResize($event); }, false, i0.ɵɵresolveWindow)("beforeprint", function ChartComponent_beforeprint_HostBindingHandler($event) { return ctx.onBeforePrint($event); }, false, i0.ɵɵresolveWindow)("afterprint", function ChartComponent_afterprint_HostBindingHandler($event) { return ctx.onAfterPrint($event); }, false, i0.ɵɵresolveWindow);
        } }, inputs: { chartType: "chartType", chartSeries: "chartSeries", maxItems: "maxItems", extras: "extras", hideLegend: "hideLegend", hideGrid: "hideGrid", enableExport: "enableExport", isStatic: "isStatic", title: "title", subtitle: "subtitle", axisType: "axisType", axisCategoriesX: "axisCategoriesX", axisTitleX: "axisTitleX", axisTitleY: "axisTitleY", screenReaderText: "screenReaderText", unitIsCurrency: "unitIsCurrency", unitPrefix: "unitPrefix", unitSuffix: "unitSuffix", unit: "unit", formatYAxisLabels: "formatYAxisLabels", formatXAxisLabels: "formatXAxisLabels", disableXLabels: "disableXLabels", disableXMarkers: "disableXMarkers", disableYLabels: "disableYLabels", disableYMarkers: "disableYMarkers", height: "height", responsiveWidth: "responsiveWidth", tooltipOutside: "tooltipOutside", minimal: "minimal" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[1, "graph", 3, "id"]], template: function ChartComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("id", ctx.inputId);
        } }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChartComponent, [{
        type: Component,
        args: [{ selector: 'sumday-chart', template: "<div [id]=\"inputId\" class=\"graph\"></div>\n" }]
    }], function () { return [{ type: i1$1.CurrencyPipe }, { type: i1.WindowRefService }, { type: ChartUtilsService }, { type: i0.ApplicationRef }, { type: i0.Renderer2 }]; }, { chartType: [{
            type: Input
        }], chartSeries: [{
            type: Input
        }], maxItems: [{
            type: Input
        }], extras: [{
            type: Input
        }], hideLegend: [{
            type: Input
        }], hideGrid: [{
            type: Input
        }], enableExport: [{
            type: Input
        }], isStatic: [{
            type: Input
        }], title: [{
            type: Input
        }], subtitle: [{
            type: Input
        }], axisType: [{
            type: Input
        }], axisCategoriesX: [{
            type: Input
        }], axisTitleX: [{
            type: Input
        }], axisTitleY: [{
            type: Input
        }], screenReaderText: [{
            type: Input
        }], unitIsCurrency: [{
            type: Input
        }], unitPrefix: [{
            type: Input
        }], unitSuffix: [{
            type: Input
        }], unit: [{
            type: Input
        }], formatYAxisLabels: [{
            type: Input
        }], formatXAxisLabels: [{
            type: Input
        }], disableXLabels: [{
            type: Input
        }], disableXMarkers: [{
            type: Input
        }], disableYLabels: [{
            type: Input
        }], disableYMarkers: [{
            type: Input
        }], height: [{
            type: Input
        }], responsiveWidth: [{
            type: Input
        }], tooltipOutside: [{
            type: Input
        }], minimal: [{
            type: Input
        }], onWindowResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], onBeforePrint: [{
            type: HostListener,
            args: ['window:beforeprint', ['$event']]
        }], onAfterPrint: [{
            type: HostListener,
            args: ['window:afterprint', ['$event']]
        }] }); })();

function PasswordStrengthComponent_ng_content_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 1, ["*ngIf", "!errorMessageMappings", "validation", ""]);
} }
const _c0$7 = ["*", [["sumday-validations"], ["sumday-validation-error"], ["", 8, "validation"]]];
const _c1$6 = ["*", "sumday-validations, sumday-validation-error, .validation"];
let id = 0;
class PasswordStrengthComponent extends BaseControlValueAccessor {
    constructor(controlContainer, ngControl) {
        super();
        this.controlContainer = controlContainer;
        this.ngControl = ngControl;
        this.inputId = `password-strength-${id++}`;
        this.required = true;
        this.strengthScore = 0;
        this.isAriaLive = false;
        this.strengthMessages = [
            `Doesn't meet requirements`,
            `Weak`,
            `Fair`,
            `Strong`,
            `Very strong`
        ];
        this.onChangeCallback = () => { };
        this.onTouchedCallback = () => { };
        this.ngControl.valueAccessor = this;
    }
    ngOnInit() {
        this.control = this.ngControl.control;
        const currentValidators = this.control.validator;
        const validators = (currentValidators) ? [currentValidators] : []; // make sure we don't overwrite any it may have
        validators.push(ExtendedValidators.password);
        if (this.required) {
            validators.push(Validators.required);
        }
        this.control.setValidators(validators);
        this.control.updateValueAndValidity();
        this.control.valueChanges.subscribe(newValue => {
            if (this.control.valid) {
                this.isAriaLive = true; // we don't want to start annoucing the changes until the user hits the requirements
                this.strengthScore = zxcvbn(newValue)['score'];
            }
            else {
                this.strengthScore = 0;
            }
        });
    }
    static { this.ɵfac = function PasswordStrengthComponent_Factory(t) { return new (t || PasswordStrengthComponent)(i0.ɵɵdirectiveInject(i1$4.ControlContainer, 5), i0.ɵɵdirectiveInject(i1$4.NgControl, 10)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PasswordStrengthComponent, selectors: [["sumday-password-strength"]], inputs: { formControlName: "formControlName", required: "required", errorMessageMappings: "errorMessageMappings", fieldParams: "fieldParams" }, features: [i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1$6, decls: 17, vars: 17, consts: [[1, "form-group", 3, "formGroup"], ["type", "password", 3, "formControlName", "extraDescribedBy", "errorMessageMappings", "fieldParams"], [4, "ngIf"], ["role", "presentation", 1, "strength-meter-bars"], [1, "bar-score-0"], [1, "bar-score-1"], [1, "bar-score-2"], [1, "bar-score-3"], [1, "bar-score-4"], [1, "strength-meter-text"], ["role", "presentation", 1, "icon"], [3, "id"], [1, "screen-reader-only"]], template: function PasswordStrengthComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$7);
            i0.ɵɵelementStart(0, "div", 0)(1, "sumday-text", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵtemplate(3, PasswordStrengthComponent_ng_content_3_Template, 1, 0, "ng-content", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div")(5, "div", 3);
            i0.ɵɵelement(6, "div", 4)(7, "div", 5)(8, "div", 6)(9, "div", 7)(10, "div", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "div", 9);
            i0.ɵɵelement(12, "span", 10);
            i0.ɵɵelementStart(13, "span", 11)(14, "span", 12);
            i0.ɵɵtext(15);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(16);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.controlContainer == null ? null : ctx.controlContainer.control);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControlName", ctx.formControlName)("extraDescribedBy", ctx.inputId)("errorMessageMappings", ctx.errorMessageMappings)("fieldParams", ctx.fieldParams);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.errorMessageMappings);
            i0.ɵɵadvance(1);
            i0.ɵɵclassMapInterpolate1("strength-meter score-", ctx.strengthScore, "");
            i0.ɵɵadvance(8);
            i0.ɵɵclassProp("icon-close-rounded", ctx.strengthScore === 0)("icon-checkmark-rounded", ctx.strengthScore > 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("id", ctx.inputId);
            i0.ɵɵattribute("aria-live", ctx.isAriaLive ? "polite" : null);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.strengthScore > 0 ? "The strengh of this password is" : "This password");
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.strengthMessages[ctx.strengthScore], " ");
        } }, dependencies: [i1$1.NgIf, i1$4.NgControlStatus, i1$4.NgControlStatusGroup, i1$4.FormGroupDirective, i1$4.FormControlName, i1.FormControlDirective, i1.FormGroupDirective, TextComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PasswordStrengthComponent, [{
        type: Component,
        args: [{ selector: 'sumday-password-strength', template: "<div class=\"form-group\" [formGroup]=\"controlContainer?.control\">\n  <sumday-text\n    type=\"password\"\n    [formControlName]=\"formControlName\"\n    [extraDescribedBy]=\"inputId\"\n    [errorMessageMappings]=\"errorMessageMappings\"\n    [fieldParams]=\"fieldParams\"\n  >\n    <ng-content></ng-content>\n\n    <ng-content *ngIf=\"!errorMessageMappings\" validation select=\"sumday-validations, sumday-validation-error, .validation\"></ng-content>\n  </sumday-text>\n\n  <div class=\"strength-meter score-{{strengthScore}}\">\n    <div class=\"strength-meter-bars\" role=\"presentation\">\n      <div class=\"bar-score-0\"></div>\n      <div class=\"bar-score-1\"></div>\n      <div class=\"bar-score-2\"></div>\n      <div class=\"bar-score-3\"></div>\n      <div class=\"bar-score-4\"></div>\n    </div>\n    <div class=\"strength-meter-text\">\n      <span\n        role=\"presentation\"\n        class=\"icon\"\n        [class.icon-close-rounded]=\"strengthScore === 0\"\n        [class.icon-checkmark-rounded]=\"strengthScore > 0\">\n      </span>\n      <span\n        [id]=\"inputId\"\n        [attr.aria-live]=\"(isAriaLive) ? 'polite' : null\"\n      >\n        <span class=\"screen-reader-only\">{{ (strengthScore > 0) ?  'The strengh of this password is' : 'This password' }}</span>\n        {{ strengthMessages[strengthScore] }}\n      </span>\n    </div>\n  </div>\n</div>" }]
    }], function () { return [{ type: i1$4.ControlContainer, decorators: [{
                type: Host
            }, {
                type: SkipSelf
            }] }, { type: i1$4.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }]; }, { formControlName: [{
            type: Input
        }], required: [{
            type: Input
        }], errorMessageMappings: [{
            type: Input
        }], fieldParams: [{
            type: Input
        }] }); })();

const _c0$6 = ["content"];
function PiiComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function PiiComponent_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.unmask()); });
    i0.ɵɵtext(1, " show ");
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "i", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.label);
} }
function PiiComponent_sumday_loader_1_address_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "address", 10);
    i0.ɵɵpipe(1, "address");
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r5.addressValue, true), i0.ɵɵsanitizeHtml);
} }
function PiiComponent_sumday_loader_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "birthdate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r6.dateValue));
} }
function PiiComponent_sumday_loader_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.stringValue);
} }
function PiiComponent_sumday_loader_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sumday-loader", 6)(1, "div", null, 7);
    i0.ɵɵtemplate(3, PiiComponent_sumday_loader_1_address_3_Template, 2, 4, "address", 8);
    i0.ɵɵtemplate(4, PiiComponent_sumday_loader_1_ng_container_4_Template, 3, 3, "ng-container", 9);
    i0.ɵɵtemplate(5, PiiComponent_sumday_loader_1_ng_container_5_Template, 2, 1, "ng-container", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("type", ctx_r1.LoaderType.Dots)("condition", !!ctx_r1.hasValue)("loadingMessage", ctx_r1.loadingMessage);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.addressValue);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.dateValue);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.stringValue);
} }
class PiiComponent {
    constructor(cdr, element, renderer) {
        this.cdr = cdr;
        this.element = element;
        this.renderer = renderer;
        this.LoaderType = LoaderType;
        this.masked = true;
        this.hasValue = false;
        this.loadingMessage = 'loading ';
    }
    ngOnInit() {
        if (!this.label) {
            console.error('Pii requires you to set the label input for a11y purposes.  Otherwise the button will be annouced as "button show"');
        }
    }
    ngOnChanges(changes) {
        let labelChanges = changes['label'];
        if (labelChanges &&
            labelChanges.currentValue) {
            this.loadingMessage += labelChanges.currentValue;
        }
    }
    unmask() {
        this.masked = false;
        this.value$.subscribe(value => {
            if (typeof value === 'string') {
                this.stringValue = value;
            }
            else if (value instanceof Date) {
                this.dateValue = value;
            }
            else {
                this.addressValue = value;
            }
            this.hasValue = true;
            this.renderer.setAttribute(this.content.nativeElement, 'tabindex', '-1');
            setTimeout(() => {
                // need a delay before focus for ios voiceover
                this.content.nativeElement.focus();
            }, 1000);
            this.cdr.markForCheck(); // This is required as the zone check is sometimes failing here
        });
    }
    static { this.ɵfac = function PiiComponent_Factory(t) { return new (t || PiiComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PiiComponent, selectors: [["sumday-pii"]], viewQuery: function PiiComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$6, 5, ElementRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
        } }, inputs: { value$: "value$", label: "label" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 3, consts: [["class", "btn-link", 3, "click", 4, "ngIf"], [3, "type", "condition", "loadingMessage", 4, "ngIf"], [3, "text"], [1, "btn-link", 3, "click"], [1, "screen-reader-only"], ["role", "presentation", 1, "icon-visibility"], [3, "type", "condition", "loadingMessage"], ["content", ""], [3, "innerHTML", 4, "ngIf"], [4, "ngIf"], [3, "innerHTML"]], template: function PiiComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, PiiComponent_button_0_Template, 5, 1, "button", 0);
            i0.ɵɵtemplate(1, PiiComponent_sumday_loader_1_Template, 6, 6, "sumday-loader", 1);
            i0.ɵɵelement(2, "sumday-screen-reader-announcement", 2);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.masked);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.masked);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("text", !ctx.masked ? ctx.loadingMessage : "");
        } }, dependencies: [i1$1.NgIf, ScreenReaderAnnouncementComponent, LoaderComponent, i1.AddressPipe, i1.BirthdatePipe], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PiiComponent, [{
        type: Component,
        args: [{ selector: 'sumday-pii', template: "<button\n  *ngIf=\"masked\"\n  class=\"btn-link\"\n  (click)=\"unmask()\"\n>\n  show  <span class=\"screen-reader-only\">{{ label }}</span><i role=\"presentation\" class=\"icon-visibility\"></i>\n</button>\n<sumday-loader\n  *ngIf=\"!masked\"\n  [type]=\"LoaderType.Dots\"\n  [condition]=\"!!hasValue\"\n  [loadingMessage]=\"loadingMessage\"\n>\n  <div #content>\n    <address *ngIf=\"addressValue\" [innerHTML]=\"addressValue | address:true\"></address>\n    <ng-container *ngIf=\"dateValue\">{{ dateValue | birthdate }}</ng-container>\n    <ng-container *ngIf=\"stringValue\">{{ stringValue }}</ng-container>\n  </div>\n\n</sumday-loader>\n\n<sumday-screen-reader-announcement\n  [text]=\"(!masked) ? loadingMessage : ''\"\n></sumday-screen-reader-announcement>" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, { value$: [{
            type: Input
        }], label: [{
            type: Input
        }], content: [{
            type: ViewChild,
            args: ['content', { read: ElementRef }]
        }] }); })();

function DatePickerComponent_ng_content_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 1, ["*ngIf", "!errorMessageMappings", "validation", ""]);
} }
const _c0$5 = ["*", [["sumday-validations"], ["sumday-validation-error"], ["", 8, "validation"]]];
const _c1$5 = ["*", "sumday-validations, sumday-validation-error, .validation"];
class DatePickerComponent extends BaseControlValueAccessor {
    constructor(controlContainer, ngControl) {
        super();
        this.controlContainer = controlContainer;
        this.ngControl = ngControl;
        this.format = 'MM/DD/YYYY';
        this.useDateMask = true;
        this.disabled = false;
        this.readonly = false;
        this.ngControl.valueAccessor = this;
    }
    ngOnInit() {
        this.datePicker = new UntypedFormControl('');
        this.datePipe = new MomentPipe();
        this.datePicker.valueChanges.subscribe((newValue) => {
            this.controlContainer.formDirective.getControl(this.ngControl).patchValue(this.datePipe.transform(newValue, this.format));
        });
    }
    touchOnChanged() {
        this.onTouched();
    }
    static { this.ɵfac = function DatePickerComponent_Factory(t) { return new (t || DatePickerComponent)(i0.ɵɵdirectiveInject(i1$4.ControlContainer, 5), i0.ɵɵdirectiveInject(i1$4.NgControl, 10)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DatePickerComponent, selectors: [["sumday-date-picker"]], inputs: { formControlName: "formControlName", format: "format", useDateMask: "useDateMask", errorMessageMappings: "errorMessageMappings", fieldParams: "fieldParams", disabled: "disabled", readonly: "readonly", placeholder: "placeholder" }, features: [i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1$5, decls: 8, vars: 14, consts: [[3, "formGroup"], [3, "formControlName", "mask", "errorMessageMappings", "fieldParams", "placeholder", "readonly", "disabled"], [4, "ngIf"], ["side-section", "", 3, "disabled", "for"], ["tabindex", "-1", 1, "date-picker-input", 3, "formControl", "matDatepicker", "dateChange"], ["picker", ""]], template: function DatePickerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$5);
            i0.ɵɵelementStart(0, "div", 0)(1, "sumday-text", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵtemplate(3, DatePickerComponent_ng_content_3_Template, 1, 0, "ng-content", 2);
            i0.ɵɵelement(4, "mat-datepicker-toggle", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "input", 4);
            i0.ɵɵlistener("dateChange", function DatePickerComponent_Template_input_dateChange_5_listener() { return ctx.touchOnChanged(); });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(6, "mat-datepicker", null, 5);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(7);
            i0.ɵɵproperty("formGroup", ctx.controlContainer == null ? null : ctx.controlContainer.control);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControlName", ctx.formControlName)("mask", ctx.useDateMask ? "date" : null)("errorMessageMappings", ctx.errorMessageMappings)("fieldParams", ctx.fieldParams)("placeholder", ctx.placeholder)("readonly", ctx.readonly)("disabled", ctx.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.errorMessageMappings);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.readonly || ctx.disabled)("for", _r1);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControl", ctx.datePicker)("matDatepicker", _r1);
            i0.ɵɵattribute("aria-label", "hidden input for ");
        } }, dependencies: [i1$1.NgIf, i1$4.DefaultValueAccessor, i1$4.NgControlStatus, i1$4.NgControlStatusGroup, i1$4.FormControlDirective, i1$4.FormGroupDirective, i1$4.FormControlName, i1.FormControlDirective, i1.FormGroupDirective, i4.MatDatepicker, i4.MatDatepickerInput, i4.MatDatepickerToggle, TextComponent], styles: ["[_nghost-%COMP%]{display:block;position:relative}[_nghost-%COMP%]   .date-picker-input[_ngcontent-%COMP%]{position:absolute;bottom:-2px;right:-2px;height:1px;width:1px;z-index:1;border:none}[_nghost-%COMP%]   sumday-text[_ngcontent-%COMP%]{position:relative;z-index:2;display:block}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatePickerComponent, [{
        type: Component,
        args: [{ selector: 'sumday-date-picker', template: "\n<div [formGroup]=\"controlContainer?.control\">\n  <sumday-text\n    [formControlName]=\"formControlName\"\n    [mask]=\"(useDateMask) ? 'date' : null\"\n    [errorMessageMappings]=\"errorMessageMappings\"\n    [fieldParams]=\"fieldParams\"\n    [placeholder]=\"placeholder\"\n    [readonly]=\"readonly\"\n    [disabled]=\"disabled\"\n    >\n      <ng-content></ng-content>\n\n      <ng-content *ngIf=\"!errorMessageMappings\" validation select=\"sumday-validations, sumday-validation-error, .validation\"></ng-content>\n\n      <mat-datepicker-toggle [disabled]=\"readonly || disabled\" [for]=\"picker\" side-section></mat-datepicker-toggle>\n  </sumday-text>\n\n  <input tabindex=\"-1\" [attr.aria-label]=\"'hidden input for '\" class=\"date-picker-input\" [formControl]=\"datePicker\" [matDatepicker]=\"picker\" (dateChange)=\"touchOnChanged()\"/>\n  <mat-datepicker #picker></mat-datepicker>\n</div>\n\n", styles: [":host{display:block;position:relative}:host .date-picker-input{position:absolute;bottom:-2px;right:-2px;height:1px;width:1px;z-index:1;border:none}:host sumday-text{position:relative;z-index:2;display:block}\n"] }]
    }], function () { return [{ type: i1$4.ControlContainer, decorators: [{
                type: Host
            }, {
                type: SkipSelf
            }] }, { type: i1$4.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }]; }, { formControlName: [{
            type: Input
        }], format: [{
            type: Input
        }], useDateMask: [{
            type: Input
        }], errorMessageMappings: [{
            type: Input
        }], fieldParams: [{
            type: Input
        }], disabled: [{
            type: Input
        }], readonly: [{
            type: Input
        }], placeholder: [{
            type: Input
        }] }); })();

function FieldsetListComponent_sumday_validations_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sumday-validations", 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("errorMessageMappings", ctx_r0.errorMessageMappings[ctx_r0.formControlName])("fieldParams", ctx_r0.fieldParams);
} }
function FieldsetListComponent_sumday_validations_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sumday-validations", 3);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("errorMessageMappings", ctx_r1.errorMessageMappings[ctx_r1.formControlName])("fieldParams", ctx_r1.fieldParams);
} }
const _c0$4 = ["*", [["li"], ["sumday-radio-fieldset-item"], ["sumday-checkbox-fieldset-item"], ["sumday-checklist-fieldset-item"]]];
const _c1$4 = ["*", "li, sumday-radio-fieldset-item, sumday-checkbox-fieldset-item, sumday-checklist-fieldset-item"];
class FieldsetListComponent extends BaseControlValueAccessor {
    constructor(controlContainer, ngControl) {
        super();
        this.controlContainer = controlContainer;
        this.ngControl = ngControl;
        this.required = true;
        this.inputId = null;
        this.extraULClass = '';
        this.onChangeCallback = () => { };
        this.onTouchedCallback = () => { };
        this.ngControl.valueAccessor = this;
    }
    ngOnInit() {
        this.control = this.ngControl.control;
        let currentValidators = this.control.validator;
        let validators = (currentValidators) ? [currentValidators] : []; // make sure we don't overwrite any it may have
        if (this.required) {
            validators.push(Validators.required);
        }
        this.control.setValidators(validators);
        this.control.updateValueAndValidity();
    }
    static { this.ɵfac = function FieldsetListComponent_Factory(t) { return new (t || FieldsetListComponent)(i0.ɵɵdirectiveInject(i1$4.ControlContainer, 5), i0.ɵɵdirectiveInject(i1$4.NgControl, 10)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FieldsetListComponent, selectors: [["sumday-fieldset-list"], ["nge-fieldset-list"]], inputs: { formControlName: "formControlName", required: "required", errorMessageMappings: "errorMessageMappings", fieldParams: "fieldParams", inputId: "inputId", extraULClass: "extraULClass" }, features: [i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1$4, decls: 7, vars: 5, consts: [["class", "screen-reader-only", 3, "errorMessageMappings", "fieldParams", 4, "ngIf"], ["aria-hidden", "true", 3, "errorMessageMappings", "fieldParams", 4, "ngIf"], [1, "screen-reader-only", 3, "errorMessageMappings", "fieldParams"], ["aria-hidden", "true", 3, "errorMessageMappings", "fieldParams"]], template: function FieldsetListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$4);
            i0.ɵɵelementStart(0, "fieldset")(1, "legend");
            i0.ɵɵprojection(2);
            i0.ɵɵtemplate(3, FieldsetListComponent_sumday_validations_3_Template, 1, 2, "sumday-validations", 0);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "ul");
            i0.ɵɵprojection(5, 1);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, FieldsetListComponent_sumday_validations_6_Template, 1, 2, "sumday-validations", 1);
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.errorMessageMappings);
            i0.ɵɵadvance(1);
            i0.ɵɵclassMapInterpolate1("input-list ", ctx.extraULClass, "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.errorMessageMappings);
        } }, dependencies: [i1$1.NgIf, ValidationsComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FieldsetListComponent, [{
        type: Component,
        args: [{ selector: 'sumday-fieldset-list, nge-fieldset-list', template: "<fieldset>\n  <legend>\n    <ng-content></ng-content>\n    <sumday-validations class=\"screen-reader-only\" *ngIf=\"errorMessageMappings\" [errorMessageMappings]=\"errorMessageMappings[formControlName]\" [fieldParams]=\"fieldParams\"></sumday-validations>\n  </legend>\n  <ul class=\"input-list {{extraULClass}}\">\n    <ng-content select=\"li, sumday-radio-fieldset-item, sumday-checkbox-fieldset-item, sumday-checklist-fieldset-item\"></ng-content>\n  </ul>\n</fieldset>\n<sumday-validations aria-hidden=\"true\" *ngIf=\"errorMessageMappings\" [errorMessageMappings]=\"errorMessageMappings[formControlName]\" [fieldParams]=\"fieldParams\"></sumday-validations>" }]
    }], function () { return [{ type: i1$4.ControlContainer, decorators: [{
                type: Host
            }, {
                type: SkipSelf
            }] }, { type: i1$4.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }]; }, { formControlName: [{
            type: Input
        }], required: [{
            type: Input
        }], errorMessageMappings: [{
            type: Input
        }], fieldParams: [{
            type: Input
        }], inputId: [{
            type: Input
        }], extraULClass: [{
            type: Input
        }] }); })();

class BaseFieldsetListItemComponent extends BaseControlValueAccessor {
    constructor(fieldListComponent, ngControl, viewContainerRef) {
        super();
        this.fieldListComponent = fieldListComponent;
        this.ngControl = ngControl;
        this.viewContainerRef = viewContainerRef;
        this.ToggleType = ToggleType;
        this.ngControl = this.fieldListComponent.ngControl;
        this.ngControl.valueAccessor = this;
    }
    ngOnInit() {
        if (!this.formControlName) {
            this.formControlName = this.fieldListComponent.formControlName;
        }
    }
    renderTemplate(templateRef) {
        const embeddedViewRef = this.viewContainerRef.createEmbeddedView(templateRef);
        embeddedViewRef.detectChanges();
        // clearing out the empty wrapper element
        // we can remove this once we move to angular 9
        const parentElement = this.viewContainerRef.element.nativeElement.parentElement;
        const element = this.viewContainerRef.element.nativeElement;
        parentElement.removeChild(element);
    }
    static { this.ɵfac = function BaseFieldsetListItemComponent_Factory(t) { return new (t || BaseFieldsetListItemComponent)(i0.ɵɵdirectiveInject(FieldsetListComponent), i0.ɵɵdirectiveInject(i1$4.NgControl, 10), i0.ɵɵdirectiveInject(i0.ViewContainerRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BaseFieldsetListItemComponent, selectors: [["sumday-base-fieldset-list-item"]], inputs: { formControlName: "formControlName", errorMessageMappings: "errorMessageMappings", fieldParams: "fieldParams", value: "value", id: "id" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function BaseFieldsetListItemComponent_Template(rf, ctx) { }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseFieldsetListItemComponent, [{
        type: Component,
        args: [{
                selector: 'sumday-base-fieldset-list-item',
                template: ''
            }]
    }], function () { return [{ type: FieldsetListComponent }, { type: i1$4.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: i0.ViewContainerRef }]; }, { formControlName: [{
            type: Input
        }], errorMessageMappings: [{
            type: Input
        }], fieldParams: [{
            type: Input
        }], value: [{
            type: Input
        }], id: [{
            type: Input
        }] }); })();

const _c0$3 = ["template"];
function RadioFieldsetListItemComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0);
} }
function RadioFieldsetListItemComponent_ng_template_2_sumday_radio_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function RadioFieldsetListItemComponent_ng_template_2_sumday_radio_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sumday-radio", 5);
    i0.ɵɵtemplate(1, RadioFieldsetListItemComponent_ng_template_2_sumday_radio_2_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("formControlName", ctx_r4.formControlName)("value", ctx_r4.value)("id", ctx_r4.inputId)("errorMessageMappings", ctx_r4.errorMessageMappings)("fieldParams", ctx_r4.fieldParams);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function RadioFieldsetListItemComponent_ng_template_2_sumday_checkbox_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function RadioFieldsetListItemComponent_ng_template_2_sumday_checkbox_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sumday-checkbox", 5);
    i0.ɵɵtemplate(1, RadioFieldsetListItemComponent_ng_template_2_sumday_checkbox_3_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("formControlName", ctx_r5.formControlName)("value", ctx_r5.value)("id", ctx_r5.inputId)("errorMessageMappings", ctx_r5.errorMessageMappings)("fieldParams", ctx_r5.fieldParams);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function RadioFieldsetListItemComponent_ng_template_2_sumday_checklist_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function RadioFieldsetListItemComponent_ng_template_2_sumday_checklist_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sumday-checklist", 5);
    i0.ɵɵtemplate(1, RadioFieldsetListItemComponent_ng_template_2_sumday_checklist_4_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("formControlName", ctx_r6.formControlName)("value", ctx_r6.value)("id", ctx_r6.inputId)("errorMessageMappings", ctx_r6.errorMessageMappings)("fieldParams", ctx_r6.fieldParams);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function RadioFieldsetListItemComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 2);
    i0.ɵɵelementContainerStart(1, 3);
    i0.ɵɵtemplate(2, RadioFieldsetListItemComponent_ng_template_2_sumday_radio_2_Template, 2, 6, "sumday-radio", 4);
    i0.ɵɵtemplate(3, RadioFieldsetListItemComponent_ng_template_2_sumday_checkbox_3_Template, 2, 6, "sumday-checkbox", 4);
    i0.ɵɵtemplate(4, RadioFieldsetListItemComponent_ng_template_2_sumday_checklist_4_Template, 2, 6, "sumday-checklist", 4);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r3.controlContainer == null ? null : ctx_r3.controlContainer.control);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r3.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r3.ToggleType.Radio);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r3.ToggleType.Checkbox);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r3.ToggleType.Checklist);
} }
const _c1$3 = ["*"];
class RadioFieldsetListItemComponent extends BaseFieldsetListItemComponent {
    constructor(controlContainer, ngControl, viewContainerRef, fieldListComponent) {
        super(fieldListComponent, ngControl, viewContainerRef);
        this.controlContainer = controlContainer;
        this.ngControl = ngControl;
        this.viewContainerRef = viewContainerRef;
        this.fieldListComponent = fieldListComponent;
        this.type = ToggleType.Radio;
    }
    ngAfterViewInit() {
        this.renderTemplate(this.templateRef);
    }
    static { this.ɵfac = function RadioFieldsetListItemComponent_Factory(t) { return new (t || RadioFieldsetListItemComponent)(i0.ɵɵdirectiveInject(i1$4.ControlContainer, 5), i0.ɵɵdirectiveInject(i1$4.NgControl, 10), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(FieldsetListComponent)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RadioFieldsetListItemComponent, selectors: [["sumday-radio-fieldset-item"]], viewQuery: function RadioFieldsetListItemComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$3, 5, TemplateRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
        } }, features: [i0.ɵɵProvidersFeature([{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => RadioFieldsetListItemComponent),
                    multi: true
                }]), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1$3, decls: 4, vars: 0, consts: [["ngContent", ""], ["template", ""], [3, "formGroup"], [3, "ngSwitch"], [3, "formControlName", "value", "id", "errorMessageMappings", "fieldParams", 4, "ngSwitchCase"], [3, "formControlName", "value", "id", "errorMessageMappings", "fieldParams"], [4, "ngTemplateOutlet"]], template: function RadioFieldsetListItemComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, RadioFieldsetListItemComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(2, RadioFieldsetListItemComponent_ng_template_2_Template, 5, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } }, dependencies: [i1$1.NgTemplateOutlet, i1$1.NgSwitch, i1$1.NgSwitchCase, i1$4.NgControlStatus, i1$4.NgControlStatusGroup, i1$4.FormGroupDirective, i1$4.FormControlName, i1.FormControlDirective, i1.FormGroupDirective, RadioComponent, CheckboxComponent, ChecklistComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioFieldsetListItemComponent, [{
        type: Component,
        args: [{ selector: 'sumday-radio-fieldset-item', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => RadioFieldsetListItemComponent),
                        multi: true
                    }], template: "<ng-template #ngContent>\n  <ng-content></ng-content>\n</ng-template>\n\n<ng-template #template>\n  <li [formGroup]=\"controlContainer?.control\">\n    <ng-container [ngSwitch]=\"type\">\n      <sumday-radio\n        *ngSwitchCase=\"ToggleType.Radio\"\n        [formControlName]=\"formControlName\"\n        [value]=\"value\"\n        [id]=\"inputId\"\n        [errorMessageMappings]=\"errorMessageMappings\"\n        [fieldParams]=\"fieldParams\"\n      >\n        <ng-container *ngTemplateOutlet=\"ngContent\"></ng-container>\n      </sumday-radio>\n\n      <sumday-checkbox\n        *ngSwitchCase=\"ToggleType.Checkbox\"\n        [formControlName]=\"formControlName\"\n        [value]=\"value\"\n        [id]=\"inputId\"\n        [errorMessageMappings]=\"errorMessageMappings\"\n        [fieldParams]=\"fieldParams\"\n      >\n        <ng-container *ngTemplateOutlet=\"ngContent\"></ng-container>\n      </sumday-checkbox>\n\n      <sumday-checklist\n        *ngSwitchCase=\"ToggleType.Checklist\"\n        [formControlName]=\"formControlName\"\n        [value]=\"value\"\n        [id]=\"inputId\"\n        [errorMessageMappings]=\"errorMessageMappings\"\n        [fieldParams]=\"fieldParams\"\n      >\n        <ng-container *ngTemplateOutlet=\"ngContent\"></ng-container>\n      </sumday-checklist>\n    </ng-container>\n  </li>\n</ng-template>" }]
    }], function () { return [{ type: i1$4.ControlContainer, decorators: [{
                type: Host
            }, {
                type: SkipSelf
            }] }, { type: i1$4.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: i0.ViewContainerRef }, { type: FieldsetListComponent }]; }, { templateRef: [{
            type: ViewChild,
            args: ['template', { read: TemplateRef }]
        }] }); })();

const _c0$2 = ["template"];
function CheckboxFieldsetListItemComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0);
} }
function CheckboxFieldsetListItemComponent_ng_template_2_sumday_radio_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CheckboxFieldsetListItemComponent_ng_template_2_sumday_radio_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sumday-radio", 5);
    i0.ɵɵtemplate(1, CheckboxFieldsetListItemComponent_ng_template_2_sumday_radio_2_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("formControlName", ctx_r4.formControlName)("value", ctx_r4.value)("id", ctx_r4.inputId)("errorMessageMappings", ctx_r4.errorMessageMappings)("fieldParams", ctx_r4.fieldParams);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function CheckboxFieldsetListItemComponent_ng_template_2_sumday_checkbox_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CheckboxFieldsetListItemComponent_ng_template_2_sumday_checkbox_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sumday-checkbox", 5);
    i0.ɵɵtemplate(1, CheckboxFieldsetListItemComponent_ng_template_2_sumday_checkbox_3_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("formControlName", ctx_r5.formControlName)("value", ctx_r5.value)("id", ctx_r5.inputId)("errorMessageMappings", ctx_r5.errorMessageMappings)("fieldParams", ctx_r5.fieldParams);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function CheckboxFieldsetListItemComponent_ng_template_2_sumday_checklist_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CheckboxFieldsetListItemComponent_ng_template_2_sumday_checklist_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sumday-checklist", 5);
    i0.ɵɵtemplate(1, CheckboxFieldsetListItemComponent_ng_template_2_sumday_checklist_4_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("formControlName", ctx_r6.formControlName)("value", ctx_r6.value)("id", ctx_r6.inputId)("errorMessageMappings", ctx_r6.errorMessageMappings)("fieldParams", ctx_r6.fieldParams);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function CheckboxFieldsetListItemComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 2);
    i0.ɵɵelementContainerStart(1, 3);
    i0.ɵɵtemplate(2, CheckboxFieldsetListItemComponent_ng_template_2_sumday_radio_2_Template, 2, 6, "sumday-radio", 4);
    i0.ɵɵtemplate(3, CheckboxFieldsetListItemComponent_ng_template_2_sumday_checkbox_3_Template, 2, 6, "sumday-checkbox", 4);
    i0.ɵɵtemplate(4, CheckboxFieldsetListItemComponent_ng_template_2_sumday_checklist_4_Template, 2, 6, "sumday-checklist", 4);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r3.controlContainer == null ? null : ctx_r3.controlContainer.control);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r3.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r3.ToggleType.Radio);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r3.ToggleType.Checkbox);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r3.ToggleType.Checklist);
} }
const _c1$2 = ["*"];
class CheckboxFieldsetListItemComponent extends BaseFieldsetListItemComponent {
    constructor(controlContainer, ngControl, viewContainerRef, fieldListComponent) {
        super(fieldListComponent, ngControl, viewContainerRef);
        this.controlContainer = controlContainer;
        this.ngControl = ngControl;
        this.viewContainerRef = viewContainerRef;
        this.fieldListComponent = fieldListComponent;
        this.type = ToggleType.Checkbox;
    }
    ngAfterViewInit() {
        this.renderTemplate(this.templateRef);
    }
    static { this.ɵfac = function CheckboxFieldsetListItemComponent_Factory(t) { return new (t || CheckboxFieldsetListItemComponent)(i0.ɵɵdirectiveInject(i1$4.ControlContainer, 5), i0.ɵɵdirectiveInject(i1$4.NgControl, 10), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(FieldsetListComponent)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CheckboxFieldsetListItemComponent, selectors: [["sumday-checkbox-fieldset-item"]], viewQuery: function CheckboxFieldsetListItemComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$2, 5, TemplateRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
        } }, features: [i0.ɵɵProvidersFeature([{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => CheckboxFieldsetListItemComponent),
                    multi: true
                }]), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1$2, decls: 4, vars: 0, consts: [["ngContent", ""], ["template", ""], [3, "formGroup"], [3, "ngSwitch"], [3, "formControlName", "value", "id", "errorMessageMappings", "fieldParams", 4, "ngSwitchCase"], [3, "formControlName", "value", "id", "errorMessageMappings", "fieldParams"], [4, "ngTemplateOutlet"]], template: function CheckboxFieldsetListItemComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, CheckboxFieldsetListItemComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(2, CheckboxFieldsetListItemComponent_ng_template_2_Template, 5, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } }, dependencies: [i1$1.NgTemplateOutlet, i1$1.NgSwitch, i1$1.NgSwitchCase, i1$4.NgControlStatus, i1$4.NgControlStatusGroup, i1$4.FormGroupDirective, i1$4.FormControlName, i1.FormControlDirective, i1.FormGroupDirective, RadioComponent, CheckboxComponent, ChecklistComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckboxFieldsetListItemComponent, [{
        type: Component,
        args: [{ selector: 'sumday-checkbox-fieldset-item', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CheckboxFieldsetListItemComponent),
                        multi: true
                    }], template: "<ng-template #ngContent>\n  <ng-content></ng-content>\n</ng-template>\n\n<ng-template #template>\n  <li [formGroup]=\"controlContainer?.control\">\n    <ng-container [ngSwitch]=\"type\">\n      <sumday-radio\n        *ngSwitchCase=\"ToggleType.Radio\"\n        [formControlName]=\"formControlName\"\n        [value]=\"value\"\n        [id]=\"inputId\"\n        [errorMessageMappings]=\"errorMessageMappings\"\n        [fieldParams]=\"fieldParams\"\n      >\n        <ng-container *ngTemplateOutlet=\"ngContent\"></ng-container>\n      </sumday-radio>\n\n      <sumday-checkbox\n        *ngSwitchCase=\"ToggleType.Checkbox\"\n        [formControlName]=\"formControlName\"\n        [value]=\"value\"\n        [id]=\"inputId\"\n        [errorMessageMappings]=\"errorMessageMappings\"\n        [fieldParams]=\"fieldParams\"\n      >\n        <ng-container *ngTemplateOutlet=\"ngContent\"></ng-container>\n      </sumday-checkbox>\n\n      <sumday-checklist\n        *ngSwitchCase=\"ToggleType.Checklist\"\n        [formControlName]=\"formControlName\"\n        [value]=\"value\"\n        [id]=\"inputId\"\n        [errorMessageMappings]=\"errorMessageMappings\"\n        [fieldParams]=\"fieldParams\"\n      >\n        <ng-container *ngTemplateOutlet=\"ngContent\"></ng-container>\n      </sumday-checklist>\n    </ng-container>\n  </li>\n</ng-template>" }]
    }], function () { return [{ type: i1$4.ControlContainer, decorators: [{
                type: Host
            }, {
                type: SkipSelf
            }] }, { type: i1$4.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: i0.ViewContainerRef }, { type: FieldsetListComponent }]; }, { templateRef: [{
            type: ViewChild,
            args: ['template', { read: TemplateRef }]
        }] }); })();

const _c0$1 = ["template"];
function ChecklistFieldsetListItemComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0);
} }
function ChecklistFieldsetListItemComponent_ng_template_2_sumday_radio_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ChecklistFieldsetListItemComponent_ng_template_2_sumday_radio_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sumday-radio", 5);
    i0.ɵɵtemplate(1, ChecklistFieldsetListItemComponent_ng_template_2_sumday_radio_2_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("formControlName", ctx_r4.formControlName)("value", ctx_r4.value)("id", ctx_r4.inputId)("errorMessageMappings", ctx_r4.errorMessageMappings)("fieldParams", ctx_r4.fieldParams);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function ChecklistFieldsetListItemComponent_ng_template_2_sumday_checkbox_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ChecklistFieldsetListItemComponent_ng_template_2_sumday_checkbox_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sumday-checkbox", 5);
    i0.ɵɵtemplate(1, ChecklistFieldsetListItemComponent_ng_template_2_sumday_checkbox_3_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("formControlName", ctx_r5.formControlName)("value", ctx_r5.value)("id", ctx_r5.inputId)("errorMessageMappings", ctx_r5.errorMessageMappings)("fieldParams", ctx_r5.fieldParams);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function ChecklistFieldsetListItemComponent_ng_template_2_sumday_checklist_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ChecklistFieldsetListItemComponent_ng_template_2_sumday_checklist_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sumday-checklist", 5);
    i0.ɵɵtemplate(1, ChecklistFieldsetListItemComponent_ng_template_2_sumday_checklist_4_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("formControlName", ctx_r6.formControlName)("value", ctx_r6.value)("id", ctx_r6.inputId)("errorMessageMappings", ctx_r6.errorMessageMappings)("fieldParams", ctx_r6.fieldParams);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function ChecklistFieldsetListItemComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 2);
    i0.ɵɵelementContainerStart(1, 3);
    i0.ɵɵtemplate(2, ChecklistFieldsetListItemComponent_ng_template_2_sumday_radio_2_Template, 2, 6, "sumday-radio", 4);
    i0.ɵɵtemplate(3, ChecklistFieldsetListItemComponent_ng_template_2_sumday_checkbox_3_Template, 2, 6, "sumday-checkbox", 4);
    i0.ɵɵtemplate(4, ChecklistFieldsetListItemComponent_ng_template_2_sumday_checklist_4_Template, 2, 6, "sumday-checklist", 4);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r3.controlContainer == null ? null : ctx_r3.controlContainer.control);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r3.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r3.ToggleType.Radio);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r3.ToggleType.Checkbox);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r3.ToggleType.Checklist);
} }
const _c1$1 = ["*"];
class ChecklistFieldsetListItemComponent extends BaseFieldsetListItemComponent {
    constructor(controlContainer, ngControl, viewContainerRef, fieldListComponent) {
        super(fieldListComponent, ngControl, viewContainerRef);
        this.controlContainer = controlContainer;
        this.ngControl = ngControl;
        this.viewContainerRef = viewContainerRef;
        this.fieldListComponent = fieldListComponent;
        this.type = ToggleType.Checklist;
    }
    ngAfterViewInit() {
        this.renderTemplate(this.templateRef);
    }
    static { this.ɵfac = function ChecklistFieldsetListItemComponent_Factory(t) { return new (t || ChecklistFieldsetListItemComponent)(i0.ɵɵdirectiveInject(i1$4.ControlContainer, 5), i0.ɵɵdirectiveInject(i1$4.NgControl, 10), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(FieldsetListComponent)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChecklistFieldsetListItemComponent, selectors: [["sumday-checklist-fieldset-item"]], viewQuery: function ChecklistFieldsetListItemComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1, 5, TemplateRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
        } }, features: [i0.ɵɵProvidersFeature([{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => ChecklistFieldsetListItemComponent),
                    multi: true
                }]), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1$1, decls: 4, vars: 0, consts: [["ngContent", ""], ["template", ""], [3, "formGroup"], [3, "ngSwitch"], [3, "formControlName", "value", "id", "errorMessageMappings", "fieldParams", 4, "ngSwitchCase"], [3, "formControlName", "value", "id", "errorMessageMappings", "fieldParams"], [4, "ngTemplateOutlet"]], template: function ChecklistFieldsetListItemComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ChecklistFieldsetListItemComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(2, ChecklistFieldsetListItemComponent_ng_template_2_Template, 5, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } }, dependencies: [i1$1.NgTemplateOutlet, i1$1.NgSwitch, i1$1.NgSwitchCase, i1$4.NgControlStatus, i1$4.NgControlStatusGroup, i1$4.FormGroupDirective, i1$4.FormControlName, i1.FormControlDirective, i1.FormGroupDirective, RadioComponent, CheckboxComponent, ChecklistComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChecklistFieldsetListItemComponent, [{
        type: Component,
        args: [{ selector: 'sumday-checklist-fieldset-item', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => ChecklistFieldsetListItemComponent),
                        multi: true
                    }], template: "<ng-template #ngContent>\n  <ng-content></ng-content>\n</ng-template>\n\n<ng-template #template>\n  <li [formGroup]=\"controlContainer?.control\">\n    <ng-container [ngSwitch]=\"type\">\n      <sumday-radio\n        *ngSwitchCase=\"ToggleType.Radio\"\n        [formControlName]=\"formControlName\"\n        [value]=\"value\"\n        [id]=\"inputId\"\n        [errorMessageMappings]=\"errorMessageMappings\"\n        [fieldParams]=\"fieldParams\"\n      >\n        <ng-container *ngTemplateOutlet=\"ngContent\"></ng-container>\n      </sumday-radio>\n\n      <sumday-checkbox\n        *ngSwitchCase=\"ToggleType.Checkbox\"\n        [formControlName]=\"formControlName\"\n        [value]=\"value\"\n        [id]=\"inputId\"\n        [errorMessageMappings]=\"errorMessageMappings\"\n        [fieldParams]=\"fieldParams\"\n      >\n        <ng-container *ngTemplateOutlet=\"ngContent\"></ng-container>\n      </sumday-checkbox>\n\n      <sumday-checklist\n        *ngSwitchCase=\"ToggleType.Checklist\"\n        [formControlName]=\"formControlName\"\n        [value]=\"value\"\n        [id]=\"inputId\"\n        [errorMessageMappings]=\"errorMessageMappings\"\n        [fieldParams]=\"fieldParams\"\n      >\n        <ng-container *ngTemplateOutlet=\"ngContent\"></ng-container>\n      </sumday-checklist>\n    </ng-container>\n  </li>\n</ng-template>" }]
    }], function () { return [{ type: i1$4.ControlContainer, decorators: [{
                type: Host
            }, {
                type: SkipSelf
            }] }, { type: i1$4.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: i0.ViewContainerRef }, { type: FieldsetListComponent }]; }, { templateRef: [{
            type: ViewChild,
            args: ['template', { read: TemplateRef }]
        }] }); })();

function GainsComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("screen-reader-only", !ctx_r0.showLeadText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r0.increased ? "up" : "down", " ");
} }
function GainsComponent_p_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1, "|");
    i0.ɵɵelementEnd();
} }
function GainsComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵtemplate(3, GainsComponent_p_3_span_3_Template, 2, 0, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(2, 2, ctx_r1.gains, "USD", "symbol", "1.2-2"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.gainsPercentage !== null);
} }
function GainsComponent_p_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "+");
    i0.ɵɵelementEnd();
} }
function GainsComponent_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 6);
    i0.ɵɵtemplate(1, GainsComponent_p_4_span_1_Template, 2, 0, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.increased);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r2.floatingPoint ? ctx_r2.gainsPercentage.toFixed(ctx_r2.floatingPoint) : ctx_r2.gainsPercentage, "% ");
} }
function GainsComponent_p_5_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function GainsComponent_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "moment");
    i0.ɵɵtemplate(3, GainsComponent_p_5_span_3_Template, 2, 0, "span", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" since ", i0.ɵɵpipeBind2(2, 2, ctx_r3.sinceDate, ctx_r3.dateFormat), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.showAsterisk);
} }
class GainsComponent {
    constructor() {
        this.increased = false;
        this.isZero = false;
        this.floatingPoint = 2;
        this.showAsterisk = true;
        this.gainsPercentage = null;
        this.gains = null;
        this.dateFormat = 'MMM YYYY';
        this.showLeadText = false;
        this.useEmptyIconForZero = false;
    }
    ngOnInit() {
        this.isZero = this.gainsPercentage === 0 && this.gains === 0;
        this.increased = (this.gainsPercentage > 0 || this.gains > 0);
    }
    static { this.ɵfac = function GainsComponent_Factory(t) { return new (t || GainsComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GainsComponent, selectors: [["sumday-gains"]], inputs: { floatingPoint: "floatingPoint", showAsterisk: "showAsterisk", gainsPercentage: "gainsPercentage", gains: "gains", sinceDate: "sinceDate", dateFormat: "dateFormat", showLeadText: "showLeadText", useEmptyIconForZero: "useEmptyIconForZero" }, decls: 6, vars: 16, consts: [[3, "screen-reader-only", 4, "ngIf"], [1, "icon"], [4, "ngIf"], ["class", "percentage", 4, "ngIf"], ["aria-hidden", "true", 4, "ngIf"], ["aria-hidden", "true"], [1, "percentage"]], template: function GainsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, GainsComponent_span_1_Template, 2, 3, "span", 0);
            i0.ɵɵelementStart(2, "div", 1);
            i0.ɵɵtemplate(3, GainsComponent_p_3_Template, 4, 7, "p", 2);
            i0.ɵɵtemplate(4, GainsComponent_p_4_Template, 3, 2, "p", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, GainsComponent_p_5_Template, 4, 5, "p", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵclassProp("increase", ctx.increased)("decrease", !ctx.increased && !ctx.isZero)("empty-icon", ctx.useEmptyIconForZero)("no-zero-icon", ctx.isZero && !ctx.useEmptyIconForZero)("with-lead-text", ctx.showLeadText || ctx.gains === null);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.isZero);
            i0.ɵɵadvance(1);
            i0.ɵɵclassProp("zero", ctx.isZero);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.gains !== null);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.gainsPercentage !== null);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.sinceDate);
        } }, dependencies: [i1$1.NgIf, i1$1.CurrencyPipe, i1.MomentPipe], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GainsComponent, [{
        type: Component,
        args: [{ selector: 'sumday-gains', template: "<div [class.increase]=\"increased\"\n     [class.decrease]=\"!increased && !isZero\"\n     [class.empty-icon]=\"useEmptyIconForZero\"\n     [class.no-zero-icon]=\"isZero && !useEmptyIconForZero\"\n     [class.with-lead-text]=\"showLeadText || gains === null\">\n  <span *ngIf=\"!isZero\" [class.screen-reader-only]=\"!showLeadText\">{{ (increased) ? 'up' : 'down' }} </span>\n  <div class=\"icon\" [class.zero]=\"isZero\">\n    <p *ngIf=\"gains !== null\">\n      {{gains | currency:'USD':'symbol':'1.2-2'}}<span *ngIf=\"gainsPercentage !== null\" aria-hidden=\"true\">|</span>\n    </p>\n    <p class=\"percentage\" *ngIf=\"gainsPercentage !== null\">\n      <span *ngIf=\"increased\">+</span>{{ (floatingPoint) ? gainsPercentage.toFixed(floatingPoint) : gainsPercentage }}%\n    </p>\n  </div>\n\n  <p *ngIf=\"sinceDate\">\n    since {{sinceDate | moment: dateFormat}}<span *ngIf=\"showAsterisk\">*</span>\n  </p>\n</div>" }]
    }], function () { return []; }, { floatingPoint: [{
            type: Input
        }], showAsterisk: [{
            type: Input
        }], gainsPercentage: [{
            type: Input
        }], gains: [{
            type: Input
        }], sinceDate: [{
            type: Input
        }], dateFormat: [{
            type: Input
        }], showLeadText: [{
            type: Input
        }], useEmptyIconForZero: [{
            type: Input
        }] }); })();

const transactionFilterDayOptions = [
    { value: 'all', text: 'All time' },
    { value: '365', text: 'Last 12 months' },
    { value: '180', text: 'Last 6 months' },
    { value: '90', text: 'Last 3 months' },
    { value: 'custom', text: 'Custom' }
];

function TransactionFiltersComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "strong");
    i0.ɵɵtext(2, "all transactions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function TransactionFiltersComponent_ng_container_5_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, ", ");
    i0.ɵɵelementContainerEnd();
} }
function TransactionFiltersComponent_ng_container_5_ng_container_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " and ");
    i0.ɵɵelementContainerEnd();
} }
function TransactionFiltersComponent_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, TransactionFiltersComponent_ng_container_5_ng_container_1_ng_container_3_Template, 2, 0, "ng-container", 3);
    i0.ɵɵtemplate(4, TransactionFiltersComponent_ng_container_5_ng_container_1_ng_container_4_Template, 2, 0, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const type_r8 = ctx.$implicit;
    const last_r9 = ctx.last;
    const count_r5 = i0.ɵɵnextContext().ngIf;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.getFilterTitle(type_r8));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", count_r5 > 2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", count_r5 > 2 && last_r9 || count_r5 === 2 && !last_r9);
} }
function TransactionFiltersComponent_ng_container_5_strong_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "strong");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "plural");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const count_r5 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", count_r5 - 2, " ", i0.ɵɵpipeBind2(2, 2, "other", count_r5 - 2), "");
} }
function TransactionFiltersComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TransactionFiltersComponent_ng_container_5_ng_container_1_Template, 5, 3, "ng-container", 20);
    i0.ɵɵtemplate(2, TransactionFiltersComponent_ng_container_5_strong_2_Template, 3, 5, "strong", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const count_r5 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.filters == null ? null : ctx_r1.filters.types == null ? null : ctx_r1.filters.types.slice(0, 2));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", count_r5 > 2);
} }
function TransactionFiltersComponent_ng_container_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "moment");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " - ");
    i0.ɵɵelementStart(5, "strong");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "moment");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 2, ctx_r14.filters == null ? null : ctx_r14.filters.startDate, "MMM DD, YYYY"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(7, 5, ctx_r14.filters == null ? null : ctx_r14.filters.endDate, "MMM DD, YYYY"));
} }
function TransactionFiltersComponent_ng_container_6_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " the ");
    i0.ɵɵelementStart(2, "strong", 28);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r15.getFilterDayText(ctx_r15.filters == null ? null : ctx_r15.filters.days));
} }
function TransactionFiltersComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " from ");
    i0.ɵɵelementContainerStart(2, 25);
    i0.ɵɵtemplate(3, TransactionFiltersComponent_ng_container_6_ng_container_3_Template, 8, 8, "ng-container", 26);
    i0.ɵɵtemplate(4, TransactionFiltersComponent_ng_container_6_ng_container_4_Template, 4, 1, "ng-container", 27);
    i0.ɵɵelementContainerEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitch", ctx_r2.filters == null ? null : ctx_r2.filters.days);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "custom");
} }
function TransactionFiltersComponent_div_27_ng_container_10_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1, " We need to know the start date to move on. ");
    i0.ɵɵelementEnd();
} }
function TransactionFiltersComponent_div_27_ng_container_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1, " That start date doesn't look right. Check your format. ");
    i0.ɵɵelementEnd();
} }
function TransactionFiltersComponent_div_27_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TransactionFiltersComponent_div_27_ng_container_10_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵtemplate(2, TransactionFiltersComponent_div_27_ng_container_10_div_2_Template, 2, 0, "div", 36);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.form.get("startDate").hasError("required"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.form.get("startDate").hasError("date") || ctx_r16.form.get("startDate").hasError("futuredate"));
} }
function TransactionFiltersComponent_div_27_ng_container_12_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1, " We need to know the end date to move on. ");
    i0.ɵɵelementEnd();
} }
function TransactionFiltersComponent_div_27_ng_container_12_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1, " That end date doesn't look right. Check your format. ");
    i0.ɵɵelementEnd();
} }
function TransactionFiltersComponent_div_27_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TransactionFiltersComponent_div_27_ng_container_12_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵtemplate(2, TransactionFiltersComponent_div_27_ng_container_12_div_2_Template, 2, 0, "div", 36);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.form.get("endDate").hasError("required"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.form.get("endDate").hasError("date") || ctx_r17.form.get("endDate").hasError("futuredate") || ctx_r17.form.get("endDate").hasError("afterStartDate"));
} }
function TransactionFiltersComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29)(1, "sumday-grid", 13)(2, "sumday-grid", 30)(3, "sumday-text", 31);
    i0.ɵɵtext(4, " From ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "sumday-grid", 30)(6, "sumday-text", 32);
    i0.ɵɵtext(7, " To ");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "div", 33)(9, "div", 34);
    i0.ɵɵtemplate(10, TransactionFiltersComponent_div_27_ng_container_10_Template, 3, 2, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 35);
    i0.ɵɵtemplate(12, TransactionFiltersComponent_div_27_ng_container_12_Template, 3, 2, "ng-container", 3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngIf", ctx_r3.form.get("startDate").touched);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.form.get("endDate").touched);
} }
function TransactionFiltersComponent_li_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "sumday-checklist", 38);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const filter_r22 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "filter-", filter_r22.type, "");
    i0.ɵɵproperty("value", filter_r22.type);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", filter_r22.title, " ");
} }
class TransactionFiltersComponent {
    get openFilters() {
        return this.openFiltersValue;
    }
    set openFilters(value) {
        this.openFiltersValue = value;
        if (value) {
            this.focusHeaderOnOpen();
        }
        else {
            this.refocusPreviouslyFocusedItemOnClose();
        }
        this.openFiltersChange.emit(this.openFiltersValue);
    }
    onDocKeydown(event) {
        switch (event.keyCode) {
            case KeyCodes.ESC:
                event.preventDefault();
                this.openFilters = false;
                break;
        }
    }
    constructor(document, element) {
        this.document = document;
        this.element = element;
        this.setFilters = new EventEmitter();
        this.download = new EventEmitter();
        this.isCustomDays = false;
        this.hideAbleToWork = false;
        this.formSubmitting = false;
        this.daysOptions = transactionFilterDayOptions;
        this.showFilters = false;
        this.filters = extend(true, {}, DEFAULT_ACTIVITY_PARAMS);
        this.filterCount = 0;
        this.dateValidators = [
            Validators.required,
            ExtendedValidators.date,
            ExtendedValidators.futureDate,
        ];
        this.openFiltersChange = new EventEmitter();
        this.afterStartDate = (value) => {
            let date = dayjs(value, 'MM/DD/YYYY', 'en', true);
            if (!date.isValid()) {
                return false;
            }
            return dayjs(this.form.get('startDate').value, 'MM/DD/YYYY').isBefore(date);
        };
    }
    focusHeaderOnOpen() {
        this.previouslyFocusedElement = this.document.activeElement;
        const headerTag = this.element.nativeElement.querySelector('h2[tabindex="-1"]');
        if (headerTag) {
            // timeout for iOS nonsense
            setTimeout(() => {
                headerTag.focus();
            }, 500);
        }
    }
    refocusPreviouslyFocusedItemOnClose() {
        if (this.previouslyFocusedElement) {
            setTimeout(() => {
                this.previouslyFocusedElement.focus();
                this.previouslyFocusedElement = null;
            }, 500);
        }
    }
    ngOnInit() {
        this.days = new UntypedFormControl();
        this.form = new UntypedFormGroup({
            days: this.days,
            types: new UntypedFormControl(),
            startDate: new UntypedFormControl(null, ExtendedValidators.requiredIf(() => this.isCustomDays, Validators.compose([
                ...this.dateValidators
            ]))),
            endDate: new UntypedFormControl(null, ExtendedValidators.requiredIf(() => this.isCustomDays, Validators.compose([
                ...this.dateValidators,
                ExtendedValidators.callback(this.afterStartDate, 'afterStartDate')
            ]))),
        });
        // Set either the default or previously selected filters
        this.form.patchValue(this.filters);
        this.form.updateValueAndValidity();
        // Mark non-defaults as dirty
        if (this.form.get('days').value !== DEFAULT_ACTIVITY_PARAMS.days) {
            this.form.get('days').markAsDirty();
        }
        if (this.form.get('types').value.length > 0) {
            this.form.get('types').markAsDirty();
        }
        this.days.valueChanges.subscribe(change => {
            this.setDays(this.days.value);
        });
    }
    setDays(days) {
        switch (days) {
            case 'custom':
                this.isCustomDays = true;
                this.form.get('startDate').patchValue(null);
                this.form.get('endDate').patchValue(null);
                this.form.get('startDate').markAsUntouched();
                this.form.get('endDate').markAsUntouched();
                this.form.get('startDate').markAsPristine();
                this.form.get('endDate').markAsPristine();
                break;
            case 'all':
                this.isCustomDays = false;
                this.form.get('startDate').patchValue(null);
                this.form.get('endDate').patchValue(null);
                break;
            default:
                this.isCustomDays = false;
                this.form.get('startDate').patchValue(dayjs().subtract(days, 'days').format('MM/DD/YYYY'));
                this.form.get('endDate').patchValue(dayjs().format('MM/DD/YYYY'));
                break;
        }
    }
    getFilterDayText(days) {
        let option = transactionFilterDayOptions.find(dayOption => dayOption.value === days);
        if (option) {
            return option.text;
        }
        return null;
    }
    getFilterTitle(filterType) {
        return this.activityFilters.find(filter => filter.type === filterType)?.title || null;
    }
    clear(section) {
        let copyOfDefault = extend(true, {}, DEFAULT_ACTIVITY_PARAMS);
        if (section) {
            if (section === 'days') {
                this.setDays(copyOfDefault[section]);
            }
            else {
                this.form.get(section).patchValue(copyOfDefault[section]);
            }
        }
        else {
            this.isCustomDays = false;
            this.form.patchValue(copyOfDefault);
        }
        this.form.updateValueAndValidity();
        this.setFilters.emit(this.form.value);
    }
    apply() {
        this.filters = this.form.value;
        this.filterCount = this.filters.types ? this.filters.types.length : 0;
        if (this.filters.days !== 'all') {
            this.filterCount++;
        }
        this.setFilters.emit(this.filters);
        this.openFilters = false;
    }
    static { this.ɵfac = function TransactionFiltersComponent_Factory(t) { return new (t || TransactionFiltersComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TransactionFiltersComponent, selectors: [["sumday-transaction-filters"]], hostBindings: function TransactionFiltersComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("keydown", function TransactionFiltersComponent_keydown_HostBindingHandler($event) { return ctx.onDocKeydown($event); }, false, i0.ɵɵresolveDocument);
        } }, inputs: { type: "type", activityFilters: "activityFilters", openFilters: "openFilters" }, outputs: { setFilters: "setFilters", download: "download", openFiltersChange: "openFiltersChange" }, decls: 40, vars: 16, consts: [[1, "transactions-header"], [1, "transactions-header-title"], [1, "h4", "margin-b-0"], [4, "ngIf"], [1, "btn-link", "btn-dark", 3, "click"], [1, "icon-download"], [1, "icon-filter"], [1, "filter-container"], [1, "filter-header", "clearfix"], ["tabindex", "-1", 1, "h3"], ["aria-label", "close filters", "type", "button", 1, "btn-icon", "btn-inverse", "icon-close", 3, "click"], [3, "formGroup", "ngSubmit"], [1, "filter-content"], ["container", ""], ["desktop", "3"], ["formControlName", "days", 3, "value", "list", "normalDescription", "hideSelectedDescription"], ["class", "form-group date-range", 4, "ngIf"], ["desktop", "8", "desktopOffset", "1"], [1, "margin-b-100"], [1, "filter-types"], [4, "ngFor", "ngForOf"], [1, "filter-buttons"], [1, "button-container", "btc-flush"], ["type", "button", 1, "btn-inverse", 3, "disabled", "click"], [3, "disabled"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [1, "lowercase"], [1, "form-group", "date-range"], ["desktop", "6"], ["mask", "date", "inputmode", "numeric", "id", "startDate", "formControlName", "startDate", "placeholder", "MM/DD/YYYY", "ariaDescribedBy", "startDateError"], ["mask", "date", "inputmode", "numeric", "id", "endDate", "formControlName", "endDate", "placeholder", "MM/DD/YYYY", "ariaDescribedBy", "endDateError"], [1, "errors"], ["id", "startDateError", "role", "alert", "aria-live", "polite"], ["id", "endDateError", "role", "alert", "aria-live", "polite"], ["class", "validation", 4, "ngIf"], [1, "validation"], ["formControlName", "types", 3, "id", "value"]], template: function TransactionFiltersComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h2", 2);
            i0.ɵɵtext(3, " Showing ");
            i0.ɵɵtemplate(4, TransactionFiltersComponent_ng_container_4_Template, 3, 0, "ng-container", 3);
            i0.ɵɵtemplate(5, TransactionFiltersComponent_ng_container_5_Template, 3, 2, "ng-container", 3);
            i0.ɵɵtemplate(6, TransactionFiltersComponent_ng_container_6_Template, 5, 2, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "ul")(8, "li")(9, "button", 4);
            i0.ɵɵlistener("click", function TransactionFiltersComponent_Template_button_click_9_listener() { return ctx.download == null ? null : ctx.download.emit(ctx.filters); });
            i0.ɵɵtext(10, "Download ");
            i0.ɵɵelement(11, "i", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "li")(13, "button", 4);
            i0.ɵɵlistener("click", function TransactionFiltersComponent_Template_button_click_13_listener() { return ctx.openFilters = true; });
            i0.ɵɵtext(14, "Filter ");
            i0.ɵɵelement(15, "i", 6);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(16, "div", 7)(17, "div", 8)(18, "h2", 9);
            i0.ɵɵtext(19, "Filter");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(20, "button", 10);
            i0.ɵɵlistener("click", function TransactionFiltersComponent_Template_button_click_20_listener() { return ctx.openFilters = false; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(21, "form", 11);
            i0.ɵɵlistener("ngSubmit", function TransactionFiltersComponent_Template_form_ngSubmit_21_listener() { return ctx.apply(); });
            i0.ɵɵelementStart(22, "div", 12)(23, "sumday-grid", 13)(24, "sumday-grid", 14)(25, "sumday-select", 15);
            i0.ɵɵtext(26, " Choose a time period ");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(27, TransactionFiltersComponent_div_27_Template, 13, 2, "div", 16);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(28, "sumday-grid", 17)(29, "fieldset")(30, "legend", 18);
            i0.ɵɵtext(31, "Activity types");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(32, "ul", 19);
            i0.ɵɵtemplate(33, TransactionFiltersComponent_li_33_Template, 3, 3, "li", 20);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(34, "div", 21)(35, "div", 22)(36, "button", 23);
            i0.ɵɵlistener("click", function TransactionFiltersComponent_Template_button_click_36_listener() { return ctx.clear(); });
            i0.ɵɵtext(37, "Clear");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(38, "button", 24);
            i0.ɵɵtext(39, "Apply");
            i0.ɵɵelementEnd()()()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵclassProp("hide", ctx.openFilters);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", (ctx.filters == null ? null : ctx.filters.types == null ? null : ctx.filters.types.length) === 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.filters == null ? null : ctx.filters.types == null ? null : ctx.filters.types.length);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.filters == null ? null : ctx.filters.days) !== "all");
            i0.ɵɵadvance(10);
            i0.ɵɵclassProp("hide", !ctx.openFilters);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("value", ctx.days.value)("list", ctx.daysOptions)("normalDescription", true)("hideSelectedDescription", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.isCustomDays);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngForOf", ctx.activityFilters);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", !ctx.form.dirty || ctx.form.invalid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", !ctx.form.dirty || ctx.form.invalid);
        } }, dependencies: [i1$1.NgForOf, i1$1.NgIf, i1$1.NgSwitch, i1$1.NgSwitchCase, i1$1.NgSwitchDefault, i1$4.ɵNgNoValidate, i1$4.NgControlStatus, i1$4.NgControlStatusGroup, i1$4.FormGroupDirective, i1$4.FormControlName, i1.FormControlDirective, i1.FormGroupDirective, GridComponent, SelectComponent, TextComponent, ChecklistComponent, i1.MomentPipe, i1.PluralPipe], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TransactionFiltersComponent, [{
        type: Component,
        args: [{ selector: 'sumday-transaction-filters', template: "<div class=\"transactions-header\">\n  <div class=\"transactions-header-title\" [class.hide]=\"openFilters\">\n    <h2 class=\"h4 margin-b-0\">\n      Showing\n\n      <ng-container *ngIf=\"filters?.types?.length === 0\">\n        <strong>all transactions</strong>\n      </ng-container>\n\n      <ng-container *ngIf=\"filters?.types?.length as count\">\n        <ng-container *ngFor=\"let type of filters?.types?.slice(0, 2); let last = last;\">\n          <strong>{{ getFilterTitle(type) }}</strong>\n          <ng-container *ngIf=\"count > 2\">, </ng-container>\n          <ng-container *ngIf=\"(count > 2 && last) || (count === 2 && !last)\"> and </ng-container>\n        </ng-container>\n        <strong *ngIf=\"count > 2\">{{ count - 2 }} {{ 'other' | plural:(count - 2) }}</strong>\n      </ng-container>\n\n      <ng-container *ngIf=\"filters?.days !== 'all'\">\n        from\n\n        <ng-container [ngSwitch]=\"filters?.days\">\n          <ng-container *ngSwitchCase=\"'custom'\">\n            <strong>{{ filters?.startDate | moment:\"MMM DD, YYYY\" }}</strong> -\n            <strong>{{ filters?.endDate | moment:\"MMM DD, YYYY\" }}</strong>\n          </ng-container>\n\n          <ng-container *ngSwitchDefault>\n            the <strong class=\"lowercase\">{{ getFilterDayText(filters?.days) }}</strong>\n          </ng-container>\n        </ng-container>\n\n      </ng-container>\n    </h2>\n\n    <ul>\n      <li>\n        <button class=\"btn-link btn-dark\" (click)=\"download?.emit(filters)\">Download <i class=\"icon-download\"></i></button>\n      </li>\n      <li>\n        <button (click)=\"openFilters = true\" class=\"btn-link btn-dark\">Filter <i class=\"icon-filter\"></i></button>\n      </li>\n    </ul>\n  </div>\n  <div class=\"filter-container\" [class.hide]=\"!openFilters\">\n    <div class=\"filter-header clearfix\">\n      <h2 class=\"h3\" tabindex=\"-1\">Filter</h2>\n      <button aria-label=\"close filters\" type=\"button\" class=\"btn-icon btn-inverse icon-close\" (click)=\"openFilters = false\"></button>\n    </div>\n    <form [formGroup]=\"form\" (ngSubmit)=\"apply()\">\n      <div class=\"filter-content\">\n        <sumday-grid container>\n          <sumday-grid desktop=\"3\">\n            <sumday-select\n              [value]=\"days.value\"\n              [list]=\"daysOptions\"\n              [normalDescription]=\"true\"\n              [hideSelectedDescription]=\"true\"\n              formControlName=\"days\"\n            >\n              Choose a time period\n            </sumday-select>\n\n            <div *ngIf=\"isCustomDays\" class=\"form-group date-range\">\n              <sumday-grid container>\n                <sumday-grid desktop=\"6\">\n                  <sumday-text\n                    mask=\"date\"\n                    inputmode=\"numeric\"\n                    id=\"startDate\"\n                    formControlName=\"startDate\"\n                    placeholder=\"MM/DD/YYYY\"\n                    ariaDescribedBy=\"startDateError\"\n                  >\n                    From\n                  </sumday-text>\n                </sumday-grid>\n                <sumday-grid desktop=\"6\">\n                  <sumday-text\n                    mask=\"date\"\n                    inputmode=\"numeric\"\n                    id=\"endDate\"\n                    formControlName=\"endDate\"\n                    placeholder=\"MM/DD/YYYY\"\n                    ariaDescribedBy=\"endDateError\"\n                  >\n                    To\n                  </sumday-text>\n                </sumday-grid>\n              </sumday-grid>\n              <div class=\"errors\">\n                <div id=\"startDateError\" role=\"alert\" aria-live=\"polite\">\n                  <ng-container *ngIf=\"form.get('startDate').touched\">\n                    <div *ngIf=\"form.get('startDate').hasError('required')\" class=\"validation\">\n                      We need to know the start date to move on.\n                    </div>\n                    <div *ngIf=\"form.get('startDate').hasError('date') || form.get('startDate').hasError('futuredate')\" class=\"validation\">\n                      That start date doesn't look right. Check your format.\n                    </div>\n                  </ng-container>\n                </div>\n\n                <div id=\"endDateError\" role=\"alert\" aria-live=\"polite\">\n                  <ng-container *ngIf=\"form.get('endDate').touched\">\n                    <div *ngIf=\"form.get('endDate').hasError('required')\" class=\"validation\">\n                      We need to know the end date to move on.\n                    </div>\n                    <div *ngIf=\"form.get('endDate').hasError('date') || form.get('endDate').hasError('futuredate') || form.get('endDate').hasError('afterStartDate')\" class=\"validation\">\n                      That end date doesn't look right. Check your format.\n                    </div>\n                  </ng-container>\n                </div>\n              </div>\n            </div>\n          </sumday-grid>\n          <sumday-grid desktop=\"8\" desktopOffset=\"1\">\n            <fieldset>\n              <legend class=\"margin-b-100\">Activity types</legend>\n\n              <ul class=\"filter-types\">\n                <li *ngFor=\"let filter of activityFilters\">\n                  <sumday-checklist\n                    formControlName=\"types\"\n                    id=\"filter-{{filter.type}}\"\n                    [value]=\"filter.type\"\n                  >\n                    {{ filter.title }}\n                  </sumday-checklist>\n                </li>\n              </ul>\n\n            </fieldset>\n          </sumday-grid>\n        </sumday-grid>\n      </div>\n      <div class=\"filter-buttons\">\n        <div class=\"button-container btc-flush\">\n          <button [disabled]=\"!form.dirty || form.invalid\" type=\"button\" (click)=\"clear()\" class=\"btn-inverse\">Clear</button>\n          <button [disabled]=\"!form.dirty || form.invalid\">Apply</button>\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n" }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: i0.ElementRef }]; }, { type: [{
            type: Input
        }], activityFilters: [{
            type: Input
        }], setFilters: [{
            type: Output
        }], download: [{
            type: Output
        }], openFilters: [{
            type: Input
        }], openFiltersChange: [{
            type: Output
        }], onDocKeydown: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }] }); })();

class ExpandButtonComponent {
    get open() {
        return this.openValue;
    }
    set open(value) {
        this.openValue = value;
        this.openChange.emit(this.openValue);
    }
    constructor(expandableContainerDirective) {
        this.expandableContainerDirective = expandableContainerDirective;
        this.openValue = false;
        this.contentId = '';
        this.label = '';
        this.openChange = new EventEmitter();
    }
    ngOnInit() {
        if (this.expandableContainerDirective) {
            this.contentId = this.expandableContainerDirective.expandableItemId;
        }
        else {
            console.error('Expand button must be a child of an ExpandableContainerDirective');
        }
    }
    static { this.ɵfac = function ExpandButtonComponent_Factory(t) { return new (t || ExpandButtonComponent)(i0.ɵɵdirectiveInject(i1.ExpandableContainerDirective, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExpandButtonComponent, selectors: [["sumday-expand-button"]], inputs: { label: "label", open: "open" }, outputs: { openChange: "openChange" }, decls: 4, vars: 5, consts: [["role", "button", "tabindex", "0", 1, "icons", "hide-on-print", 3, "click"], ["aria-hidden", "true"], [1, "btn-icon", "btn-inverse", "icon-plus"], [1, "btn-icon", "btn-inverse", "icon-minus"]], template: function ExpandButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function ExpandButtonComponent_Template_div_click_0_listener() { return ctx.open = !ctx.open; });
            i0.ɵɵelementStart(1, "span", 1);
            i0.ɵɵelement(2, "span", 2)(3, "span", 3);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵclassProp("open", ctx.open);
            i0.ɵɵattribute("aria-label", ctx.label)("aria-controls", ctx.contentId)("aria-expanded", ctx.open);
        } }, dependencies: [i1.RoleButtonDirective], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExpandButtonComponent, [{
        type: Component,
        args: [{ selector: 'sumday-expand-button', template: "<div\n  class=\"icons hide-on-print\"\n  [class.open]=\"open\"\n  [attr.aria-label]=\"label\"\n  [attr.aria-controls]=\"contentId\"\n  [attr.aria-expanded]=\"open\"\n  (click)=\"open = !open\"\n  role=\"button\"\n  tabindex=\"0\"\n>\n  <span aria-hidden=\"true\">\n    <span class=\"btn-icon btn-inverse icon-plus\"></span>\n    <span class=\"btn-icon btn-inverse icon-minus\"></span>\n  </span>\n</div>" }]
    }], function () { return [{ type: i1.ExpandableContainerDirective, decorators: [{
                type: Optional
            }] }]; }, { label: [{
            type: Input
        }], open: [{
            type: Input
        }], openChange: [{
            type: Output
        }] }); })();

const _c0 = [[["", "header", ""]], [["", "details", ""]]];
const _c1 = ["[header]", "[details]"];
class ExpandableCardComponent {
    constructor() {
        this.extraDetailsClasses = '';
        this.extraClasses = '';
        this.toggleOnRowClick = true;
        this.openValue = false;
        this.contentId = '';
        this.openChange = new EventEmitter();
    }
    get open() {
        return this.openValue;
    }
    set open(value) {
        this.openValue = value;
        this.openChange.emit(this.openValue);
    }
    ngOnInit() { }
    toggle() {
        if (this.toggleOnRowClick) {
            if (this.toggleOpen) {
                this.open = this.toggleOpen(this.cardInfo);
            }
            else {
                this.open = !!this.open;
            }
        }
    }
    static { this.ɵfac = function ExpandableCardComponent_Factory(t) { return new (t || ExpandableCardComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExpandableCardComponent, selectors: [["sumday-expandable-card"]], inputs: { cardInfo: "cardInfo", expandButtonLabel: "expandButtonLabel", extraDetailsClasses: "extraDetailsClasses", extraClasses: "extraClasses", toggleOpen: "toggleOpen", toggleOnRowClick: "toggleOnRowClick", open: "open" }, outputs: { openChange: "openChange" }, ngContentSelectors: _c1, decls: 7, vars: 12, consts: [["expandableContainer", ""], [1, "expandable-item-title", 3, "click"], [3, "label", "open", "openChange"], ["expandableContent", "", 3, "open"]], template: function ExpandableCardComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵlistener("click", function ExpandableCardComponent_Template_div_click_1_listener() { return ctx.toggle(); });
            i0.ɵɵprojection(2);
            i0.ɵɵelementStart(3, "div")(4, "sumday-expand-button", 2);
            i0.ɵɵlistener("openChange", function ExpandableCardComponent_Template_sumday_expand_button_openChange_4_listener($event) { return ctx.open = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(5, "div", 3);
            i0.ɵɵprojection(6, 1);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("expandable-item clearfix ", ctx.extraClasses, "");
            i0.ɵɵclassProp("active", ctx.open);
            i0.ɵɵattribute("aria-expanded", ctx.open);
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("label", ctx.expandButtonLabel);
            i0.ɵɵproperty("open", ctx.open);
            i0.ɵɵadvance(1);
            i0.ɵɵclassMapInterpolate1("expandable-item-details ", ctx.extraDetailsClasses, "");
            i0.ɵɵproperty("open", ctx.open);
        } }, dependencies: [i1.ExpandableContentDirective, i1.ExpandableContainerDirective, ExpandButtonComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExpandableCardComponent, [{
        type: Component,
        args: [{ selector: 'sumday-expandable-card', template: "<div\n  class=\"expandable-item clearfix {{ extraClasses }}\"\n  [attr.aria-expanded]=\"open\"\n  [class.active]=\"open\"\n  expandableContainer\n>\n  <div class=\"expandable-item-title\" (click)=\"toggle()\">\n    <ng-content select=\"[header]\"></ng-content>\n    <div>\n      <sumday-expand-button\n        label=\"{{expandButtonLabel}}\"\n        [(open)]=\"open\"\n      ></sumday-expand-button>\n    </div>\n  </div>\n  <div class=\"expandable-item-details {{extraDetailsClasses}}\" expandableContent [open]=\"open\">\n    <ng-content select=\"[details]\"></ng-content>\n  </div>\n</div>\n" }]
    }], null, { cardInfo: [{
            type: Input
        }], expandButtonLabel: [{
            type: Input
        }], extraDetailsClasses: [{
            type: Input
        }], extraClasses: [{
            type: Input
        }], toggleOpen: [{
            type: Input
        }], toggleOnRowClick: [{
            type: Input
        }], open: [{
            type: Input
        }], openChange: [{
            type: Output
        }] }); })();

const components = [
    GridComponent,
    HeaderComponent,
    FooterComponent,
    SelectComponent,
    SelectListComponent,
    SelectItemComponent,
    TextComponent,
    RadioComponent,
    CheckboxComponent,
    ChecklistComponent,
    ProgressBarComponent,
    SocialLinksComponent,
    TooltipComponent,
    NotificationComponent,
    DialogComponent,
    TablistComponent,
    TabRowComponent,
    ScreenReaderAnnouncementComponent,
    AccordionComponent,
    StepsComponent,
    AddressComponent,
    TakeOverModalComponent,
    PopupModalComponent,
    FormBoxComponent,
    UploaderComponent,
    LoaderComponent,
    ValidationErrorComponent,
    PasswordStrengthComponent,
    ValidationsComponent,
    StateDropdownDirective,
    ChartComponent,
    PiiComponent,
    DatePickerComponent,
    FieldsetListComponent,
    RadioFieldsetListItemComponent,
    ChecklistFieldsetListItemComponent,
    CheckboxFieldsetListItemComponent,
    BaseFieldsetListItemComponent,
    GainsComponent,
    TransactionFiltersComponent,
    ExpandableCardComponent,
    ExpandButtonComponent,
    FootnoteComponent,
    FootnoteLinkComponent
];
class SumdayComponentModule {
    static { this.ɵfac = function SumdayComponentModule_Factory(t) { return new (t || SumdayComponentModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SumdayComponentModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            ChartUtilsService
        ], imports: [CommonModule,
            RouterModule,
            FormsModule,
            ReactiveFormsModule,
            SumdayCommonModule,
            MatDatepickerModule,
            MatNativeDateModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SumdayComponentModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule,
                    FormsModule,
                    ReactiveFormsModule,
                    SumdayCommonModule,
                    MatDatepickerModule,
                    MatNativeDateModule
                ],
                exports: [
                    ...components,
                    PreviewCheckComponent,
                ],
                declarations: [
                    ...components,
                    PreviewCheckComponent,
                ],
                providers: [
                    ChartUtilsService
                ],
                schemas: [
                    CUSTOM_ELEMENTS_SCHEMA
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SumdayComponentModule, { declarations: [GridComponent,
        HeaderComponent,
        FooterComponent,
        SelectComponent,
        SelectListComponent,
        SelectItemComponent,
        TextComponent,
        RadioComponent,
        CheckboxComponent,
        ChecklistComponent,
        ProgressBarComponent,
        SocialLinksComponent,
        TooltipComponent,
        NotificationComponent,
        DialogComponent,
        TablistComponent,
        TabRowComponent,
        ScreenReaderAnnouncementComponent,
        AccordionComponent,
        StepsComponent,
        AddressComponent,
        TakeOverModalComponent,
        PopupModalComponent,
        FormBoxComponent,
        UploaderComponent,
        LoaderComponent,
        ValidationErrorComponent,
        PasswordStrengthComponent,
        ValidationsComponent,
        StateDropdownDirective,
        ChartComponent,
        PiiComponent,
        DatePickerComponent,
        FieldsetListComponent,
        RadioFieldsetListItemComponent,
        ChecklistFieldsetListItemComponent,
        CheckboxFieldsetListItemComponent,
        BaseFieldsetListItemComponent,
        GainsComponent,
        TransactionFiltersComponent,
        ExpandableCardComponent,
        ExpandButtonComponent,
        FootnoteComponent,
        FootnoteLinkComponent, PreviewCheckComponent], imports: [CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        SumdayCommonModule,
        MatDatepickerModule,
        MatNativeDateModule], exports: [GridComponent,
        HeaderComponent,
        FooterComponent,
        SelectComponent,
        SelectListComponent,
        SelectItemComponent,
        TextComponent,
        RadioComponent,
        CheckboxComponent,
        ChecklistComponent,
        ProgressBarComponent,
        SocialLinksComponent,
        TooltipComponent,
        NotificationComponent,
        DialogComponent,
        TablistComponent,
        TabRowComponent,
        ScreenReaderAnnouncementComponent,
        AccordionComponent,
        StepsComponent,
        AddressComponent,
        TakeOverModalComponent,
        PopupModalComponent,
        FormBoxComponent,
        UploaderComponent,
        LoaderComponent,
        ValidationErrorComponent,
        PasswordStrengthComponent,
        ValidationsComponent,
        StateDropdownDirective,
        ChartComponent,
        PiiComponent,
        DatePickerComponent,
        FieldsetListComponent,
        RadioFieldsetListItemComponent,
        ChecklistFieldsetListItemComponent,
        CheckboxFieldsetListItemComponent,
        BaseFieldsetListItemComponent,
        GainsComponent,
        TransactionFiltersComponent,
        ExpandableCardComponent,
        ExpandButtonComponent,
        FootnoteComponent,
        FootnoteLinkComponent, PreviewCheckComponent] }); })();

/*
 * Public API Surface of components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionComponent, AddressComponent, BaseControlValueAccessor, BaseFieldsetListItemComponent, ChartComponent, CheckboxComponent, CheckboxFieldsetListItemComponent, ChecklistComponent, ChecklistFieldsetListItemComponent, DatePickerComponent, DialogComponent, ExpandButtonComponent, ExpandableCardComponent, FieldsetListComponent, FooterComponent, FootnoteComponent, FootnoteLinkComponent, FormBoxComponent, GainsComponent, GridComponent, HeaderComponent, LoaderComponent, LoaderType, ModalService, ModalType, NotificationComponent, PasswordStrengthComponent, PiiComponent, PopupModalComponent, PreviewCheckComponent, ProgressBarComponent, RadioComponent, RadioFieldsetListItemComponent, ScreenReaderAnnouncementComponent, SelectComponent, SelectItemComponent, SelectListComponent, SocialLinksComponent, StateDropdownDirective, StepsComponent, SumdayComponentModule, TabRowComponent, TablistComponent, TakeOverModalComponent, TextComponent, TooltipComponent, TransactionFiltersComponent, UploaderComponent, ValidationErrorComponent, ValidationsComponent };
